export const translations = {
  ar: {
    common_error_msg: {
      only_png_jpeg: "الملفات بصيغ PNG وJPEG هي فقط المسموح بها.",
      failed_to_approve_request: "فشلت الموافقة على الطلب",
      failed_to_reject_request: "فشلت المحاولة لرفض الطلب.",
      no_document_available: "لا يوجد ملف متوفر",
      failed_to_load_store: "فشل رفع بيانات المتجر",
      failed_to_delete_store: "فشل حذف المتجر",
      select_user_to_delete: "يرجى تحديد المستخدم لحذفه",
      delete_not_allowed: "لا تملك صلاحية الحذف في هذا القسم.",
      password_not_meet_requirements: "كلمة المرور غير مطابقة للشروط",
      wait_while_product_uploading: "يرجى الانتظار أثناء تحديث المنتج",
      select_merchant_to_delete: "يرجى تحديد تاجر لحذفه",
      failed_to_fetch_uploaded_files: "فشل التعرف على الملفات المُحمّلة",
      failed_to_delete_file: "فشل حذف الملف",
      select_store_to_delete_product: "حدد المتجر أولًا لحذف المنتج",
      rejected_request_deleted_successfully: "تم حذف الطلب المرفوض بنجاح",
      business_deleted_successfully: "تم حذف النشاط التجاري بنجاح",
      failed_to_delete_business: "فشل حذف النشاط التجاري",
      select_store_first: "حدد المتجر أولًا",
      failed_to_fetched_products_try_again:
        "فشل التعرف على المنتجات. حاول مرة أخرى",
      product_updated_successfully: "تم تحديث المنتج بنجاح",
      failed_to_fetch_approved_stores:
        "فشل التعرف على المتاجر المعتمدة. المحاولة قيد التنفيذ",
      store_deleted_successfully: "تم حذف المتجر بنجاح",
      request_deleted_successfully: "تم حذف الطلب بنجاح",
      invalid_user_id: "الهوية غير صالحة",
      user_deleted_successfully: "تم حذف المستخدم بنجاح",
      failed_to_delete_user: "فشل حذف المستخدم",
      failed_to_deletee_product: "فشل حذف المنتج.",
      please_upload_a_file: "يرجى تحميل ملف.",
      email_cannot_symbol: "لا يمكن أن يحتوي البريد الإلكتروني على رمز +",
      failed_to_fetch_comments: "فشل التعرف على التعليقات",
      failed_to_create_comments: "فشل إنشاء تعليق.",
      file_uploaded_being_processed:
        "تم تحميل ملفك بنجاح، وهو قيد المعالجة، انتظر بضع دقائق.",
      store_logo_invalid_image:
        "ملف الشعار ليس صورة صالحة. يُرجى تحميل صورة حقيقية بصيغة PNG أو JPEG.",
      store_submit_failed: "تعذّر إرسال الطلب. يُرجى المحاولة مرة أخرى.",
    },
    privacy_policy: {
      Privacy_policy: "سياسة الخصوصية",
      title: "سياسة الخصوصية وسرية المعلومات",
      welcome:
        'يرحّب بكم فريق عمل منصة زوري، ونفيدكم بأنه حرصاً منّا على حماية المستخدمين، فإن منصة زوري تسعى للحفاظ على المعلومات الخاصة بالتجار والممارسين والمستهلكين وفقاً لآلية سياسة الخصوصية وسرية المعلومات المعمول بها في منصة زوري . وعليه فإن منصة زوري تنوّه بأن هذه الوثيقة تحيطكم علماً بسياسة الخصوصية وسرية المعلومات المعمول بها في منصة زوري ، فقد أنشأت منصة زوري هذه السياسة "سياسة الخصوصية وسرية المعلومات" لتوضيح وتحديد آلية السرية والخصوصية المعمول بها في منصة زوري ، لذا يرجى الإطلاع عليها حيث باستخدامكم لمنصة زوري فإن جميع معلوماتكم تخضع لهذه السياسة.',
      definitions: {
        title: "التعريفات",
        platform_label: "منصة زوري",
        platform:
          "يشير هذا المصطلح إلى المنصة المملوكة لشركة زوري، ويشمل جميع الأشكال الرقمية لزوري على الإنترنت - سواء كتطبيق جوال أو كموقع إلكتروني.",

        merchant_label: "التاجر",
        merchant:
          "يشير هذا المصطلح إلى أي تاجر يسجل في منصة زوري لربط متجره الإلكتروني بها، سواء كان شخصاً طبيعياً أو اعتبارياً. ويشمل هذا جميع أشكال متجر التاجر، طالما يتم عرض منتجاتهم ضمن تصورات التصميم الداخلي في زوري لتمكين التوصيات بالمنتجات عبر المنصة. يشمل هذا التعريف موقع التاجر الإلكتروني و/أو تطبيق الهاتف المحمول الخاص به.",

        ecommerce_label: "المتجر الإلكتروني",
        ecommerce:
          "يشير هذا المصطلح إلى المتجر الإلكتروني الذي يستخدمه التاجر ضمن منصة زوري، بما في ذلك الموقع الإلكتروني وتطبيق الهاتف المحمول.",

        consumer_label: "المستهلك",
        consumer:
          "يشير هذا المصطلح إلى أي مستخدم نهائي يشتري خدمات مثل تصميم الغرف أو يستخدم ميزات التوصيات المدعومة بالذكاء الاصطناعي للمنتجات والتجار المقدمة من خلال منصة زوري.",

        user_label: "المستخدم",
        user: "يشير هذا المصطلح إلى أي فرد يستخدم منصة زوري، سواء كتاجر أو كمستهلك.",
      },

      information_collected: {
        title:
          "المعلومات التي تحصل عليها منصة زوري وتحتفظ بها في أنظمتها الإلكترونية:",
        items: [
          "المعلومات الشخصية الخاصة بالمستهلك: كالإسم، البريد الالكتروني، ورقم الجوال",
          'المعلومات الخاصة بالمتجر وكيانه القانوني: كرقم السجل التجاري وصورة من السجل التجاري، أو رقم وثيقة العمل الحر وصورة من الوثيقة وشهادة الحساب البنكي "الآيبان" ورابط المتجر',
          "معلومات الدخول الخاصة بالمتجر الالكتروني: كإسم المستخدم وكلمة السر والبريد الالكتروني، والسؤال الخاص باسترجاع كلمة المرور وإجابته والمظفين الذين يحتاجون الى حساب للمتجر",
          "تستخدم منصة زوري ملفات تعريف الارتباط (ملفات تعريف الارتباط) لتحسين تجربة المستخدم وتقديم خدمات مخصصة. في حال عدم توفير المستخدم للمعلومات المطلوبة منه فإن منصة زوري قدّ تحاول الحصول عليها عبر مصادر أخرى.",
          "معلومات المنتجات الخاصة بالمتاجر: منصة زوري على اطلاع دائم بزيارات المتاجر، وذلك لكون المتجر يستخدم بوابات توصية المنتجات الخاصة بهم من قبل منصة زوري. منصة زوري على اطلاع بنوع المنتجات المعروضة في المتجر.",
          "منصة زوري على إطلاع بأداء المتاجر وذلك في حال استدعت الحاجة إلى توجيه الدعم أو النصح والإرشاد للمتاجر لمساعدتهم وتحسين أدائهم.",
          "معلومات مستهلكي المتاجر أو عملاء التجار: حيث إن منصة زوري تسعى إلى تحسين تجربة المتاجر، وتحسين جودة أعمالهم، فإنها تطلع باستمرار على عدد مستهلكين المتاجر وعمليات الزيارات.",
        ],
      },
      information_sharing: {
        title: "مشاركة المعلومات:",
        content: [
          "بطبيعة الحال فإن منصة زوري تسعى بالاحتفاظ بهذه المعلومات بما يحفظ خصوصية المستخدم، ومنصة زوري لا تحتفظ بهذه المعلومات إلا بهدف تحسين جودة المنصة وجودة عمل المتاجر وتسهيلاً وتيسيراً للخدمات.",
          "كقاعدة عامة فإن جميع هذه المعلومات لا يطلع عليها إلا بعض القائمين على تطوير تقنيات منصة زوري وذلك بعد حصولهم على تصريح للاطلاع عليها من قِبل إدارة منصة زوري عادة ما يكون التصريح محدد ومقيّد ويخضع لرقابة من قِبل منصة زوري.",
          "حيث أن منصة زوري تسعى للحفاظ على بيئة آمنة لممارسة التجارة الإلكترونية، لذا فإنه في حال ملاحظة منصة زوري لأي نشاط غير نظامي أو غير شرعي يقوم به المستخدم فإن منصة زوري تطبيقاً لمواد وبنود وأحكام اتفاقية الاستخدام وسياسة الخصوصية وسرية المعلومات، فإنها قد تشارك أيٍ من هذه المعلومات مع الجهات المختصة لاتخاذ اللازم حيال المستخدم المخالف، وذلك التزاماً من منصة زوري بضوابط وأحكام الأنظمة السارية في المملكة العربية السعودية، ومنها على سبيل المثال لا الحصر نظام التجارة الإلكترونية ونظام حماية البيانات الشخصية ونظام الجرائم المعلوماتية.",
          "تنوه منصة زوري بأنه ينتج عن الممارسات غير النظامية لأي من المستخدمين مشاركة بياناتهم مع الجهات الرسمية او بعض الجهات الخاصة مثل: البنوك.",
          "يعلم المستخدم ويوافق على أن منصة زوري قد تستخدم المعلومات التي زوده بها، لإرسال الرسائل التسويقية.",
        ],
      },
      data_confidentiality: {
        title: "ما هو مدى أمان سرية المعلومات الخاصة بالمستخدمين:",
        content: [
          "تسعى منصة زوري إلى الحفاظ على سرية معلومات مستخدمين المنصة، ولكن نظراً لعدم إمكانية ضمان ذلك 100% في (فضاء الإنترنت) فإن فريق عمل منصة زوري ، ينوّه على يلي:",
          "تسعى منصة زوري إلى الحفاظ على جميع المعلومات الخاصة بالمستخدمين وألا يطلع عليها أي شخص بما يخالف السياسة المعمول بها في منصة زوري.",
          "عمل منصة زوري على حماية معلومات المستخدمين بموجب أنظمة حماية إلكترونية وتقنية ذات جودة عالية وتُحدّث بشكل مستمر ودوري.",
          "غير أنه نظراً لأن شبكة الانترنت لا يمكن ضمانها 100% لما قد يطرأ من اختراق أو فيروسات على أنظمة الحماية الالكترونية وعلى جدران الحماية المعمول بها في منصة زوري فإن منصة زوري تنصح المستخدمين بالحفاظ على معلوماتهم بسرية تامة، وعدم إفشاء أي معلومات يراها المستخدم هامة جداً له، وهذا حرصاً من منصة زوري على حماية وتوجيه وإرشاد المستخدمين.",
          "تسعى منصة زوري بحماية البيانات الشخصية لمستخدميها وفقًا لأعلى المعايير، وفي حال حدوث أي خرق أمني يؤدي إلى الوصول غير المصرح به أو التلاعب بالبيانات الشخصية، تلتزم المنصة بإبلاغ الجهات المختصة فوراً، وكذلك إخطار المستخدمين المتأثرين بتفاصيل الخرق، كما ستقوم المنصة باتخاذ جميع التدابير اللازمة لمعالجة الخرق.",
        ],
      },
      information_usage: {
        title: "كيفية استخدامنا لمعلوماتك",
        content: "نقوم باستخدام المعلومات التي نجمعها من أجل:",
        items: [
          "تقديم خدماتنا وصيانتها.",
          "معالجة المعاملات وإرسال المعلومات المتعلقة بها.",
          "التواصل معك، بما في ذلك إرسال التحديثات والعروض الترويجية.",
          "تحسين موقعنا الإلكتروني وخدماتنا.",
          "ضمان الأمان ومنع الاحتيال.",
        ],
      },
      cookies: {
        title:
          "المعلومات التي نجمعها تلقائيًا باستخدام ملفات تعريف الارتباط (ملفات تعريف الارتباط)",
        content: [
          "أثناء تنقلك وتفاعلك مع خدماتنا، قد نستخدم تقنيات جمع البيانات التلقائية لجمع بعض المعلومات حول جهازك وأنماط تصفحك واستخدامك، بما في ذلك:",
          "تفاصيل زياراتك إلى خدماتنا، بما في ذلك الموارد التي تصل إليها وتستخدمها على الموقع.",
        ],
        usage: [
          "المعلومات التي نجمعها تلقائيًا هي بيانات إحصائية، وتساعدنا في تحسين خدماتنا وتقديم مزايا أكثر تخصيصًا لك، من خلال تمكيننا من:",
          "تقدير حجم جمهورنا وأنماط الاستخدام.",
          "تخزين معلومات حول تفضيلاتك، مما يسمح لنا بتخصيص خدماتنا وفقًا لاهتماماتك الفردية.",
          "تسريع عمليات البحث الخاصة بك.",
          "إدارة المسابقات أو العروض الترويجية أو الاستبيانات أو أي ميزة أخرى على موقعنا.",
          "التعرف عليك عند عودتك إلى خدماتنا.",
        ],
      },
      user_rights: {
        title: "حقوق المستخدمين فيما يتعلق بالبيانات الشخصية:",
        content:
          "تحرص منصة زوري على حماية خصوصية مستخدميها وتوفير آليات واضحة لممارسة حقوقهم المتعلقة بالبيانات الشخصية، ومن ذلك ممارسة الحقوق التالية:",
        items: [
          "الحق في الوصول: يحق للمستخدم الاطلاع على البيانات الشخصية المخزنة لديه من قبل منصة زوري وتحديثها او تعديلها عندما يتطلب الامر",
          "الحق في الحصول على نسخة: يمكن للمستخدم الحصول على نسخة من بياناته الشخصية التي تم جمعها ومعالجتها من قبل منصة زوري.",
          "الحق في التصحيح: يحق للمستخدم تعديل أو تحديث بياناته الشخصية لضمان دقتها واكتمالها.",
          "الحق في الإتلاف: يحق للمستخدم طلب حذف أو إتلاف بياناته الشخصية إذا لم تعد هناك حاجة لمعالجتها.",
          "الحق في الرجوع عن الموافقة: يحق للمستخدم سحب موافقته على معالجة بياناته الشخصية في أي وقت.",
        ],
      },
      third_party_links: {
        title: "روابط الجهات الخارجية",
        content: [
          'يحتوي موقعنا على روابط لمواقع إلكترونية تابعة لجهات خارجية مثل "منصات التجارة الإلكترونية" والتي تحتوي على المنتجات المتوفره في توصيات المنتج',
          "منصة زوري غير مسؤولة عن ممارسات الخصوصية الخاصة بهذه المواقع، بما في ذلك إذا قمت بشراء منتجات من خلالها. كما أننا غير مسؤولين عن أي صفقة بيع تُستكمل عبر موقع إلكتروني تابع لطرف ثالث.",
          'وإن هذه القواعد هي "سياسة الخصوصية وسرية المعلومات"، وقد وضعت لضمان المصداقية والثقة التي تحرص منصة زوري على توفيرها لكافة المستخدمين.',
          "لمزيد من التفاصيل عن معالجة بياناتك الشخصية، وكيفية ممارسة حقوقك، يمكنك التواصل مع قسم حماية البيانات الشخصية في شركة منصة زوري للاتصالات و تقنية المعلومات حسب بيانات التواصل الموضحة أدناه: support@zory.ai",
        ],
      },
    },
    chatbot: {
      ask_us_anything: "اسألنا عن أي شيء، أو شاركنا ملاحظاتك.",
      connection_lost: "حاول إعادة الاتصال. تم فقد الاتصال",
      connecting_to_support: "جارٍ الاتصال بالدعم...",
      message_placeholder: "رسالة...",
    },
    navbar: {
      logout: "تسجيل الخروج",
      watch_tutorial: "شروحات الموقع",
      good_bye: "الى اللقاء",
    },
    common_table_comp: {
      actions: "الإجراءات",
      image_url_copied_clipboard: "تم نسخ رابط الصورة إلى الحافظة",
      from_sales_request: "طلب مبيعات",
    },
    loginPage: {
      vendor_portal: "بوابة البائع",
      email: "البريد الإلكتروني",
      email_placeholder: "أدخل البريد الإلكتروني",
      email_error_1: "البريد الإلكتروني مطلوب",
      email_error_2: "الرجاء إدخال بريد إلكتروني صالح",
      password_placeholder: "كلمة المرور",
      forget_password: "?نسيت كلمة المرور",
      login: "تسجيل الدخول",
      privacy_policy_content_1: "بالمتابعة، فإنك تؤكد أنك قرأت ووافقت على",
      privacy_policy_content_2: "سياسة الخصوصية الخاصة بنا",
      agree_prefix: "أوافق على",
      terms_of_service: "شروط الخدمة",
      and: "و",
      privacy_policy_link: "سياسة الخصوصية",
      agree_error: "يجب الموافقة على شروط الخدمة وسياسة الخصوصية",
      no_merchant_access: "لم يتم العثور على حساب نشط",
      invalid_credentials:
        "لم يتم العثور على حساب نشط ببيانات الاعتماد المُدخلة",
    },
    signup: {
      buttonText: "اشتراك",
      createAccount: "أنشئ حسابك",
      enterDetails: "الرجاء إدخال التفاصيل الخاصة بك للبدء.",
      fullName: "الاسم الكامل",
      email: "البريد الإلكتروني",
      phone: "رقم الهاتف",
      phoneNumberPlaceholder: "أدخل رقم هاتفك",
      phoneNumberMessage: "رقم الهاتف مطلوب",
      storeName: "المتجر/اسم النشاط التجاري",
      password: "كلمة المرور",
      storeNamePlaceholder: "أدخل اسم المتجر الخاص بك",
      storeNameMessage: "Store/Business Name is required",
      passwordPlaceholder: "أدخل كلمة المرور الخاصة بك",
      passwordRequirements: {
        length: "يجب أن تتراوح كلمة المرور بين 6 و 20 حرفًا",
        complexity:
          "يجب أن تحتوي على حرف كبير وحرف صغير وحرف خاص ورقم واحد على الأقل",
      },
      phone_number_error_2: "مسموح فقط بالأرقام وعلامة +",
      next: "التالي",
      submit: "إرسال",
      alreadyHaveAccount: "هل لديك حساب بالفعل؟",
      login: "تسجيل الدخول",
      back: "رجوع",
      vendorPortal: "بوابة البائع",
      invalid_link: "رابط التسجيل هذا لم يعد صالحًا",
      signup: "تسجيل الدخول.",
      industry: "القطاع",
      industryPlaceholder: "اختر القطاع",
      industryRequired: "القطاع مطلوب",
      industrySpecify: "حدد القطاع",
      ecommercePlatform: "منصة التجارة الإلكترونية",
      ecommercePlatformPlaceholder: "اختر المنصة",
      ecommercePlatformRequired: "منصة التجارة الإلكترونية مطلوبة",
      platformSpecify: "حدد المنصة",
      country: "الدولة",
      countryPlaceholder: "أدخل الدولة",
      countryRequired: "الدولة مطلوب",
      city: "المدينة",
      cityPlaceholder: "أدخل المدينة",
      cityRequired: "المدينة مطلوبة",
      pleaseSpecify: "يرجى التحديد",
      termsAndConditions: "أوافق على",
      termsLink: "الشروط والأحكام",
      termsRequired: "يجب الموافقة على الشروط والأحكام للمتابعة",
    },

    forget_passwordPage: {
      forget_password: "?نسيت كلمة المرور",
      forgort_password_description:
        "أدخل عنوان بريدك الإلكتروني المسجل لتلقي تعليمات إعادة تعيين كلمة المرور.",
      success_msg:
        "لقد تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني",

      send_reset_inxtruction: "إرسال تعليمات إعادة التعيين",
    },
    reset_password: {
      reset_password_title: "إعادة تعيين كلمة المرور",
      reset_password_description:
        "أدخل كلمة المرور الجديدة لإعادة تعيين كلمة المرور الخاصة بك.",
      password: "كلمة المرور",
      password_error: " كلمة المرور مطلوبة",
      confirm_password: "تأكيد كلمة المرور",
      validation_0: "يجب أن تكون كلمة المرور من 8 إلى 20 حرفًا",
      validation_1: "مطلوب حرف كبير واحد على الأقل، وحرف صغير، وحرف خاص، ورقم",
      validation_2: "يجب أن تكون كلمة المرور مكونة من 8 أحرف على الأقل",
      passwordMatch: "كلمات المرور غير متطابقة!",
      requirement_not_match_msg: "كلمة المرور لا تستوفي المتطلبات",
      confirm_password_error: "تأكيد كلمة المرور",
      reset: "إعادة تعيين",
    },

    platformOptions: {
      ZID: "زد",
      SALLA: "سله",
      MAGENTO: "ماجنتو",
      SHOPIFY: "شوبيفاي",
      Other: "اخرى",
    },
    PostHog: {
      title: "تحليلات المنصة",
      subtitle:
        "مؤشرات أداء المنتج محدثة لحظيًا من PostHog، بما يشمل الزيارات، وسلوك المستخدمين، ومصادر الزيارات، وتدفق الصفحات.",
      dau: "المستخدمون النشطون يوميًا",
      dauSub: "عدد الزوار الفريدين للصفحة يوميًا",
      wau: "المستخدمون النشطون أسبوعيًا",
      wauSub: "عدد الزوار الفريدين للصفحة خلال الأسبوع",
      events: "أبرز التفاعلات",
      eventsSub: "أكثر التفاعلات خلال الفترة المحددة",
      referrers: "مصادر الزيارات",
      referrersSub: "مصادر مشاهدات الصفحة",
      topPages: "أهم الصفحات",
      topPagesSub: "الصفحات الأكثر مشاهدة خلال الفترة",
      countries: "أهم الدول",
      countriesSub: "مواقع المستخدمون",
      browsers: "المتصفحات",
      browsersSub: "المتصفح الذي يستخدمه الزوار",
      devices: "أنواع الأجهزة",
      devicesSub: "أجهزة سطح المكتب مقابل الهواتف المحمولة مقابل الأجهزة اللوحية",
      deviceDesktop: "أجهزة سطح المكتب",
      deviceMobile: "الهواتف المحمولة",
      deviceTablet: "الأجهزة اللوحية",
      funnel: "الصفحات لكل المستخدم",
      funnelSub: "عدد الصفحات التي يشاهدها المستخدمون في الجلسة الواحدة",
      kpiVisitors: "المستخدمون الفريدون",
      kpiPageviews: "مشاهدات الصفحات",
      kpiEvents: "إجمالي الأحداث",
      kpiSessions: "الجلسات",
      kpiAvgSession: "متوسط الجلسة",
      kpiBounce: "معدل الترك",
      kpiPagesPerSession: "الصفحات لكل جلسة",
      kpiMobile: "نسبة الزيارات من الأجهزة المحمولة",
      convTitle: "معدلات التحويل",
      convSignin: "معدل تسجيل الدخول",
      convSigninSub: "عدد عمليات تسجيل الدخول مقابل عدد المستخدمين",
      convSub: "معدل الاشتراك",
      convSubSub: "عدد المشتركين مقابل عدد عمليات تسجيل الدخول",
      convReturn: "معدل العودة",
      convReturnSub: "عدد المستخدمين العائدين مقابل عدد عمليات تسجيل الدخول",
      funnelByBrowser: "مسار مشاهدة الصفحات، حسب المتصفح",
      funnelByBrowserSub:
        "عدد المستخدمين الذين أكملوا ١ ← ٢ ← ٣ مشاهدات للصفحات، مصنفة حسب المتصفح.",
      funnelStep1: "عرض الصفحة الأولى",
      funnelStep2: "عرض الصفحة الثانية",
      funnelStep3: "عرض الصفحة الثالثة",
      funnelPersons: "أشخاص",
      funnelCompleted: "أكملوا الخطوة",
      funnelDropped: "غادروا",
      funnelAvgTime: "متوسط الوقت",
      newReturning: "المستخدمون الجدد مقابل العائدين",
      newReturningSub: "المستخدمون النشطون الجدد والعائدون يوميًا",
      newUsers: "جدد",
      returningUsers: "عائدون",
      os: "أنظمة التشغيل",
      osSub: "أنظمة التشغيل التي يستخدمها المستخدمون",
      entryPages: "صفحات الهبوط",
      entryPagesSub: "من أين تبدأ جلسات الزوار",
      activity: "النشاط",
      activitySub: "استكشف الأحداث أو شاهد النشاط في الوقت الفعلي من تطبيقك",
      actEvent: "الحدث",
      actPerson: "المستخدم",
      actUrl: "الرابط / الشاشة",
      actLibrary: "المكتبة",
      actTime: "الوقت",
      actEntry: "صفحة الدخول",
      actPages: "الصفحات",
      actDuration: "المدة",
      tabEvents: "الأحداث",
      tabSessions: "الجلسات",
      tabLive: "مباشر",
      lastHour: "الساعة الماضية",
      viewMore: "عرض المزيد",
      showingLatest: "عرض آخر {n} سجلات",
      last7: "آخر 7 أيام",
      last14: "آخر 14 يومًا",
      last30: "آخر 30 يومًا",
      last90: "آخر 90 يومًا",
      custom: "نطاق مخصص",
    },
    chatbotCheckerPage: {
      page_title: "مدقق دردشة المساعد الذكي",
      page_subtitle:
        "راقب أداء المساعد الذكي من خلال مراجعة المحادثات الحقيقية وتحليل جودة استجاباته.",
      refresh: "تحديث",
      stat_total_conversations: "إجمالي المحادثات",
      stat_total_messages: "إجمالي الرسائل",
      stat_positive_rate: "نسبة الجودة الإيجابية",
      stat_flagged: "ردود مُعلَّمة",
      search_placeholder: "ابحث برقم المحادثة أو الاسم أو البريد أو الرسالة",
      col_chat_id: "رقم المحادثة",
      filter_all: "كل التقييمات",
      rating_good: "جيد",
      rating_bad: "سيئ",
      rating_unrated: "غير مُقيَّم",
      col_user: "المستخدم",
      col_first_message: "الرسالة الاولى",
      col_messages: "الرسالة",
      col_quality: "الجودة",
      col_started: "بدأ",
      col_actions: "إجراءات",
      anonymous: "زائر مجهول",
      sender_bot:"المساعد الذكي",
      sender_user: "المستخدم",
      rate_quality: "قيّم جودة هذه المحادثة:",
      quality_saved: "تم حفظ التقييم",
      quality_save_failed: "تعذّر حفظ التقييم",
      delete_confirm_title: "هل تريد حذف هذه المحادثة؟",
      delete_confirm_body: "سيؤدي هذا إلى حذف الجلسة وكل رسائلها نهائياً. لا يمكن التراجع عن هذا الإجراء.",
      delete_confirm_ok: "حذف",
      delete_confirm_cancel: "إلغاء",
      delete_success: "تم حذف المحادثة",
      delete_failed: "تعذّر حذف المحادثة",
      error_overview: "تعذّر تحميل الإحصائيات",
      error_conversations: "تعذّر تحميل المحادثات",
      error_detail: "تعذّر تحميل تفاصيل المحادثة",
    },
    Sidebar: {
      Dashboard: "لوحة التحكم",
      PostHog: "تحليلات PostHog",
      "Zory Analytics": "تحليلات زوري",
      Merchants: "التجار",
      Stores: "المتاجر",
      Products: "المنتجات",
      "Merchant Users": "مستخدمو التجار",
      Users: "مستخدمو الذكاء الاصطناعي",
      Campaigns: "الحملات",
      Discounts: "الخصومات",
      "Plan and Pricing": "الباقات والأسعار",
      "Plan Usage": "استخدام الباقات",
      Referrals: "الإحالات",
      Announcements: "الإعلانات",
      Library: "المكتبة",
      Settings: "الإعدادات",
      Categories: "الفئات",
      Contacts: "جهات الاتصال",
      "Sales Requests": "طلبات المبيعات",
      "Policies & Privacy": "السياسات والخصوصية",
      "Chatbot Checker": "مدقق دردشة المساعد الذكية",
      "Admin roles": "أدوار المسؤول",
      "Organization team": "فريق المؤسسة",
      "Organization generations": "إنشاءات الفريق",
    },
    sitePoliciesPage: {
      title: "السياسات والخصوصية",
      subtitle: "حرّر سياسة الخصوصية والشروط والأحكام بالعربية والإنجليزية. تظهر التغييرات على الموقع فور الحفظ.",
      privacy_policy: "سياسة الخصوصية",
      terms_and_conditions: "الشروط والأحكام",
      // Subtitle lines rendered under the heading, mirroring the public site.
      // One entry per line; a policy with no entry simply shows no subtitle.
      terms_and_conditions_subtitle: [
        "الشروط والأحكام – مستخدمو المنصّة",
        "الشروط والأحكام (النسخة العربية – المُعتمَدة)",
      ],
      status_live: "منشورة",
      status_partial: "مكتملة جزئياً",
      status_empty: "غير مُعدّة",
      tab_en: "English",
      tab_ar: "العربية",
      lang_empty: "فارغ",
      content_label: "المحتوى",
      content_placeholder_en: "Start writing the page content…",
      content_placeholder_ar: "ابدأ بكتابة محتوى الصفحة…",
      lang_missing_en: "لا يوجد محتوى إنجليزي بعد. سيستمر الموقع في عرض النص الافتراضي بهذه اللغة حتى تضيفه.",
      lang_missing_ar: "لا يوجد محتوى عربي بعد. سيستمر الموقع في عرض النص الافتراضي بهذه اللغة حتى تضيفه.",
      save: "حفظ التغييرات",
      discard: "تجاهل",
      saving: "جارٍ الحفظ...",
      save_success: "تم حفظ الصفحة",
      save_error: "تعذّر حفظ الصفحة",
      no_changes: "لا توجد تغييرات للحفظ",
      error_fetching: "تعذّر تحميل الصفحات",
      last_updated: "آخر تحديث",
      never_saved: "لم يتم الحفظ بعد",
      unsaved_changes: "تغييرات غير محفوظة",
      read_only: "لديك صلاحية العرض فقط لهذه الصفحة.",
      editor_visual: "تحرير",
      editor_preview: "معاينة",
      editor_html: "HTML",
      words: "كلمة",
      preview_empty: "لا يوجد محتوى للمعاينة.",
      retry: "إعادة المحاولة",
    },
    schedulingTab: {
      meetings_tab: "الاجتماعات",
      availability_tab: "الأوقات المتاحة",
      meetings_title: "الاجتماعات",
      meetings_subtitle: "الأوقات معروضة بتوقيت المنظّم.",
      meetings_empty: "لا توجد اجتماعات بعد",
      schedule_meeting: "تحديد اجتماع",
      booking_paused_hint: "الحجز متوقف أو التقويم غير متصل.",
      scope_upcoming: "القادمة",
      scope_past: "السابقة",
      scope_all: "الكل",
      status_all: "كل الحالات",
      status_confirmed: "مؤكد",
      status_pending: "جاري الحجز",
      status_needs_review: "يحتاج مراجعة",
      status_cancellation_pending: "الإلغاء قيد التأكيد",
      status_cancelled: "ملغي",
      status_failed: "فشل",
      status_completed: "منتهٍ",
      table_attendee: "الحاضر",
      table_email: "البريد الإلكتروني",
      table_when: "التاريخ والوقت",
      table_timezone: "المنطقة الزمنية",
      table_status: "الحالة",
      table_source: "المصدر",
      table_actions: "الإجراءات",
      source_website: "الموقع",
      source_admin: "المسؤول",
      view: "عرض",
      cancel: "إلغاء",
      check_status: "تحقق من الحالة",
      checking: "جارٍ التحقق...",
      meet_issue: "مشكلة في رابط الاجتماع",
      meet_pending: "جارٍ تجهيز الرابط",
      meet_failed: "لا يوجد رابط — شارك تفاصيل الانضمام مع الحاضر",
      date_start: "من",
      date_end: "إلى",
      detail_title: "تفاصيل الاجتماع",
      detail_attendee: "الحاضر",
      detail_email: "البريد الإلكتروني",
      detail_message: "الرسالة",
      detail_attendee_timezone: "المنطقة الزمنية للحاضر",
      detail_organizer_time: "توقيت المنظّم",
      detail_source: "المصدر",
      detail_booked_at: "تاريخ الحجز",
      detail_status: "الحالة",
      detail_meet: "رابط الانضمام",
      detail_calendar: "التقويم",
      open_in_calendar: "فتح في تقويم جوجل",
      cancel_meeting: "إلغاء الاجتماع",
      cancel_confirm_title: "إلغاء هذا الاجتماع؟",
      cancel_confirm_body: "سيقوم تقويم جوجل بإشعار الحاضر.",
      cancel_slot_note: "يبقى الوقت غير منشور بعد الإلغاء. يمكنك نشره لاحقاً ليصبح قابلاً للحجز.",
      keep_meeting: "الإبقاء على الاجتماع",
      cancelling: "جارٍ الإلغاء...",
      cancel_success: "تم إلغاء الاجتماع",
      book_title: "تحديد اجتماع",
      book_subtitle: "30 دقيقة · Google Meet",
      book_success: "تم تحديد الاجتماع",
      choose_date: "التاريخ",
      choose_time: "الوقت",
      attendee_name: "اسم الحاضر",
      attendee_email: "بريد الحاضر",
      attendee_message: "رسالة",
      confirm_meeting: "تأكيد الاجتماع",
      confirming: "جارٍ التأكيد...",
      no_slots: "لا توجد أوقات منشورة متاحة.",
      admin_booking_note: "يمكن اختيار الأوقات المنشورة والمتاحة فقط. لا يمكن تجاوز تعارضات التقويم من هنا.",
      booking_pending_title: "ما زلنا نؤكد هذا الحجز",
      booking_pending_body: "لا تنشئ حجزاً آخر الآن.",
      setup_title: "إعداد الحجز",
      setup_subtitle: "تقويم واحد لزوري ينظّم كل الاجتماعات المحجوزة من الموقع أو من هنا.",
      bookings_enabled: "الحجز مُفعّل",
      bookings_paused: "الحجز متوقف",
      connect: "ربط تقويم جوجل",
      reconnect: "إعادة الاتصال",
      connection_ok: "الاتصال سليم",
      connection_reconnect: "يلزم إعادة الاتصال",
      not_connected: "غير متصل",
      no_organizer: "لا يوجد حساب منظّم",
      calendar: "التقويم",
      not_connected_title: "لا يوجد تقويم متصل",
      not_connected_body: "حدد المنطقة الزمنية للمنظّم واربط حساب جوجل لديه صلاحية إنشاء الأحداث واجتماعات Google Meet. لا يمكن نشر الأوقات قبل ذلك.",
      reconnect_title: "فُقد الوصول إلى تقويم جوجل",
      reconnect_body: "أعد الاتصال لقبول حجوزات جديدة. الاجتماعات الحالية وأحداثها في جوجل لم تتغير — لم يتم إلغاء أي شيء.",
      reconnect_note: "يجب أن تتم إعادة الاتصال بنفس الحساب — لا يتم تبديل التقويم تلقائياً.",
      contact_email: "بريد التواصل المعروض في صفحة «اتصل بنا»",
      contact_email_hint: "يظهر للزوار. تُرسل الدعوة من حساب المنظّم المتصل.",
      organizer_timezone: "المنطقة الزمنية للمنظّم",
      select_timezone: "اختر منطقة زمنية",
      timezone_hint: "يؤثر هذا على الإدخال والعرض فقط. الأوقات والاجتماعات الحالية تبقى كما هي.",
      duration: "مدة الاجتماع",
      duration_hint: "ثابتة في هذا الإصدار.",
      minutes: "دقيقة",
      horizon: "مدى الحجز",
      days: "يوم",
      unsaved: "تغييرات غير محفوظة",
      discard: "تجاهل",
      discard_title: "تجاهل التغييرات؟",
      discard_ok: "تجاهل",
      keep_editing: "متابعة التحرير",
      save_changes: "حفظ التغييرات",
      saving: "جارٍ الحفظ...",
      settings_saved: "تم حفظ الإعدادات",
      slots_title: "الأوقات المنشورة",
      slots_subtitle: "تُقرأ حالة الانشغال من التقويم عند كل تحميل لهذه القائمة ولا يتم تخزينها.",
      slots_calendar_unavailable: "تعذر التحقق من حالة الانشغال الآن، لذا لا تُعرض الأوقات على الزوار.",
      slots_empty: "لم يتم نشر أي أوقات بعد.",
      refresh: "تحديث",
      add_slot: "إضافة وقت",
      add_slot_title: "إضافة وقت قابل للحجز",
      slot_date: "التاريخ",
      slot_time: "الوقت",
      slot_start: "وقت البداية",
      slot_ends: "ينتهي",
      slot_ends_hint: "يُحتسب من المدة الثابتة.",
      slot_timezone: "المنطقة الزمنية",
      slot_status: "الحالة",
      slot_entry_note: "يُدخل بتوقيت المنظّم",
      save_before_publishing: "احفظ الإعدادات قبل نشر الأوقات — تُستخدم المنطقة الزمنية المحفوظة للمنظّم.",
      publish_slot: "نشر الوقت",
      publishing: "جارٍ النشر...",
      slot_published: "تم نشر الوقت",
      unpublish: "إلغاء النشر",
      republish: "إعادة النشر",
      slot_available: "متاح",
      slot_busy: "مشغول في التقويم",
      slot_booked: "محجوز",
      slot_in_progress: "جاري الحجز",
      slot_unpublished: "غير منشور",
      slot_past: "منتهٍ",
      slot_unknown: "الحالة غير متاحة",
      connected_success: "تم ربط تقويم جوجل",
      error_generic: "تعذر إكمال العملية. حاول مرة أخرى.",
      error_validation: "راجع الحقول المحددة.",
      error_invalid_timezone: "المنطقة الزمنية غير مدعومة.",
      error_slot_unavailable: "لم يعد هذا الوقت متاحاً.",
      error_slot_expired: "انقضى هذا الوقت.",
      error_slot_changed: "تغيّر هذا الوقت. راجعه ثم حاول مرة أخرى.",
      error_slot_overlap: "يتداخل هذا الوقت مع وقت منشور.",
      error_slot_busy: "التقويم مشغول خلال هذا الوقت.",
      error_slot_in_use: "هذا الوقت محجوز ولا يمكن تغييره.",
      error_settings_changed: "تم تغيير هذه الإعدادات من مكان آخر. راجعها ثم حاول مرة أخرى.",
      error_request_conflict: "تم إرسال هذا الطلب سابقاً ببيانات مختلفة.",
      error_booking_pending: "ما زلنا نؤكد هذا الحجز.",
      error_booking_failed: "تعذر تحديد الاجتماع.",
      error_booking_cancelled: "تم إلغاء هذا الحجز.",
      error_calendar_unavailable: "التقويم غير متاح الآن.",
      error_calendar_reconnect: "يحتاج اتصال التقويم إلى إعادة ربط.",
      error_calendar_mismatch: "هذا حساب أو تقويم مختلف.",
      error_cancellation_pending: "ما زال الإلغاء قيد التأكيد.",
      error_cancellation_failed: "لم يكتمل الإلغاء.",
      error_rate_limited: "محاولات كثيرة. انتظر قليلاً ثم حاول مرة أخرى.",
      error_not_configured: "أكمل إعداد التقويم أولاً.",
      error_slot_not_found: "لم نجد هذا الوقت.",
      error_oauth_scope: "صلاحيات جوجل الممنوحة غير كافية. ابدأ من جديد.",
      error_booking_unavailable: "الحجز غير متاح في هذا المتصفح.",
      error_scheduling_disabled: "الحجز غير متاح الآن.",
      error_load_meetings: "تعذر تحميل الاجتماعات.",
      error_load_slots: "تعذر تحميل الأوقات.",
      error_save_settings: "تعذر حفظ الإعدادات.",
      error_publish_slot: "تعذر نشر الوقت.",
      error_connect: "تعذر ربط تقويم جوجل.",
      error_load_settings: "تعذر تحميل الإعدادات.",
      refresh_connection: "تحديث حالة الاتصال",
      refreshing: "جارٍ التحديث…",
      connection_refreshed: "تم تحديث حالة الاتصال",
      setup_tab_blocked: "اسمح بالنوافذ المنبثقة لهذا الموقع ثم اختر ربط تقويم جوجل مرة أخرى.",
      setup_tab_note: "يفتح الإعداد في تبويب جديد. أكمله هناك ثم أغلقه وحدّث حالة الاتصال هنا.",
      error_name_required: "أدخل اسم الحاضر",
      error_email_required: "أدخل البريد الإلكتروني",
      error_email_invalid: "أدخل بريداً إلكترونياً صالحاً",
      error_slot_required: "اختر وقتاً",
      error_date_required: "اختر تاريخاً",
      error_time_required: "اختر وقت البداية",
    },
    salesRequestsPage: {
      title: "طلبات المبيعات",
      search_placeholder: "ابحث بالاسم أو النشاط أو البريد أو الهاتف",
      date_start: "من",
      date_end: "إلى",
      export: "تصدير",
      exporting: "جارٍ التصدير...",
      export_success: "تم تنزيل الملف",
      export_error: "خطأ في تصدير طلبات المبيعات",
      empty: "لا توجد طلبات مبيعات بعد",
      error_fetching: "خطأ في جلب طلبات المبيعات",
      table: {
        name: "الاسم",
        business_name: "النشاط التجاري",
        email: "البريد الإلكتروني",
        phone_number: "رقم الهاتف",
        furniture_type: "نوع الأثاث",
        submitted_at: "تاريخ الإرسال",
        actions: "الإجراءات",
      },
      view: "عرض",
      detail_title: "تفاصيل طلب المبيعات",
      detail: {
        name: "الاسم",
        business_name: "النشاط التجاري",
        email: "البريد الإلكتروني",
        phone_number: "رقم الهاتف",
        furniture_type: "نوع الأثاث",
        business_type: "نوع النشاط",
        message: "الرسالة",
        submitted_at: "تاريخ الإرسال",
        updated_at: "آخر تحديث",
      },
      close: "إغلاق",
      delete: "حذف",
      delete_confirm_title: "هل تريد حذف هذا الطلب؟",
      delete_confirm_body:
        "سيؤدي هذا إلى حذف طلب المبيعات وجميع بياناته نهائيًا. لا يمكن التراجع عن هذا الإجراء.",
      delete_confirm_ok: "حذف",
      delete_confirm_cancel: "إلغاء",
      delete_success: "تم حذف الطلب",
      delete_failed: "خطأ في حذف الطلب",
      move_to_merchant: "نقل إلى طلبات التجار",
      move_confirm_title: "نقل الطلب إلى طلبات التجار؟",
      move_confirm_body:
        "سينتقل هذا الطلب إلى قائمة التجار قيد الانتظار، حيث يمكنك قبوله أو رفضه.",
      move_confirm_ok: "نقل",
      move_confirm_cancel: "إلغاء",
      move_success: "تم النقل إلى طلبات التجار",
      move_failed: "خطأ في نقل الطلب",
      move_duplicate_email:
        "يوجد بالفعل طلب بنفس البريد الإلكتروني، يرجى استخدام بريد آخر.",
    },
    allUsersPage: {
      btn_create_user: "إضافة",
      modal_title: "إنشاء حساب لوحة التحكم",
      modal_subtitle: "أنشئ حسابًا جديدًا وحدد الباقة المناسبة له",
      name_english: "الاسم (بالإنجليزية)",
      name_english_placeholder: "أدخل الاسم الكامل بالإنجليزية",
      name_arabic: "الاسم (بالعربية)",
      name_arabic_placeholder: "أدخل الاسم الكامل بالعربية",
      email: "البريد الإلكتروني",
      email_placeholder: "أدخل البريد الإلكتروني",
      password: "كلمة المرور",
      password_placeholder: "أدخل كلمة المرور",
      plan: "الباقة",
      plan_placeholder: "اختر باقة",
      expiry: "تنتهي صلاحية الوصول إلى الحساب",
      expiry_placeholder: "اختر التاريخ",
      cancel: "إلغاء",
      submit: "إضافة مستخدم",
      validation_name_required: "مطلوب اضافة الاسم",
      validation_email_required: "مطلوب البريد الالكتروني",
      validation_email_invalid: "يرجى إدخال بريد إلكتروني صالح",
      validation_password_required: "كلمة المرور مطلوبة",
      validation_plan_required: "يجب اختيار الباقة",
      validation_expiry_future: "يجب تحديد تاريخ انتهاء صلاحية لاحق للتاريخ الحالي",
      error_email_exists: "يوجد مستخدم في لوحة التحكم بهذا البريد الإلكتروني بالفعل.",
      success_created: "تم إنشاء المستخدم بنجاح",
      error_create_failed: "تعذر إنشاء المستخدم",
      error_plans_load: "تعذر تحميل الباقات",
      update_modal_title: "تحديث الباقة",
      tab_assign_plan: "تعيين الباقة",
      tab_assign_images: "تعيين الصور",
      current_plan: "الباقة الحالية",
      assign_images_disabled_hint: "لا يوجد اشتراك نشط. عيّن الباقة أولاً.",
      remaining_images: "الصور المتبقية",
      images: "الصور",
      images_placeholder: "مثال: 120",
      images_hint: "أدخل عدد الصور المراد إضافتها",
      furniture_finder: "البحث عن الأثاث",
      furniture_finder_placeholder: "مثال: 30",
      furniture_finder_hint: "أدخل رصيد البحث عن الأثاث المراد إضافته",
      update_submit: "تحديث",
      update_success: "تم تحديث الباقة بنجاح",
      update_error: "تعذر تحديث الباقة",
      update_validation_required: "الرجاء تعديل حقل واحد على الأقل",
      error_user_detail_load: "تعذر تحميل بيانات المستخدم",
    },
    createRolesPage: {
      title: "أدوار المسؤول",
      subtitle: "حدد أدوار المستخدمين وصلاحياتهم وقم بإدارتها هنا.",
      tab_roles: "الأدوار",
      tab_users: "المستخدمون",
      btn_create_role: "إنشاء دور",
      modal_title_create_role: "إنشاء دور جديد",
      modal_title_edit_role: "تعديل الدور",
      role_name_label: "اسم الدور",
      role_name_placeholder: "أدخل اسم الدور",
      role_description_label: "الوصف",
      role_description_placeholder: "اختياري - يُحفظ مع الدور (مثل: وصول مختلط)",
      partial_access: "للقراءة فقط",
      edit_only_access: "محرر",
      full_access: "وصول كامل",
      cancel: "إلغاء",
      submit_create: "إنشاء الدور",
      submit_update_role: "تحديث الدور",
      validation_role_name: "يرجى إدخال اسم الدور",
      validation_permissions_required:
        "يرجى اختيار صلاحية لميزة واحدة على الأقل (للقراءة فقط، محرر، أو وصول كامل).",
      error_role_create_failed: "تعذر إنشاء الدور. حاول مرة أخرى.",
      error_role_update_failed: "تعذر تحديث الدور. حاول مرة أخرى.",
      error_modules_load_failed: "تعذر تحميل الوحدات. أغلق النافذة وحاول مرة أخرى.",
      error_roles_load_failed: "تعذر تحميل الأدوار. حاول مرة أخرى.",
      warning_modules_empty: "لم تُرجع الخادم أي وحدات للصلاحيات.",
      modal_modules_empty_hint:
        "تحقق من الاتصال أو من إعدادات الخادم. يمكنك إغلاق هذا الحوار والمحاولة لاحقًا.",
      col_role_name: "اسم الدور",
      col_permissions: "الصلاحيات",
      col_created: "تم الإنشاء",
      access_partial: "للقراءة فقط",
      access_edit: "محرر",
      access_full: "وصول كامل",
      access_none: "—",
      empty_no_roles: "لم يتم إنشاء أدوار بعد. اضغط «إنشاء دور» للبدء.",
      success_role_created: "تم إنشاء الدور بنجاح",
      success_role_updated: "تم تحديث الدور بنجاح",
      col_actions: "الإجراءات",
      edit_role: "تعديل الدور",
      edit_user: "تعديل المستخدم",
      btn_create_user: "إنشاء مستخدم",
      modal_title_create_user: "إنشاء مستخدم جديد",
      modal_title_edit_user: "تعديل المستخدم",
      modal_subtitle_create_user:
        "أدخل بريدهم الإلكتروني وحدد دورًا لمنحهم صلاحيات الوصول المناسب.",
      modal_subtitle_edit_user:
        "حدّث الدور المعيّن لهذا المستخدم ثم احفظ التغييرات.",
      user_email_label: "البريد الإلكتروني",
      user_email_placeholder: "أدخل البريد الإلكتروني",
      user_role_label: "الدور",
      user_role_placeholder: "اختر الدور",
      submit_create_user: "إنشاء المستخدم",
      submit_update_user: "تحديث المستخدم",
      validation_email_required: "يرجى إدخال البريد الإلكتروني",
      validation_email_invalid: "يرجى إدخال بريد إلكتروني صالح",
      validation_role_required: "يرجى اختيار دور",
      validation_no_roles_yet: "أنشئ دورًا من تبويب الأدوار أولًا",
      success_user_created: "تم إنشاء المستخدم بنجاح",
      success_user_updated: "تم تحديث المستخدم بنجاح",
      error_user_create_failed: "تعذر إضافة المستخدم. حاول مرة أخرى.",
      error_user_update_failed: "تعذر تحديث المستخدم. حاول مرة أخرى.",
      error_users_load_failed: "تعذر تحميل قائمة المستخدمين. حاول مرة أخرى.",
      col_user_email: "البريد الإلكتروني",
      col_user_role: "الدور",
      col_user_status: "الحالة",
      user_status_active: "نشط",
      user_status_pending: "قيد الانتظار",
      empty_no_users: "لا يوجد مستخدمون بعد. اضغط «إنشاء مستخدم» للبدء.",
      revoke_user: "إلغاء الصلاحية",
      cancel_pending_invite: "إلغاء",
      cancel_pending_invite_aria: "إلغاء الدعوة المعلّقة",
      cancel_invite_confirm_title: "إلغاء هذه الدعوة؟",
      cancel_invite_confirm_desc:
        "لا يمكن التراجع عن هذا الإجراء. هل أنت متأكد؟",
      cancel_invite_ok: "إلغاء الدعوة",
      success_invite_cancelled: "تم إلغاء الدعوة",
      error_invite_cancel_failed: "تعذر إلغاء الدعوة. حاول مرة أخرى.",
      revoke_user_confirm_title: "إلغاء صلاحية هذا المستخدم؟",
      revoke_user_confirm_desc:
        "لا يمكن التراجع عن هذا الإجراء. هل أنت متأكد؟",
      revoke_user_ok: "إلغاء الصلاحية",
      success_user_revoked: "تم إلغاء صلاحية المستخدم",
      error_user_revoke_failed: "تعذر إلغاء صلاحية المستخدم. حاول مرة أخرى.",
      api_role_labels: {
        VIEWER: "المشاهد",
        OWNER: "المالك",
      },
    },
    referralsPage: {
      page_title: "الإحالات",
      tab_dashboard: "لوحة التحكم",
      tab_configuration: "الإعدادات",
      tab_rewards: "المكافآت",
      tab_users: "المستخدمون",
      tab_activity_logs: "سجلات النشاط",
      dashboard_overview: "نظرة عامة على لوحة التحكم",
      export: "تصدير",
      exporting: "جاري التصدير…",
      filter_last_90_days: "آخر 90 يومًا",
      filter_last_30_days: "آخر 30 يومًا",
      filter_last_15_days: "آخر 15 يومًا",
      filter_last_7_days: "آخر 7 أيام",
      filter_custom_range: "نطاق مخصص",
      date_start: "تاريخ البداية",
      date_end: "تاريخ النهاية",
      overview_total_referrals: "إجمالي الإحالات",
      overview_people_from_referrals: "الأشخاص المُحالين",
      overview_total_rewards_earned: "إجمالي المكافآت المكتسبة",
      overview_points_redeemed: "مكافأة مستردة",
      overview_pending_approvals: "الموافقات المعلقة",
      overview_pending_subtitle: "فترة انتظار {days} أيام",
      overview_rewards_earned: "المكافآت المكتسبة",
      top_referrals: "أعلى الإحالات",
      country_placeholder: "الدولة",
      country_option_all: "الدولة",
      view_all: "عرض الكل",
      col_rank: "الترتيب",
      col_referrer: "المُحيل",
      col_email: "البريد الإلكتروني",
      col_referrals: "الإحالات",
      col_conversions: "التحويلات",
      col_rewards_earned: "المكافآت المكتسبة",
      col_country: "الدولة",
      recent_activity: "النشاط الأخير",
      activity_filter_all: "جميع الأنشطة",
      activity_filter_signup: "التسجيل",
      activity_filter_subscription: "الاشتراك",
      activity_filter_pending_approval: "الموافقة المعلقة",
      activity_filter_redeem_points: "استبدال النقاط",
      activity_empty: "لا يوجد نشاط بعد.",
      config_title: "إعدادات الإحالات",
      save_changes: "حفظ التغييرات",
      saving: "جاري الحفظ…",
      program_status: "حالة البرنامج",
      program_status_hint: "تفعيل أو تعطيل برنامج الإحالة",
      rewards_earning_rules: "قواعد المكافآت والربح",
      col_plan: "الخطة",
      col_price_sar: "السعر (ريال سعودي)",
      col_monthly_reward: "مكافأة شهرية",
      col_annual_reward: "مكافأة سنوية",
      config_no_plans: "لا توجد خطط مُعدّة.",
      referral_limits_controls: "حدود وضوابط الإحالة",
      max_referrals_per_month: "الحد الأقصى للإحالات شهريًا",
      max_referrals_hint:
        "الحد لمنع إساءة الاستخدام (يمكن تعديله للحملات)",
      payment_hold_days: "فترة تعليق الدفع (بالأيام)",
      payment_hold_hint:
        "المكافآت المضافة بعد الدفع غير قابلة للاسترداد خلال هذه الفترة",
      referred_user_discount: "خصم المستخدم المُحال",
      referred_user_discount_hint:
        "تقديم خصم فوري للمستخدمين الجدد الذين ينضمون عبر الإحالة",
      discount_amount_sar: "قيمة الخصم (بالريال السعودي)",
      discount_first_purchase_hint:
        "خصم فوري على أول عملية شراء للمستخدمين المُحالين",
      custom_codes_title: "تخصيص رموز الإحالة (المؤثرون)",
      referral_code: "رمز الإحالة",
      influencer_name: "البريد الإلكتروني",
      add_custom_code: "إضافة رمز مخصص",
      placeholder_enter_code: "أدخل الرمز",
      placeholder_select_influencer: "أدخل البريد الإلكتروني",
      col_code: "الرمز",
      col_influencer: "البريد الإلكتروني",
      col_status: "الحالة",
      no_custom_codes: "لا توجد رموز إحالة مخصصة بعد.",
      rewards_management: "إدارة المكافآت",
      activity_logs_title: "سجلات النشاط",
      users_title: "المستخدمون",
      search_rewards: "البحث عن المكافآت",
      read_only_hint: "عرض فقط — لا يمكن تنفيذ هذا الإجراء.",
      revoke_disabled_credit_hint: "المكافأة مُضافة بالفعل — لا يمكن إلغاؤها من هنا.",
      reward_credited_no_mutations_hint:
        "المكافأة مُضافة بالفعل — لا توجد إجراءات إضافية هنا.",
      search_users: "ابحث بالاسم أو البريد الإلكتروني أو رمز الإحالة...",
      search_logs: "ابحث في السجلات...",
      col_user: "المستخدم",
      col_amount: "المبلغ",
      col_earned_date: "تاريخ الاستحقاق",
      col_actions: "الإجراءات",
      col_event: "النشاط",
      col_details: "التفاصيل",
      col_timestamp: "الطابع الزمني",
      reward_details: "تفاصيل المكافأة",
      reward_id: "معرف المكافأة",
      user_name: "اسم المستخدم",
      user_email: "بريد المستخدم الإلكتروني",
      referrer_name: "اسم المُحيل",
      referrer_email: "بريد المُحيل الإلكتروني",
      reward_value: "قيمة المكافأة",
      status: "الحالة",
      approve_reward: "الموافقة على المكافأة",
      revoke_reward: "إلغاء المكافأة",
      approving: "جاري الموافقة…",
      revoking: "جاري الإلغاء…",
      filter_all_status: "جميع الحالات",
      status_credit: "الرصيد",
      status_expired: "منتهية الصلاحية",
      status_hold: "معلّقة",
      status_pending: "معلقة",
      status_redeemed: "تم استلامها",
      status_under_review: "قيد المراجعة",
      pagination_prev: "السابق",
      pagination_next: "التالي",
      modal_signups: "التسجيلات",
      modal_conversions: "التحويلات",
      modal_reward_earned: "المكافأة المكتسبة",
      modal_referral_code: "رمز الإحالة",
      modal_referral_link: "رابط الإحالة",
      copy: "نسخ",
      copied: "تم النسخ إلى الحافظة",
      copy_failed: "تعذر النسخ",
      col_referral_code: "رمز الإحالة",
      signup_label: "التسجيلات",
      conversions_label: "التحويلات",
      rewards_label: "المكافآت",
      last_activity: "آخر نشاط",
      filter_logs_success: "نجاح",
      filter_logs_failed: "فشل",
      status_active: "نشط",
      status_inactive: "غير نشط",
      modal_close: "إغلاق",
      delete_user: "حذف",
      delete_cancel: "إلغاء",
      confirm_delete_user_title: "حذف مستخدم الإحالة؟",
      confirm_delete_user_message:
        "هل أنت متأكد أنك تريد حذف {name} من برنامج الإحالة؟ لا يمكن التراجع عن هذا الإجراء.",
      delete_user_success: "تم حذف مستخدم الإحالة بنجاح.",
      delete_user_failed: "فشل حذف مستخدم الإحالة.",
    },
    filters: {
      filter: "تصفية",
      select: "اختيار",
      all: "الكل",
      search: "بحث",
      select_categories: "لقد أخذت زمام المبادرة",
    },
    status: {
      active: "نشط",
      inactive: "غير نشط",
      rejected: "مرفوض",
      permanently_rejected: " مرفوض نهائيًا",
      waiting: "قيد الانتظار",
      pending: "معلق",
      completed: "مكتمل",
      processing: "قيد المعالجة",
      failed: "فشل",
      blocked: "محظور",
    },

    modals: {
      confirm_delete_text: "تأكيد الحذف",
      description_1: "هل أنت متأكد أنك تريد حذف",
      description_2: "المتجر؟ لا يمكن التراجع عن هذا الإجراء.",
    },
    common_btn: {
      add_btn: "إضافة",
      cancel_btn: "إلغاء",
      upload: "رفع",
      delete: "يمسح",
      change: "تغيير",
      save: "حفظ",
      reject: "يرفض",
      close: "إغلاق",
      accept: "قبول",
      update: "تحديث",
      deleting: "جارٍ الحذف",
      block: "كتلة",
      loading: "جاري التحميل",
      unblock: "إلغاء الحظر",
    },

    upload_file_comp: {
      file_uploaded: "تم رفع الملف(ات)",
      can_upload_more_files: "يمكنك رفع المزيد من الملفات",
      file_added: "تم إضافة الملف",
      only: "فقط",
      file_allowed: "الملفات مسموح بها.",
      file: "الملف",
      click_to_upload: "انقر للتحميل",
      or_drag_and_drop: "أو اسحب وأفلت",
      file_size_error: "يجب أن يكون حجم الملف أصغر من ",
      file_add_success_msg: "تم إضافة الملف بنجاح",
      remove_file: "إزالة الملف",
      remove_all_files: "إزالة جميع الملفات",
    },

    // Dashboard Super Admin
    DashboardSuperAdmin: {
      new_merchants: "التجار الجدد",
      active_merchants: "التجار النشطون",
      inactive_merchants: "تجار غير نشطين",
      existing_business: "الشركات الحالية",
      new_business: " الشركات الجديدة",
      subscription_overview: "نظرة عامة على الاشتراكات",
      subscription_overview_description_1:
        "٪60 من التجار يشتركون في الخطة المجانية.",
      subscription_overview_description_2:
        "٪30 من التجار يشتركون في الخطة القياسية.",
      subscription_overview_description_3:
        "٪10 من التجار يشتركون في الخطة المؤسسية.",
    },

    AnalyticsPages: {
      select_store_to_view_analytics: "الرجاء تحديد متجر لعرض التحليلات",
      stores: " المتاجر",
      Analytics: "التحليلات",
      welcome: "مرحبًا",
      total_clicks: "إجمالي النقرات",
      total_impressions: "إجمالي مرات الظهور",
      most_viewed: "الأكثر مشاهدة",
      metrics: "المقاييس",
      since_last_month: "منذ الشهر الماضي",
      select_store: "اختر متجرًا",
      clicks: "مرات الظهور",
      impressions: "الانطباعات",
      no_data_right: " لا توجد بيانات",

      dropdown_1: {
        last_7_days: "آخر ٧ أيام",
        last_30_days: "آخر ٣٠ يومًا",
        last_90_days: "آخر ٩٠ يومًا",
      },
      chart: {
        last_7_days: "آخر ٧ أيام",
        last_30_days: "آخر ٣٠ يومًا",
        currentMOnth: "الشهر الحالي",
        custom_range: "نطاق مخصص",
      },
    },

    MerchantAnalytics: {
      filter: {
        all_stores: "جميع المتاجر",
        last_7_days: "آخر ٧ أيام",
        last_30_days: "آخر ٣٠ يومًا",
        last_90_days: "آخر ٩٠ يومًا",
        custom_range: "نطاق مخصص",
        no_countries_found: "لم يتم العثور على دول",
        no_merchants_found: "لم يتم العثور على تجار",
        failed_to_load_countries: "فشل تحميل الدول",
      },
      cards: {
        active_merchants: "التجار النشطون",
        pending_merchants: "التجار المعلقون",
        waiting_merchants: "التجار في الانتظار",
        total_stores: "إجمالي المتاجر",
        active_stores: "المتاجر النشطة",
        total_products: "إجمالي المنتجات",
        active_products: "المنتجات النشطة",
        total_views: "إجمالي المشاهدات",
        clicks: "النقرات",
        ctr: "معدل النقر",
      },
      charts: {
        analytics_overview: "نظرة عامة على التحليلات",
        performance_metrics_over_time: "مقاييس الأداء بمرور الوقت",
        total_clicks: "إجمالي النقرات",
        total_impressions: "إجمالي مرات الظهور",
        subscription_plans: "خطط الاشتراك",
        distribution_by_plan_type: "التوزيع حسب نوع الباقة",
        total: "الإجمالي",
        free: "مجاني",
        standard: "قياسي",
        enterprise: "مؤسسي",
        clicks: "النقرات",
        views: "المشاهدات",
      },
      growth: {
        tabs: {
          merchants: "التجار",
          stores: "المتاجر",
          products: "المنتجات",
        },
        merchant_growth_trend: "اتجاه نمو التجار",
        merchants_by_country: "التجار حسب البلد",
        store_growth_trend: "اتجاه نمو المتاجر",
        stores_by_country: "المتاجر حسب البلد",
        distribution_by_category: "التوزيع حسب الفئة",
        days_7: "7 أيام",
        days_30: "30 يومًا",
        days_90: "90 يومًا",
        labels: {
          active: "نشط",
          pending: "معلق",
          waiting: "في الانتظار",
          total_stores: "إجمالي المتاجر",
          active_stores: "المتاجر النشطة",
        },
      },
      tables: {
        top_merchants: "أفضل التجار",
        top_stores: "أفضل المتاجر",
        top_20_products: "أفضل 20 منتج",
        merchants: "التجار",
        stores: "المتاجر",
        views: "المشاهدات",
        impressions: "الانطباعات",
        products: "المنتجات",
        country: "البلد",
        status: "الحالة",
        active: "نشط",
        inactive: "غير نشط",
        pending: "معلق",
        waiting: "في الانتظار",
        product: "المنتج",
        store: "المتجر",
        category: "الفئة",
        export: "تصدير",
        csv_file: "ملف CSV",
        count: "العدد",
      },
      months: {
        jan: "يناير",
        feb: "فبراير",
        mar: "مارس",
        apr: "أبريل",
        may: "مايو",
        jun: "يونيو",
        jul: "يوليو",
        aug: "أغسطس",
        sep: "سبتمبر",
        oct: "أكتوبر",
        nov: "نوفمبر",
        dec: "ديسمبر",
      },
    },

    // Merchants Super Admin
    MerchantsPage: {
      Merchants: "التجار",
      approved: "معتمد",
      pending: "معلق",
      rejected: "مرفوض",

      dropdown_1: {
        vendor: "البائع",
        business: "الأعمال",
      },

      dropdown_2: {
        all: "الكل",
        active: "نشط",
        inactive: "غير نشط",
      },

      filter_all_countries: "جميع الدول",
      filter_all_industries: "جميع الصناعات",
      filter_has_store: "المتاجر",
      has_store_all: "كل المتاجر",
      has_store_with: "مع متجر",
      has_store_without: "بدون متجر",

      no_merchant: "لم يتم إنشاء أي تجار حتى الآن",
      no_blocked_merchant: "لا يوجد تجار محظورون حتى الآن",

      merchant_pending_tooltip:
        "الطلب المعلق يعني أنه قيد المعالجة ولم تتم الموافقة عليه أو رفضه بعد.",
      request_approved_msg:
        "تمت الموافقة على الطلب بنجاح. انتظر تسجيل المستخدم",
      request_rejected_msg: "تم رفض الطلب بنجاح",
      waiting_msg:
        "هذا النشاط التجاري في حالة انتظار حاليًا. حتى تسجيل المستخدم.",
      permenatly_msg:
        "تم رفض هذا النشاط التجاري نهائيًا. يُرجى التواصل مع الإدارة.",

      tableCol: {
        Merchant_name: "اسم التاجر",
        Vendor_name: "اسم البائع",
        store_name: "اسم المتجر",
        ecom_platform: "منصة التجارة الإلكترونية",
        industry: "الصناعة",
        country: "البلد",
        joined_at: "تاريخ ووقت الانضمام",
        status: "الحالة",
        no_of_store: "عدد المتاجر",
        product_count: "عدد المنتجات",
      },

      merchant_request_modal: {
        vendor_full_name: "الاسم الكامل للبائع",
        email_address: "عنوان البريد الإلكتروني",
        phone_number: "رقم الهاتف",
        merchant_name: "اسم التاجر",
        store_names: "أسماء المتاجر",
        industry: "القطاع",
        country: "البلد",
        city: "المدينة",
        e_commerce_platform: "منصة التجارة الإلكترونية",
        business_url: "رابط العمل",
        description: "الوصف",
      },
    },

    StorePage: {
      platformOptions: {
        ZID: " زد",
        SALLA: "سله",
        MAGENTO: "ماجنتو",
        SHOPIFY: "شوبيفاي",
        Other: "اخرى",
      },

      Merchants: "التجار",
      Store: "المتجر",
      approved: "المتجر المعتمد",
      pending: "المتجر المعلق",
      rejected: "المتجر المرفوض",
      add_store: "إضافة متجر",
      select_merchant: "اختيار التجار",
      select: "اختر",

      dropdown_1: {
        name: "الاسم",
        type: "النوع",
      },
      dropdown_2: {
        all: "الكل",
        active: "نشط",
        inactive: "غير نشط",
      },

      comments_modal: {
        comment: "تعليق",
        store_resubmission_comments: "تعليقات إعادة تقديم المتجر",
        comment_added_successfully: "تم إضافة التعليق بنجاح",
        comment_placeholder: "أضف تعليقاتك على الملاحظات",
        no_comments: "لا توجد تعليقات",
      },

      request_rejected_msg: "تم رفض الطلب بنجاح",
      rejection_comment: ".الرجاء إدخال تعليق الرفض",
      approveRequestStore: "تمت الموافقة على طلب الانضمام",

      reject_comment_modal: {
        title: "إضافة تعليق الرفض",
        placeholder: "أدخل سبب الرفض",
      },

      product_view_modal: {
        title: "منتجات المتجر",
      },
      no_store: {
        title: "لم يتم العثور على متاجر",
        description_approved:
          "لم يتم العثور على متاجر معتمدة. ستظهر المتاجر هنا بعد الموافقة.",
        description_pending: "لم يتم العثور على طلبات متاجر قيد الانتظار.",
        description_rejected: "لم يتم العثور على طلبات متاجر مرفوضة.",
        main_description: "بدء بإنشاء متجر المبادرة الأول لإدارة منتجاتك.",
      },
      storeTableCol: {
        store_name: "اسم المتجر",
        merchant_name: "اسم التاجر",
        store_type: "نوع المتجر",
        no_of_products: "عدد المنتجات",
        status: "الحالة",
      },
      storeActions: {
        view_add_comments: "عرض التعليقات وإضافتها",
        resubmit: "إعادة الإرسال",
        update: "تحديث",
        view_product: " عرض المنتجات",
      },
      store_pending_tooltip:
        "الطلب المعلق يعني أنه قيد المعالجة ولم تتم الموافقة عليه أو رفضه بعد.",
      store_rejected_tooltip:
        "يشير الطلب المرفوض إلى أنه لم يستوفِ معايير الموافقة المطلوبة.",
      createStore: {
        no_file_uploaded: "لم يتم تحميل أي ملف",

        view: "عرض",

        general_details: "التفاصيل العامة",

        vendor_name: "اسم البائع",
        phone_number: "رقم الهاتف",
        CRN: "CRN",
        BRC: "BRC",
        // Store Name
        store_name: "الاسم التجاري (بالإنجليزية)",
        store_arabic_name: "الاسم التجاري (بالعربية)",
        store_name_placeholder: "أدخل اسم متجرك المسجل",
        store_arabic_name_placeholder:
          "أدخل الاسم التجاري المسجل لمتجرك باللغة العربية",
        store_name_error: "اسم المتجر مطلوب",
        store_name_rule_1: "الرجاء إدخال اسم متجر صالح",
        //        store_type: "Select Type",
        store_type: "نوع المتجر",
        store_type_placeholder: "اختر نوع المتجر",
        store_type_error: "يرجى تحديد نوع المتجر",

        // Preferred Name
        preferred_name: "اسم المتجر (اسم العرض المفضل)",
        preferred_name_error: "اسم المتجر المفضل مطلوب",
        preferred_name_placeholder: "أدخل اسم المتجر بالتنسيق الذي تفضله",
        preferred_name_preview: "معاينة الاسم المفضل",
        preferred_display_name: "اسم العرض المفضل",
        preferred_display_name_placeholder:
          "سيُستخدم هذا الاسم للإعلانات والمحتوى الترويجي، وسيبقى كما هو حتى عند تطبيق الترجمات.",
        preferred_name_tooltip: "سيتم عرض الاسم الذي ستدخله هنا في التوصيات.",
        company_name: "اسم الشركة",

        // Store description
        store_description: "وصف المتجر",
        store_description_placeholder: "أدخل وصف المتجر الخاص بك",
        store_description_error: "وصف المتجر مطلوب",

        // Store Logo
        store_logo: "شعار المتجر",
        store_logo_error: "شعار المتجر مطلوب",
        check_size:
          "PNG, JPEG, JPG (الحد الأقصى 364×204 بكسل) الحد الأقصى لحجم الملف 1 ميجابايت",

        // business Details
        business_details: "تفاصيل العمل",

        // Regsitration number
        registration_number: "رقم السجل التجاري",
        registration_number_placeholder: "أدخل رقم السجل التجاري الخاص بك",
        registration_number_error: "رقم السجل التجاري مطلوب",
        registration_number_tooltip:
          "أدخل رقم تسجيل عملك الرسمي وفقًا للوائح بلدك.",

        // Business registration certificate
        certificate: "شهادة السجل التجاري",
        certificate_error: "شهادة السجل التجاري مطلوبة",
        certificate_placeholder: "قم برفع شهادة السجل التجاري الخاصة بك",
        certificate_tooltip: "أدخل رقم تسجيل عملك الرسمي وفقًا للوائح بلدك.",

        // VAT number
        vat_certificate: "شهادة ضريبة القيمة المضافة",
        vat_certificate_placeholder:
          "قم برفع شهادة ضريبة القيمة المضافة الخاصة بك",
        vat_certificate_error: "رقم ضريبة القيمة المضافة مطلوب",
        vat_tooltip: "أدخل رقم تسجيل عملك الرسمي وفقًا للوائح بلدك.",

        // Tax IX/Vat number
        tax_number: "رقم التعريف الضريبي/رقم ضريبة القيمة المضافة",
        tax_number_placeholder:
          "أدخل رقم التعريف الضريبي/رقم ضريبة القيمة المضافة الخاص بك",
        tax_number_error: "رقم التعريف الضريبي/رقم ضريبة القيمة المضافة مطلوب",
        tax_number_tooltip: "أدخل رقم تسجيل عملك الرسمي وفقًا للوائح بلدك.",

        // Business URL
        business_url: " رابط الموقع ",
        business_url_placeholder: "أدخل رابط العمل الخاص بك",
        business_url_error: "رابط العمل مطلوب",
        business_url_tooltip: "قم بإرفاق رابط موقع عملك أو متجرك عبر الإنترنت.",

        // Maroof link
        maroof_link: "رابط معروف",
        maroof_link_placeholder: "أدخل رابط معروف الخاص بك",
        maroof_link_error: "رابط معروف مطلوب",
        maroof_link_tooltip:
          "قم بإرفاق الرابط إلى صفحة التحقق معروف الخاصة بك.",

        // Location
        location: "الموقع",
        location_placeholder: "أدخل موقعك",
        location_error_1: "الموقع مطلوب",
        location_error_2: "الرجاء إدخال عنوان موقع صالح!",

        location_tooltip: "أدخل العنوان الفعلي أو المقر الرئيسي لعملك.",

        // Country of sale
        country_of_sale: "بلد البيع",
        country_of_sale_placeholder: "اختر بلد البيع الخاص بك",
        country_of_sale_error: "بلد البيع مطلوب",
        country_of_sale_tooltip: "حدد البلدان التي تُباع فيها منتجاتك.",

        Resubmit: "إعادة إرسال المتجر",
        store_status: "حالة المتجر",
        store_image: "صورة المتجر",
        store_link: "رابط المتجر",
        Create: "إنشاء متجر",
        Update: "تحديث المتجر",
        submit_request: "تقديم الطلب",
        resubmit_request: "إعادة تقديم الطلب",
      },
      resubmission_remarks: "ملاحظات إعادة إرسال المتجر",
      store_creation_msg: "تم إنشاء المتجر بنجاح",
    },

    // product page
    productPage: {
      stores: " المتاجر",
      products: "المنتج",
      add_products: "إضافة منتج",
      add_manually: "إضافة يدويًا",
      bulk_upload: "رفع مجمع",
      select_store: "اختر متجرًا",
      store_select_error: "الرجاء اختيار متجر",
      selection_store_text: "اختر المتجر لعرض المنتجات",

      showing: "عرض",
      of: "من",
      dropdown_1: {
        name: "الاسم",
        category: "الفئة",
      },

      dropdown_2: {
        all: "الكل",
        active: "نشط",
        inactive: "غير نشط",
      },

      // product table
      productTableCol: {
        product_name: "اسم المنتج",
        category: "الفئة",
        price: "السعر",
        image: "الصورة",
        product_url: "رابط المنتج",
        status: "الحالة",
        error: "خطأ",
      },
      no_product: {
        title: "لم يتم العثور على منتجات",
        selected_store_no_product:
          "يبدو أنه لا توجد منتجات في المتجر المحدد. أضف بعض المنتجات للبدء في البيع.",
        no_product_in_any_store:
          "يبدو أنه لا توجد منتجات في أي متجر. أضف بعض المنتجات للبدء في البيع.",
      },

      previous: "السابق",
      next: "التالي",
      // Product add Manual page
      add_manual_page: {
        add_manual_validation:
          "فشل التحقق: قم بإكمال كافة الحقول قبل إضافة حقل آخر.",

        details: "التفاصيل",
        product_name: "اسم المنتج",
        product_placeholder: "أدخل اسم المنتج المسجل الخاص بك",
        product_name_error: "اسم المنتج مطلوب",

        product_unit: "وحدة المنتج",
        product_unit_placeholder: "أدخل وحدة المنتج",
        product_unit_error: "وحدة المنتج مطلوبة",

        product_price: "سعر المنتج",
        product_price_placeholder: "أدخل سعر المنتج",
        product_price_error_1: "سعر المنتج مطلوب",
        product_price_error_2: "الرجاء إدخال سعر صالح",

        select_type: "اختر النوع",
        select_type_placeholder: "اختر نوع فئة المنتج",
        select_type_error: "الرجاء اختيار فئة المنتج",

        image_url: "رابط الصورة",
        image_url_placeholder: "أدخل رابط صورة المنتج",
        image_url_error_1: "الرابط مطلوب",
        image_url_error_2: "الرجاء إدخال رابط صالح!",

        product_url: "رابط المنتج",
        product_url_placeholder: "أدخل رابط المنتج",
        product_url_error_1: "الرابط مطلوب",
        product_url_error_2: "الرجاء إدخال رابط صالح!",

        add_another_product: "إضافة منتج آخر",

        product_added_successfully: "تمت إضافة المنتج(المنتجات) بنجاح!",
      },
      // Product Bulk upload
      bulk_upload_page: {
        required_file_validation: "الرجاء إضافة ملف",
        file_deleted_successfully: "تم حذف الملف بنجاح.",
        upload_file: "رفع ملف",
        no_template_text: "ليس لديك القالب؟",
        download_template: "تنزيل القالب",
        view_summary: "عرض الملخص",
        upload_size: "XLSX (بحد أقصى ٥ ميجابايت)",
        table: {
          previous_upload: "الملف المُحمّل سابقًا",
          Col: {
            file_name: "اسم الملف",
            date: "التاريخ",
            status: "الحالة",
            file_type: "نوع الملف",
          },
        },
        viewLogs: {
          no_error_logs: "لا توجد سجلات أخطاء متاحة",
          file_upload_logs: "سجلات تحميل الملفات",
          upload_summary: "ملخص التحميل",
          failed_entries: " إدخالات فاشلة",
          successfully_added: "تم الإضافة بنجاح",
          total_product: "إجمالي المنتجات",
        },
      },
    },
    organizationPage: {
      pageTitle: "أعضاء الفريق",
      teamTitle: "أعضاء الفريق",
      noActiveOrganizationTitle: "لا توجد مؤسسة نشطة",
      noActiveOrganizationDescription:
        "لا يوجد اشتراك مؤسسة نشط مرتبط بهذا الحساب. اشترِ باقة مؤسسة من لوحة التحكم أو سجّل الدخول بحساب مالك المؤسسة.",
      addMember: "اضف عضوا",
      emptyTitle: "لا يوجد أعضاء في الفريق بعد",
      emptyDescription:
        "ادعُ أعضاء الفريق بالبريد الإلكتروني وخصّص لهم صورًا وخصائص من الرصيد المشترك لشركتك.",
      nav: { team: "الفريق", generations: "توليدات المؤسسة" },
      stats: {
        plan: "الباقة",
        totalPool: "مجموع الصور",
        unallocated: "غير مخصص",
        activeMembers: "الأعضاء النشطون",
        invited: "مدعوون",
        ends: "انتهاء الاشتراك",
        furnitureFinderSection: "مكتشف الأثاث",
        totalFurnitureFinder: "مخزون مكتشف الأثاث",
        unallocatedFurnitureFinder: "غير مخصص",
      },
      statusLabels: {
        active: "نشط",
        invited: "مدعو",
        suspended: "موقوف",
      },
      table: {
        email: "البريد الإلكتروني",
        status: "الحالة",
        assigned: "مخصص",
        remaining: "المتبقي",
        used: "المستخدم",
        pending: "قيد الانتظار",
        features: "خصائص",
        ffRemaining: "رصيد البحث عن الأثاث",
        ffPending: "بحث عن الأثاث قيد الانتظار",
      },
      actions: {
        allocate: "تخصيص",
        reclaim: "استرجاع",
      },
      addMemberModal: {
        title: "دعوة عضو فريق",
        subtitle: "سيتلقى المستخدم دعوة بالبريد الإلكتروني للانضمام إلى لوحة التحكم.",
        email: "البريد الإلكتروني",
        emailRequired: "البريد الإلكتروني مطلوب",
        emailInvalid: "بريد إلكتروني غير صالح",
        emailPlaceholder: "member@example.com",
        images: "صور للتخصيص",
        imagesHint: "متاح من الرصيد المشترك: {max} صورة",
        imagesMin: "لا يمكن أن تكون القيمة سالبة",
        imagesMax: "تجاوزت الصور المتاحة من الرصيد المشترك",
        furnitureFinder: "البحث عن الأثاث للتخصيص",
        furnitureFinderHint: "متاح من الرصيد المشترك: {max}",
        furnitureFinderMin: "لا يمكن أن تكون القيمة سالبة",
        furnitureFinderMax: "تجاوز الرصيد المتاح من مخزون مكتشف الأثاث",
        features: "خصائص",
        featuresFromPlan: "اختر من الميزات المتاحة ضمن خطة شركتك فقط.",
        noPlanFeatures: "لا توجد خصائص مفعّلة على خطة شركتك.",
        submit: "إرسال دعوة",
        sending: "جاري الإرسال…",
        success: "تمت إضافة العضو بنجاح.",
      },
      allocateModal: {
        title: "تخصيص الصور والميزات",
        subtitle: "تحديث التخصيص لـ",
        images: "صور إضافية",
        imagesHint: "متاح من الرصيد المشترك: {max}",
        furnitureFinder: "رصيد بحث عن الأثاث إضافي",
        furnitureFinderHint:
          "متاح من الرصيد المشترك: {max}. يُضاف إلى الرصيد الحالي للعضو.",
        furnitureFinderCurrentBalance: "الرصيد الحالي: {balance}",
        furnitureFinderPendingNote:
          "يوجد {pending} قيد الانتظار وسيُضاف إلى الرصيد عند الحفظ قبل أي تخصيص جديد.",
        features: "خصائص",
        featuresFromPlan: "اختر من الميزات المتاحة ضمن خطة شركتك فقط.",
        noPlanFeatures: "لا توجد خصائص مفعّلة على خطة شركتك.",
        submit: "حفظ التخصيص",
        saving: "جاري الحفظ…",
        success: "تم تحديث العضو",
        nothingToUpdate: "أدخل صورًا أو رصيد بحث عن الأثاث أو خصائص للتحديث",
      },
      reclaimModal: {
        title: "استرجاع الصور غير المستخدمة",
        body: "هل تريد استرجاع الصور غير المستخدمة من {email} إلى رصيد المؤسسة؟",
        hint: "سيتم استرجاع ما يصل إلى {remaining} صورة غير مستخدمة (إن وجدت).",
        furnitureFinderHint:
          "سيتم استرجاع ما يصل إلى {remaining} رصيد غير مستخدم من ميزة البحث عن الأثاث (إن وجد)",
        confirm: "استرجاع",
        cancel: "إلغاء",
        success: "تمت إعادة {count} صورة إلى رصيد المؤسسة.",
        successWithFurnitureFinder:
          "تمت إعادة {images} صورة و{furnitureFinder} رصيد من ميزة البحث عن الأثاث إلى رصيد المؤسسة.",
      },
      generationsPage: {
        pageTitle: "توليدات الفريق",
        pageSubtitle:
          "تظهر هنا التوليدات التي أُنشئت على ملف المؤسسة لأعضاء الفريق النشطين. توليدات الحساب الشخصي لا تُدرج.",
        filterMember: "عضو الفريق",
        filterFeature: "خصائص",
        personal: "شخصي",
        allMembers: "جميع الأعضاء",
        allFeatures: "جميع الخصائص",
        emptyTitle: "لا توجد توليدات للمؤسسة بعد",
        emptyDescription:
          "ستظهر هنا توليدات أعضاء الفريق النشطين من حساب المؤسسة فقط. التوليدات الشخصية أو البيانات القديمة غير الموسومة لن تظهر.",
        noImage: "لا توجد صورة",
        generationAlt: "توليد الفريق",
        paginationTotal: "{from}-{to} من {total}",
        viewDetails: "عرض التفاصيل",
      },
      generationModal: {
        input: "المدخل",
        output: "الناتج",
        outputImage: "صورة الناتج {n}",
        prompt: "الوصف",
        noImage: "لا توجد صورة",
        noInput: "لا يوجد مدخل",
        inputAlt: "صورة المدخل",
        outputAlt: "صورة الناتج",
        completed: "مكتمل",
        generationFailed: "فشل الإنشاء",
      },
    },
    // User Page
    userPage: {
      user: "مستخدم",
      add_user: "إضافة مستخدم",
      select_merchant: " اختيار التجار",
      merchants: "التجار",

      dropdown_1: {
        name: "الاسم",
        role: "الدور",
      },

      dropdown_2: {
        all: "الكل",
        active: "نشط",
        inactive: "غير نشط",
      },
      select_merchant_view_user: "  لعرض المستخدمين  اختيار التجار",
      no_user: {
        title: "لم يتم إنشاء مستخدم بعد",
        description: "ابدأ بإنشاء مستخدمين لإدارة متاجرك ومنتجاتك",
      },

      // User Table
      userTableCol: {
        user_name: "اسم المستخدم",
        email: "عنوان البريد الإلكتروني",
        phone_number: "رقم الهاتف",
        status: "الحالة",
        role: "الدور",
      },
      ad_user_modal: {
        add_user: "إضافة مستخدم",

        text: "أضف المزيد من المستخدمين إلى منصتك",

        email: "البريد الإلكتروني",
        email_placeholder: "أدخل البريد الإلكتروني",
        email_error_1: "البريد الإلكتروني مطلوب",
        email_error_2: "الرجاء إدخال بريد إلكتروني صالح",

        phone_number: "رقم الهاتف",
        phone_number_placeholder: "أدخل رقم الهاتف المسجل الخاص بك",
        phone_number_error: "رقم الهاتف مطلوب",

        update_user_role: "تحديث دور المستخدم",
        update_role: "تحديث الدور",

        role: "الدور",
        role_placeholder: "اختر دور المستخدم",
        role_error: "دور المستخدم مطلوب",

        send_invites_btn: "إرسال الدعوات",
        send_invite_successfully: "تم إرسال دعوة المستخدم بنجاح",
        invite_send_successfully: "تم إرسال الدعوة بنجاح",

        admin: "مسؤول",
        viewer: "مشاهد",
      },
    },
    // Campaigns page
    campaignsPage: {
      campaigns: "الحملات",
      create_campaign: "إنشاء حملة",
      edit_campaign: "تعديل حملة",
      view_campaign: "عرض الحملة",
      view_campaign_details: "عرض تفاصيل الحملة",
      campaign_deleted_successfully: "تم حذف الحملة بنجاح",
      campaign_created_successfully: "تم إنشاء الحملة بنجاح",
      campaign_updated_successfully: "تم تحديث الحملة بنجاح",
      failed_to_fetch_campaigns: "فشل جلب الحملات. يرجى المحاولة مرة أخرى.",
      failed_to_delete_campaign: "فشل حذف الحملة. يرجى المحاولة مرة أخرى.",
      failed_to_create_campaign: "فشل إنشاء الحملة. يرجى المحاولة مرة أخرى.",
      failed_to_update_campaign: "فشل تحديث الحملة. يرجى المحاولة مرة أخرى.",
      campaign_id_missing: "معرف الحملة مفقود",
      campaign_id_not_found:
        "لم يتم العثور على معرف الحملة. لا يمكن تحديث الحملة.",
      search_campaigns: "البحث في الحملات...",

      // Steps
      steps: {
        details: "التفاصيل",
        audience: "الجمهور",
        content: "المحتوى",
        preview: "معاينة",
        schedule: "الجدولة",
      },

      // Details Step
      details: {
        title: "العنوان",
        title_placeholder: "منتجات جديدة - يناير",
        description: "الوصف",
        description_placeholder: "وصف حملتك...",
        email_sender: "البريد الإلكتروني للمرسل",
        email_sender_placeholder: "sender@example.com",
        email_sender_invalid: "يرجى إدخال بريد إلكتروني صالح",
        campaign_type: "نوع الحملة",
        campaign_type_placeholder: "اختر نوع الحملة",
        types: {
          promotional: "ترويجي",
          seasonal: "موسمي",
          welcome: "مرحبا",
          updates: "تحديثات المنصة",
        },
      },

      // Audience Step
      audience: {
        select_target_audience: "اختيار الجمهور المستهدف",
        list: "قائمة",
        types: "أنواع",
        search: "بحث",
        type: "النوع",
        country: "البلد",
        selected: "محدد",
        of: "من",
        available: "متاح",
        loading: "جاري التحميل...",
        users: "مستخدم",
        all_users: "جميع المستخدمين",
        returning_users: "المستخدمون العائدون",
        active_users: "المستخدمون النشطون",
        inactive_users: "المستخدمون غير النشطين",
        paid_users: "المستخدمون المشتركين",
        unpaid_users: "المستخدمون غير المشتركين",
        newsletter_users: "مستخدمو النشرة الإخبارية",
        contact_users: "مستخدمو جهات الاتصال",
        contact_list: "قائمة جهات الاتصال",
        contact_groups: "مجموعات الاتصال",
        contact: "جهة الاتصال",
        failed_to_fetch_contact_users: "فشل جلب مستخدمي جهات الاتصال",
        failed_to_fetch_contact_groups: "فشل جلب مجموعات الاتصال",
        total_contact_users: "إجمالي مستخدمي جهات الاتصال",
        custom_users: "مستخدمون مخصصون",
        target_audience: "الجمهور المستهدف",
        previous: "السابق",
        next: "التالي",
        failed_to_fetch_users: "فشل جلب المستخدمين. يرجى المحاولة مرة أخرى.",
        // Excel upload modal (Audience)
        upload_excel_sheet: "رفع ملف إكسل",
        upload_excel_description:
          "قم برفع ملف إكسل (.xls, .xlsx, .xlsm, .csv) يحتوي على قائمة الجمهور. الحد الأقصى لحجم الملف: 10MB",
        click_or_drag_file: "اضغط أو اسحب الملف إلى هذه المنطقة لرفعه",
        supported_formats: "الصيغ المدعومة: .xls, .xlsx, .xlsm, .csv",
        upload_file: "رفع الملف",
        download: "تحميل",
        please_select_excel_file: "يرجى اختيار ملف إكسل لرفعه",
        invalid_file: "الملف غير صالح. يرجى المحاولة مرة أخرى.",
        excel_uploaded_successfully: "تم رفع ملف الإكسل بنجاح",
        failed_to_upload_excel: "فشل رفع ملف الإكسل",
        excel_download_started: "بدأ التحميل",
        failed_to_download_excel: "فشل تحميل ملف الإكسل",
        table: {
          user: "المستخدم",
          country: "البلد",
          status: "الحالة",
          last_activity: "آخر نشاط",
          plan: "الباقة",
          name: "الاسم",
          email: "البريد الإلكتروني",
          description: "الوصف",
        },
        status: {
          active: "نشط",
          inactive: "غير نشط",
        },
      },

      // Content Step
      content: {
        subject_english: "الموضوع (الإنجليزية)",
        subject_english_placeholder: "أدخل الموضوع بالإنجليزية",
        description_english: "الوصف (الإنجليزية)",
        description_english_placeholder: "وصف حملتك...",
        subject_arabic: "الموضوع (العربية)",
        subject_arabic_placeholder: "أدخل العنوان بالعربية",
        description_arabic: "الوصف (العربية)",
        description_arabic_placeholder: "وصف حملتك باللغة العربية",
        template: "قالب البريد الإلكتروني",
        template_default: "قياسي",
        template_default_desc: "الإنجليزية والعربية واحدة تلو الأخرى",
        template_bilingual_split: "جنبًا إلى جنب",
        template_bilingual_split_desc: "صورة رأس اختيارية، الإنجليزية والعربية جنبًا إلى جنب، صورة تذييل اختيارية",
        header_image: "صورة الرأس (اختياري)",
        header_image_hint: "العرض الموصى به 600 بكسل",
        footer_image: "صورة التذييل (اختياري)",
        footer_image_hint: "العرض الموصى به 600 بكسل",
        upload_image: "رفع صورة",
        remove_image: "إزالة",
        no_image: "لا توجد صورة",
        attach_media: "إرفاق وسائل الإعلام",
        upload_your_image_here: "قم بتحميل صورتك هنا",
        image_formats: "JPG, PNG, HEIC حتى 10 ميجابايت",
        choose_file: "اختر ملف",
        remove: "إزالة",
        uploading_image: "جاري تحميل الصورة...",
        image_uploaded_successfully: "تم تحميل الصورة بنجاح",
        failed_to_upload_image: "فشل تحميل الصورة",
        add_a_button: "إضافة زر",
        button_label_english: "نص الزر (الإنجليزية)",
        button_label_english_placeholder: "أدخل نص الزر",
        button_label_arabic: "نص الزر (العربية)",
        button_label_arabic_placeholder: "أدخل نص الزر بالعربية",
        button_link: "رابط الزر",
        button_link_placeholder: "https://example.com",
      },

      // Schedule Step
      schedule: {
        schedule_campaign: "جدولة الحملة",
        send_immediately: "إرسال فوري",
        send_immediately_description: "إرسال حملتك إلى المستلمين على الفور",
        schedule_for_later: "جدولة لاحقاً",
        schedule_for_later_description:
          "اختر تاريخاً ووقتاً لإرسال حملتك تلقائياً",
        save_for_later: "حفظ لاحقاً",
        save_for_later_description: "احفظ حملتك للمراجعة أو التعديل لاحقاً",
        date: "التاريخ",
        time: "الوقت",
        not_scheduled: "غير مجدول",
        please_select: "يرجى الاختيار",
        campaign_summary: "ملخص الحملة",
        summary: {
          title: "العنوان:",
          audience: "الجمهور:",
          type: "النوع:",
          schedule: "الجدولة:",
          na: "غير متاح",
        },
      },

      // Preview Step
      preview: {
        default_greeting_english: "مرحبا",
        default_description_english:
          "استعد لموسمك مع مجموعتنا الجديدة إصدار الشتاء! من الأساسيات الأنيقة إلى المفضلات ذات الإصدار المحدود، تم تصميم هذه المنتجات لإبقائك دافئاً وملهماً طوال فصل الشتاء.",
        default_cta_english: "لا تفوت الفرصة - اكتشف الجديد قبل نفاد الكمية!",
        default_greeting_arabic: "مرحبا",
      },

      // Modal buttons
      buttons: {
        cancel: "إلغاء",
        back: "رجوع",
        next: "التالي",
        create_campaign: "إنشاء حملة",
        update_campaign: "تحديث الحملة",
        confirm_campaign: "تأكيد الحملة",
        edit: "تعديل",
        delete: "حذف",
        view: "عرض",
        view_details: "عرض التفاصيل",
        close: "إغلاق",
        save_for_later: "حفظ لوقت لاحق",
        delete_campaign: "حذف الحملة",
      },

      // Confirmation Modal
      confirm: {
        title: "تأكيد الحملة",
        send_immediately_message: "سيتم إرسال الحملة على الفور",
        schedule_for_later_message: "سيتم جدولة الحملة لاحقاً",
        save_for_later_message: "سيتم حفظ الحملة لاحقاً",
      },

      // Save for Later Modal
      save_for_later_modal: {
        title: "احفظ أو احذف الحملة؟",
        subtitle: "إدارة حالة الحملة",
      },

      // Table
      table: {
        campaign: "الحملة",
        description: "الوصف",
        type: "النوع",
        status: "الحالة",
        audience: "الجمهور",
        scheduled_on: "مجدولة في",
        created_on: "مُنشأة في",
        actions: "الإجراءات",
        by: "بواسطة",
      },

      // Filters
      filters: {
        all_status: "جميع الحالات",
        all_types: "جميع الأنواع",
        status: {
          scheduled: "مجدولة",
          draft: "مسودة",
          saved: "تم الحفظ",
          send_immediately: "إرسال فوري",
          completed: "مكتمل",
          canceled: "ملغي",
          failed: "فشل",
        },
        types: {
          promotional: "ترويجي",
          seasonal: "موسمي",
          welcome: "مرحبا",
          updates: "تحديثات",
        },
      },

      // View Modal
      view: {
        campaign: "الحملة",
        created_by: "تم الإنشاء بواسطة",
        type: "النوع",
        status: "الحالة",
        audience: "الجمهور",
        created_on: "مُنشأة في",
        description: "الوصف",
      },

      status_logs: {
        title: "سجلات حالة الحملة",
        upload_summary: "ملخص التحميل",
        total_emails: "إجمالي الرسائل الإلكترونية:",
        successful_emails: "الرسائل الإلكترونية الناجحة:",
        failed_emails: "الرسائل الإلكترونية الفاشلة:",
        opened_tracked: "تم فتحها (تتبُّع):",
        unopened: "لم تُفتح:",
        send_status: "حالة الإرسال:",
        processed_batches: "الدفعات المعالجة:",
        recipients_who_opened: "المستلمون الذين فتحوا الرسائل",
        download_opened: "تنزيل القائمة",
        email: "البريد الإلكتروني",
        open_count: "عدد مرات الفتح",
        first_opened: "أول فتح",
        items: "عنصر",
        failed_entries: "إدخالات فاشلة",
        error: "خطأ",
        no_error_logs: "لا توجد سجلات أخطاء متاحة",
        no_data: "لا توجد بيانات متاحة",
        no_opened: "لم يفتح أي مستلم الرسالة بعد",
      },

      failed_emails: {
        title: "الرسائل الفاشلة",
        email: "البريد الإلكتروني",
        reason: "السبب",
        failed_at: "وقت الفشل",
        items: "عنصر",
        search_placeholder: "ابحث بالبريد أو السبب",
        refresh: "تحديث",
        empty: "لا توجد رسائل فاشلة",
        no_results: "لا توجد نتائج مطابقة",
        delete_selected: "إزالة المحدد",
        delete_all: "إزالة الكل",
        confirm_delete_title: "إزالة الرسائل الفاشلة المحددة؟",
        confirm_delete_all_title: "إزالة جميع الرسائل الفاشلة؟",
        confirm_delete_message: "سيتم إزالة {count} عنوان بريد محدد من هذه الحملة.",
        confirm_delete_all_message: "سيتم إزالة {count} عنوان بريد من هذه الحملة.",
        confirm_delete_warning:
          "ستتم إزالتهم من المستلمين وتجاهلهم في أي إرسال مستقبلي. لا يمكن التراجع عن هذا الإجراء.",
        confirm_ok: "نعم، أزل",
        deleted_success: "تمت الإزالة بنجاح",
        delete_failed: "فشل إزالة الرسائل الفاشلة",
        fetch_failed: "فشل في جلب الرسائل الفاشلة",
        excluded_title: "عناوين مستبعدة من هذه الحملة",
      },

      // Stats
      stats: {
        total: "إجمالي",
        scheduled: "مجدولة",
        completed: "مكتمل",
      },
    },
    // Setting page
    settingPage: {
      settings: "إعدادات",
      profile_text: "الملف الشخصي",
      menu_text: "القائمة",
      setup_profile_text: "إعداد ملفك الشخصي",
      my_details: "بياناتي",
      reset_password: "إعادة تعيين كلمة المرور",
      personal_information: "المعلومات الشخصية",

      update_profile_modal: {
        update_profile: "قم بتحديث صورة ملفك الشخصي",
        resolution: "قم بتحميل صورة بدقة 128×128 بكسل",
        remove_profile: "هل تريد إزالة صورة الملف الشخصي؟",
        remove_profile_description:
          "سيتم حذف صورة ملفك الشخصي وسيتم استخدام هذه الصورة بدلاً منها.",
        Processing: "تحميل الصورة...",
      },
      remove: "إزالة",

      full_name: "الاسم الكامل",
      full_name_placeholder: "أدخل الاسم الكامل",
      full_name_error: "الاسم الكامل مطلوب",

      email: "البريد الإلكتروني",
      email_error_1: "البريد الإلكتروني مطلوب",
      email_error_2: "الرجاء إدخال بريد إلكتروني صالح",
      email_placeholder: "أدخل بريدك الإلكتروني",

      phone_number: "رقم الهاتف",
      phone_number_placeholder: "أدخل رقم هاتفك",
      phone_number_error: "رقم الهاتف مطلوب",
      phone_number_error_2: "مسموح فقط بالأرقام وعلامة +",

      profile_update_successfully: "تم تحديث الملف الشخصي بنجاح",

      reset_your_password: "إعادة تعيين كلمة المرور",

      password_requiremnts:
        "قم بإنشاء كلمة مرور قوية لا تقل عن 8 أحرف، بما في ذلك حرف صغير واحد على الأقل، وحرف كبير واحد، ورقم واحد، وحرف خاص واحد. هذا يضمن الأمان الأمثل لحسابك.",

      current_password: "كلمة المرور الحالية",
      current_password_placeholder: "أدخل كلمة المرور الحالية",
      current_password_error: "كلمة المرور الحالية مطلوبة",

      new_password: "كلمة المرور الجديدة",
      new_password_placeholder: "أدخل كلمة المرور الجديدة",
      new_password_error: "كلمة المرور الجديدة مطلوبة",

      confirm_password: "تأكيد كلمة المرور",
      confirm_password_placeholder: "أدخل تأكيد كلمة المرور",
      confirm_password_error: "تأكيد كلمة المرور مطلوب",

      passwordMatch: "كلمات المرور غير متطابقة!",

      discard_btn: "إلغاء",
      change_password_btn: "تغيير كلمة المرور",

      failed_upload_details: "فشل في تحديث الملف الشخصي. حاول مرة أخرى.",
    },

    discountsPage: {
      discounts: "الخصومات",
      search_discounts: "البحث عن طريق رمز الخصم",
      create_discount: "إنشاء خصم",
      code_copied: "نسخ الكود",
      copy_code: "نسخ الكود",
      discount_id_missing: "معرف الخصم مفقود",
      error_fetching_stats: "خطأ في جلب إحصائيات الخصم",
      error_fetching_discounts: "خطأ في جلب قائمة الخصومات",
      error_fetching_discount: "خطأ في جلب تفاصيل الخصم",
      error_fetching_users: "خطأ في جلب مستخدمي الخصم",
      error_fetching_plans: "خطأ في جلب الخطط",
      discount_created_successfully: "تم إنشاء الخصم بنجاح",
      discount_updated_successfully: "تم تحديث الخصم بنجاح",
      discount_deleted_successfully: "تم حذف الخصم بنجاح",
      error_creating_discount: "خطأ في إنشاء الخصم",
      error_deleting_discount: "خطأ في حذف الخصم",
      read_only_action_blocked: "عرض فقط — لا يمكنك تنفيذ هذا الإجراء.",
      export_success: "تم التصدير بنجاح",
      export_error: "فشل تصدير مستخدمي الخصم",
      error_code_exists: "رمز الخصم موجود بالفعل. يرجى استخدام رمز مختلف.",
      error_code_invalid: "رمز غير صالح",
      error_start_date_required: "تاريخ البدء مطلوب.",
      error_start_date_invalid: "تاريخ البدء غير صالح",
      error_end_date_required: "تاريخ الانتهاء مطلوب.",
      error_end_date_invalid: "تاريخ الانتهاء غير صالح",
      stats: {
        active: "الخصومات النشطة",
        expired: "الخصومات منتهية الصلاحية",
        total_redemptions: "إجمالي عمليات الخصومات",
        revenue_impact: "تأثير الإيرادات",
      },
      filters: {
        all_status: "جميع الحالات",
        all_plan_types: "جميع أنواع الخطط",
        all_plans: "جميع الباقات",
        status: {
          active: "نشط",
          expired: "منتهي الصلاحية",
          upcoming: "قادم",
        },
        plan_types: {
          starter: "ستارتر",
          basic: "بيسك",
          pro: "برو",
          business: "بزنس",
        },
        discount_types: {
          percentage: "نسبة مئوية",
          fixed: "مبلغ ثابت",
        },
      },
      table: {
        discount_code: "كود الخصم",
        type_value: "النوع والقيمة",
        validity_period: "فترة الصلاحية",
        target_plans: "الباقات المستهدفة",
        audience: "الجمهور",
        usage: "الاستخدام",
        status: "الحالة",
        actions: "الإجراءات",
      },
      buttons: {
        view: "عرض",
        edit: "تعديل",
        delete: "حذف",
      },
      pagination: {
        previous: "السابق",
        next: "التالي",
      },
      breadcrumbs: {
        discounts: "الخصومات",
      },
      detail: {
        user: "المستخدم",
        date: "التاريخ",
        plan: "الباقة",
        country: "البلد",
        original_amount: "المبلغ الأصلي",
        paid_amount: "المبلغ المدفوع",
        discount_type: "نوع الخصم",
        audience: "الجمهور",
        validity_period: "فترة الصلاحية",
        remaining_usage: "الاستخدام المتبقي",
        plans: "الباقات",
        discount_users: "مستخدمو الخصم",
      },
      export: "تصدير",
      export_csv: "ملف CSV",
      modal: {
        basic_info: "المعلومات الأساسية",
        audience: "الجمهور",
        create_discount_code: "إنشاء كود خصم",
        edit_discount_code: "تعديل رمز خصم",
        discount_name_english: "اسم الخصم (إنجليزي)",
        discount_name_arabic: "اسم الخصم (عربي)",
        required_fields_note: "الحقول المعلمة بـ * مطلوبة",
        discount_code: "كود الخصم",
        discount_type: "نوع الخصم",
        percentage_discount: "نسبة الخصم",
        fixed_discount: "خصم ثابت",
        plan_extension: "تمديد الباقة",
        trial_extension: "تمديد التجربة",
        discount_percentage: "نسبة الخصم",
        discount_amount: "قيمة الخصم",
        applicable_plans: "الباقات المطبقة",
        target_countries: "الدول المستهدفة",
        select_country: "اختر الدولة",
        start_date_time: "تاريخ/وقت البدء",
        end_date_time: "تاريخ/وقت الانتهاء",
        max_uses_overall: "إجمالي الاستخدام الأقصى",
        notify_when_max_reached: "إشعار عند الوصول إلى الحد الأقصى",
        enable_disable_notification: "تفعيل/تعطيل إشعار البريد الإلكتروني",
        first_purchase_only: "للشراء الأول فقط",
        redeem_more_than_once: "استخدام أكثر من مرة",
        back: "رجوع",
        next: "التالي",
        create: "إنشاء",
        update: "تحديث",
        confirm_saving_discount: "تأكيد خصم التوفير",
        confirm_discount_message:
          "سيتم حفظ الخصم وسيكون متاحًا للمستخدمين من تاريخ البدء المذكور.",
        discard: "إلغاء",
        confirm: "تأكيد",
        discard_discount: "تجاهل الخصم؟",
        discard_discount_message:
          "هل أنت متأكد أنك تريد تجاهل هذا الخصم؟ لن يتم حفظ أي تغييرات.",
        cancel: "إلغاء",
        confirm_delete_discount: "تأكيد حذف الخصم",
        confirm_delete_discount_message:
          "هل أنت متأكد أنك تريد حذف هذا الخصم؟ لا يمكن التراجع عن هذا الإجراء.",
        delete: "حذف",
        error_discount_code_invalid_chars:
          "يُسمح فقط بالأحرف (A-Z) والأرقام (0-9) والشرطة السفلية (_) والشرطة (-)",
        error_discount_code_min_length:
          "يجب أن يكون رمز الخصم 3 أحرف على الأقل",
        error_discount_code_max_length: "يجب ألا يتجاوز رمز الخصم 20 حرفًا",
        error_discount_max_amount:
          "لا يمكن أن تتجاوز قيمة الخصم 99,999 ريال سعودي",
        error_discount_exceeds_plan_price:
          "يجب أن تكون قيمة الخصم أقل من سعر الباقة (ريال سعودي",
      },
      audience: {
        all_users: "جميع المستخدمين",
        returning_users: "المستخدمون العائدون",
        active_users: "المستخدمون النشطون",
        inactive_users: "المستخدمون غير النشطين",
        paid_users: "المستخدمون المدفوعون",
        unpaid_users: "المستخدمون غير المدفوعين",
        newsletter_users: "مستخدمو النشرة الإخبارية",
        contact_users: "مستخدمو جهات الاتصال",
        contact_list: "قائمة جهات الاتصال",
        contact_groups: "مجموعات الاتصال",
        select_contact: "اختر قائمة جهات الاتصال",
        contact: "جهة الاتصال",
        failed_to_fetch_contact_users: "فشل جلب مستخدمي جهات الاتصال",
        failed_to_fetch_contact_groups: "فشل جلب مجموعات الاتصال",
        total_contact_users: "إجمالي مستخدمي جهات الاتصال",
        select_target_audience: "اختيار الجمهور المستهدف",
        list: "قائمة",
        types: "أنواع",
        search: "بحث",
        type: "النوع",
        country: "البلد",
        selected: "محدد",
        of: "من",
        available: "متاح",
        previous: "السابق",
        next: "التالي",
        users: "مستخدمين",
        loading: "جاري التحميل...",
        failed_to_fetch_users: "فشل جلب المستخدمين",
        status: {
          active: "نشط",
          inactive: "غير نشط",
        },
        table: {
          user: "المستخدم",
          country: "البلد",
          status: "الحالة",
          last_activity: "آخر نشاط",
          plan: "الباقة",
        },
      },
    },

    announcementsPage: {
      title: "الإعلانات",
      search_placeholder: "ابحث في الإعلانات",
      create_button: "إنشاء إعلان",
      english_label: "النص بالإنجليزية",
      arabic_label: "النص بالعربية",
      success_create: "تم إنشاء الإعلان بنجاح",
      validation: {
        english_required: "النص الإنجليزي مطلوب",
        arabic_required: "النص العربي مطلوب",
      },
      table: {
        english_text: "النص الإنجليزي",
        arabic_text: "النص العربي",
        created_at: "تاريخ الإنشاء",
        actions: "الإجراءات",
      },
      modal: {
        title: "إنشاء إعلان",
        english_placeholder: "أدخل الإعلان بالإنجليزية",
        arabic_placeholder: "أدخل الإعلان بالعربية",
        cancel: "إلغاء",
        submit: "إنشاء",
      },
      delete: {
        confirm_title: "حذف الإعلان؟",
        confirm_message: "هل أنت متأكد أنك تريد حذف هذا الإعلان؟",
        confirm_ok: "حذف",
        confirm_cancel: "إلغاء",
        success: "تم حذف الإعلان",
        error: "تعذر حذف الإعلان",
      },
    },

    librayPage: {
      library: "المكتبة",
      upload_images: "تحميل الصور",
      room_types_title: "نوع الغرفة",
      decor_style_title: "أسلوب الديكور",
      theme_title: "الموضوع",
      image_deleted_successfully: "تم حذف الصورة بنجاح",
      api_returned_unsuccessful_response:
        "محاولة توجيه برمجة التطبيقات غير ناجحة",
      failed_to_delete_image: "فشل حذف الصورة",
      read_only_cannot_delete: "عرض فقط — لا يمكن حذف الصور من المكتبة.",
      read_only_cannot_upload:
        "عرض فقط — لا يمكن إضافة صور إلى المكتبة.",

      no_more_images_title: " لا توجد صور أخرى",
      no_more_images_description:
        " يبدو أنه لا توجد صور أخرى في المكتبة. أضف بعض الصور للبدء في استخدامها في تصميماتك.",

      decor_style: {
        all: "الجميع",
        islamic: "إسلامي",
        minimalist: "مينيمال",
        tropical: "استوائي",
        modern: "مودرن",
        contemporary: "معاصر",
        classy: "كلاسيكي",
        boho: "بوهو",
        modern_classic: "مودرن كلاسيك",
        industrial: "صناعي",
        rustic_modern: "ريفي حديث",
        eclectic: "انتقائي",
        zen: "زن ياباني",
        shabby_chic: "رث أنيقة",
        elegant: "أنيق",
      },
      room_types: {
        all: "الجميع",
        library: "المكتبة",
        gym: "الجيم",
        restaurant: "مطعم",
        kitchen: "المطبخ",
        bathroom: "الحمام",
        dining: "طاولات الطعام",
        bedroom: "غرفة النوم",
        entrance: "المدخل",
        garden: "الحديقة",
        living_room: "الصالة",
        kids_room: "غرفة الاطفال",
        office: "المكتب",
        gaming_room: "غرفة الألعاب",
      },
      theme: {
        all: "الجميع",
        dark: "غامق",
        light: "فاتح",
        moroccan: "مغربي",
      },
    },
    contactsPage: {
      contacts: "جهات الاتصال",
      search_contacts: "البحث بالاسم",
      create_contact_list: "إنشاء مجموعة اتصال",
      create_contact_group: "إنشاء مجموعة اتصال",
      edit_contact_list: "تعديل قائمة الاتصال",
      add_contact: "إضافة جهة اتصال",
      edit_contact: "تعديل جهة الاتصال",
      contact_list_id_missing: "معرف قائمة الاتصال مفقود",
      contact_list_created_successfully: "تم إنشاء قائمة الاتصال بنجاح",
      contact_list_updated_successfully: "تم تحديث قائمة الاتصال بنجاح",
      contact_list_deleted_successfully: "تم حذف قائمة الاتصال بنجاح",
      contact_added_successfully: "تم إضافة جهة الاتصال بنجاح",
      contact_updated_successfully: "تم تحديث جهة الاتصال بنجاح",
      contact_deleted_successfully: "تم حذف جهة الاتصال بنجاح",
      error_fetching_contacts: "خطأ في جلب جهات الاتصال",
      error_fetching_contact_list: "خطأ في جلب تفاصيل قائمة الاتصال",
      error_creating_contact_list: "خطأ في إنشاء قائمة الاتصال",
      error_updating_contact_list: "خطأ في تحديث قائمة الاتصال",
      error_deleting_contact_list: "خطأ في حذف قائمة الاتصال",
      error_saving_contact: "خطأ في حفظ جهة الاتصال",
      error_deleting_contact: "خطأ في حذف جهة الاتصال",
      error_uploading_excel: "خطأ في رفع ملف Excel",
      excel_file_not_found: "ملف Excel غير موجود",
      excel_file_required: "يرجى رفع ملف Excel",
      excel_updated_successfully: "تم تحديث ملف Excel بنجاح",
      excel_deleted_successfully: "تم حذف ملف Excel بنجاح",
      excel_download_started: "بدأ التحميل",
      failed_to_download_excel: "فشل تحميل ملف Excel",
      failed_to_update_excel: "فشل تحديث ملف Excel",
      failed_to_delete_excel: "فشل حذف ملف Excel",
      excel_file_management: "إدارة ملف Excel",
      update_excel_file: "تحديث ملف Excel",
      excel_file_name: "اسم ملف Excel",
      excel_file_path: "مسار ملف Excel",
      no_excel_file: "لا يوجد ملف Excel",
      no_excel_file_uploaded: "لم يتم رفع ملف Excel",
      existing_excel_file: "ملف Excel الموجود",
      confirm_delete_excel: "تأكيد حذف ملف Excel",
      confirm_delete_excel_message:
        "هل أنت متأكد من حذف ملف Excel؟ لا يمكن التراجع عن هذا الإجراء.",
      confirm_delete_contact: "تأكيد حذف جهة الاتصال",
      confirm_delete_contact_message:
        "هل أنت متأكد من حذف جهة الاتصال هذه؟ لا يمكن التراجع عن هذا الإجراء.",
      breadcrumbs: {
        contacts: "جهات الاتصال",
      },
      table: {
        name: "الاسم",
        description: "الوصف",
        contacts_count: "عدد جهات الاتصال",
        actions: "الإجراءات",
      },
      detail: {
        name: "الاسم",
        email: "البريد الإلكتروني",
        actions: "الإجراءات",
        contacts: "جهات الاتصال",
        total_contacts: "إجمالي جهات الاتصال",
        excel_file: "ملف Excel",
      },
      form: {
        name: "الاسم",
        name_required: "الاسم مطلوب",
        name_placeholder: "أدخل اسم مجموعة الاتصال",
        contact_name_placeholder: "أدخل اسم جهة الاتصال",
        description: "الوصف",
        description_placeholder: "أدخل الوصف",
        email: "البريد الإلكتروني",
        email_required: "البريد الإلكتروني مطلوب",
        email_invalid: "تنسيق البريد الإلكتروني غير صحيح",
        email_placeholder: "أدخل البريد الإلكتروني",
        upload_excel: "رفع ملف Excel",
        excel_file_required: "ملف Excel مطلوب",
        excel_file_type_error: "يُسمح فقط بملفات Excel (.xls, .xlsx)",
        excel_file_size_error: "يجب أن يكون حجم الملف أقل من 10 ميجابايت",
        excel_uploaded_successfully: "تم رفع ملف Excel بنجاح",
        excel_uploaded: "تم رفع ملف Excel",
        uploading: "جاري الرفع...",
        click_to_upload: "انقر لرفع ملف Excel",
      },
      buttons: {
        view: "عرض",
        edit: "تعديل",
        delete: "حذف",
        download: "تحميل",
        update: "تحديث",
        create: "إنشاء",
      },
      modal: {
        cancel: "إلغاء",
        add: "إضافة",
        create: "إنشاء",
        update: "تحديث",
        delete: "حذف",
        confirm_delete_contact_list: "تأكيد حذف مجموعة الاتصال",
        confirm_delete_contact_list_message:
          "هل أنت متأكد من حذف مجموعة الاتصال هذه؟ لا يمكن التراجع عن هذا الإجراء.",
      },
      pagination: {
        previous: "السابق",
        next: "التالي",
      },
    },

    planUsagePage: {
      title: "إحصائيات استخدام الباقات",
      subtitle: "متوسط الاستخدام لكل مشترك حسب نوع الباقة",
      export: "تصدير",
      total_subscribers: "إجمالي المشتركين",
      across_all_plans: "في جميع الباقات",
      avg_images: "متوسط الصور المُنشأة",
      avg_finder: "متوسط استخدام الباحث",
      per_subscriber: "لكل مشترك",
      per_subscriber_lower: "لكل مشترك",
      overall_usage: "الاستخدام الإجمالي للباقة",
      of_included: "من المخصص المتضمن",
      average_by_plan: "متوسط الاستخدام حسب الباقة",
      plan: "الباقة",
      subscribers: "المشتركون",
      images: "الصور",
      furniture_finder: "باحث الأثاث",
      avg_images_generated: "متوسط الصور المُنشأة",
      images_included: "الصور المتضمنة",
      usage_percent: "نسبة الاستخدام",
      avg_finder_usage: "متوسط استخدام الباحث",
      finder_included: "الباحث المتضمن",
      overall_plan_usage: "نسبة الاستخدام الإجمالي للباقة",
      overall_tooltip:
        "متوسط نسبتي استخدام الصور وباحث الأثاث. يُحسب المخصصان بوزن متساوٍ بغض النظر عن حجمهما.",
      chart_images: "متوسط الصور المُنشأة لكل مشترك",
      chart_finder: "متوسط استخدام باحث الأثاث لكل مشترك",
      total_images_generated: "إجمالي الصور المُنشأة",
      total_finder_usage: "إجمالي استخدام الباحث",
      all_subscribers_lower: "جميع المشتركين",
      chart_total_images: "إجمالي الصور المُنشأة لكل باقة",
      chart_total_finder: "إجمالي استخدام باحث الأثاث لكل باقة",
      amount_spent: "المبلغ المدفوع",
      amount_spent_tooltip:
        "إجمالي المدفوع لهذه الباقة خلال الفترة. تُحتسب كل عملية دفع، لذا يُحتسب المشترك الذي جدّد أو رقّى باقته أكثر من مرة.",
      chart_amount_spent: "المبلغ المدفوع لكل باقة",
      in_period: "خلال الفترة المحددة",
      plan_distribution: "توزيع الباقات",
      subscriber_singular: "مشترك",
      subscribers_lower: "مشتركين",
      low_sample_tooltip:
        "المتوسط محسوب على {count} مشترك فقط — يعكس سلوكًا فرديًا وليس الباقة.",
      low_sample_note:
        "الأعمدة الرمادية محسوبة على أقل من {count} مشتركين، لذا تعكس سلوكًا فرديًا وليس الباقة.",
      no_data: "لا يوجد استخدام للباقات في هذه الفترة.",
      error_fetching: "تعذر تحميل إحصائيات استخدام الباقات.",
      error_export: "تعذر تصدير الملف.",
      usage_statistics: "إحصائيات الاستخدام",
      tab_plans: "استخدام الباقات",
      tab_tools: "الإنشاء حسب الأداة",
    },

    toolUsagePage: {
      title: "إنشاء المشتركين",
      subtitle: "كيف يستخدم المشتركون أدوات الإنشاء في زوري",
      export: "تصدير",
      total_generations: "إجمالي عمليات الإنشاء",
      total_generations_inline: "إجمالي عمليات الإنشاء",
      across_all_tools: "في جميع الأدوات",
      most_used_tool: "الأداة الأكثر استخدامًا",
      generations_lower: "عملية إنشاء",
      no_data_caption: "لا توجد عمليات إنشاء بعد",
      share_of_top_tool: "حصة الأداة الأولى",
      of_all_generations: "من إجمالي عمليات الإنشاء",
      active_subscribers: "المشتركون النشطون",
      per_subscriber_lower: "لكل مشترك",
      subscribers: "المشتركون",
      segment_all: "الكل",
      segment_paid: "المشتركون المدفوعون",
      segment_trial: "المستخدمون المجانيون",
      plan: "الباقة",
      all_plans: "جميع الباقات",
      plan_implies_paid: "تصفية الباقة تشمل مشتركيها المدفوعين.",
      generations_by_tool: "عمليات الإنشاء حسب الأداة",
      panel_subtitle: "تُظهر النسبة حصة كل أداة من إجمالي عمليات الإنشاء.",
      tool: "الأداة",
      relative_use: "الاستخدام النسبي",
      relative_tooltip:
        "يُقاس كل شريط مقابل الأداة الأكثر استخدامًا، لذا يملأ الشريط الأول المسار بالكامل.",
      generations: "عمليات الإنشاء",
      percent_of_total: "٪ من الإجمالي",
      share_of_total: "الحصة من إجمالي عمليات الإنشاء",
      share_tooltip: "النسبة نفسها مرسومة على مسار كامل بنسبة ١٠٠٪.",
      footnote:
        "تحتسب المقاييس عمليات الإنشاء الناجحة للمشتركين المحددين.",
      no_data: "لا توجد عمليات إنشاء في هذه الفترة.",
      error_fetching: "تعذر تحميل إحصائيات استخدام الأدوات.",
      error_export: "تعذر تصدير الملف.",
    },

    plansPricingPage: {
      title: "الباقات والأسعار",
      create_plan: "إنشاء باقة",
      search_plans: "البحث في الباقات...",
      view_list: "قائمة",
      view_grid: "شبكة",
      off_label: "خصم",
      no_plans: "لا توجد باقات تطابق عوامل التصفية.",
      read_only_action_blocked: "عرض فقط — لا يمكنك تنفيذ هذا الإجراء.",
      error_fetching_plans: "خطأ في جلب الباقات. يرجى المحاولة مرة أخرى.",
      error_duplicating_plan: "خطأ في نسخ الباقة.",
      error_disabling_plan: "خطأ في تعطيل الباقة.",
      error_enabling_plan: "خطأ في تفعيل الباقة.",
      error_deleting_plan: "خطأ في حذف الباقة.",
      error_saving_plan: "خطأ في حفظ الباقة.",
      error_fetching_plan: "خطأ في جلب الباقة.",
      delete_confirm_title: "حذف الباقة؟",
      delete_confirm_message:
        "هل أنت متأكد أنك تريد حذف هذه الباقة؟ لا يمكن التراجع عن هذا الإجراء.",
      delete_cancel: "إلغاء",
      filters: {
        all_status: "جميع الحالات",
        all_types: "جميع الأنواع",
        all_categories: "جميع الفئات",
        status: {
          active: "نشط",
          inactive: "غير نشط",
          draft: "مسودة",
        },
        types: {
          one_time: "دفعة واحدة",
          subscription: "اشتراك",
        },
        categories: {
          standard: "قياسي",
          organization: "مؤسسة",
        },
      },
      table: {
        plan: "الباقة",
        type: "النوع",
        category: "الفئة",
        price: "السعر",
        images: "الصور",
        subscribers: "المشتركون",
        status: "الحالة",
        last_updated: "آخر تحديث",
        actions: "الإجراءات",
      },
      actions: {
        edit: "تعديل الباقة",
        duplicate: "نسخ",
        disable: "تعطيل",
        enable: "تفعيل",
        delete: "حذف",
      },
      pagination: {
        show_total: "{start}-{end} من {total}",
      },
      grid: {
        images_included_template: "{count} صورة متضمنة",
        most_popular: "الأكثر شيوعًا",
        optional_addon: "إضافة اختيارية",
        per_photo: "لكل صورة",
        one_time_note: "صالحة لمرة واحدة، بدون تجديد",
        yearly_promo_template: "فقط {amount} ر.س مع الفوترة السنوية",
      },
      createPlan: {
        breadcrumb: "إنشاء باقة",
        edit_breadcrumb: "تعديل الباقة",
        page_title: "إنشاء باقة جديدة",
        edit_page_title: "تعديل الباقة",
        page_subtitle:
          "قم بإعداد تفاصيل الباقة والمزايا ومعاينتها قبل النشر.",
        cancel: "إلغاء",
        save_draft: "حفظ كمسودة",
        confirm_plan: "تأكيد الباقة",
        update_plan: "تحديث الباقة",
        billing_monthly: "/شهر",
        billing_yearly: "/سنة",
        plan_name_required: "اسم الباقة مطلوب.",
        price_required: "السعر مطلوب.",
        plan_name_arabic_required: "اسم الباقة بالعربية مطلوب.",
        description_required: "الوصف المختصر مطلوب.",
        description_arabic_required: "الوصف المختصر بالعربية مطلوب.",
        features_bilingual_required:
          "كل ميزة تتطلب وصفًا بالإنجليزية والعربية.",
        plan_updated: "تم تحديث الباقة بنجاح.",
        draft_saved: "تم حفظ المسودة بنجاح.",
        plan_confirmed: "تم إنشاء الباقة بنجاح.",
        draft_status_mismatch:
          "تم حفظ الباقة، لكن قد لا تكون الحالة مسودة. تحقق من قائمة الباقات.",
        basic_info: "المعلومات الأساسية",
        plan_name: "اسم الباقة",
        plan_name_placeholder: "مثال: باقة احترافية",
        plan_name_arabic: "اسم الباقة (عربي)",
        plan_name_arabic_placeholder: "مثال: باقة احترافية",
        short_description: "وصف مختصر",
        short_description_placeholder: "وصف موجز لهذه الباقة",
        short_description_arabic: "وصف مختصر (عربي)",
        short_description_arabic_placeholder: "وصف موجز لهذه الخطة",
        max_chars: "الحد الأقصى",
        characters: "حرفًا",
        category: "الفئة",
        plan_type: "نوع الباقة",
        type_subscription: "اشتراك",
        type_one_time: "دفعة واحدة",
        billing_cycle: "دورة الفوترة",
        billing_monthly_option: "شهري",
        billing_yearly_option: "سنوي",
        price: "السعر",
        images: "الصور",
        furniture_finder: "مكتشف الأثاث",
        features: "المزايا",
        tab_feature_access: "الوصول إلى المزايا",
        tab_furniture_tools: "أدوات الأثاث",
        tab_ai_image_tools: "أدوات تصميم الذكاء الاصطناعي",
        tab_room_planner: "مخطط الغرف",
        tab_advanced_spaces: "المساحات المتقدمة",
        tab_upcoming_features: "المزايا القادمة",
        no_features: "لا توجد مزايا في هذه الفئة بعد.",
        feature_description: "وصف الميزة",
        feature_placeholder: "أدخل وصف الميزة",
        feature_description_arabic: "وصف الميزة (عربي)",
        feature_placeholder_arabic: "أدخل وصف الميزة بالعربية",
        add_feature: "إضافة ميزة",
        allowed_features: "المزايا المسموحة",
        allowed_features_desc: "حدد المزايا المتاحة في هذه الباقة.",
        no_allowed_features: "لا توجد مزايا متاحة.",
        per_generation_features: "لكل عملية توليد",
        included_use_features: "استخدام متضمن",
        images_per_generation: "الصور لكل عملية توليد",
        plan_settings: "إعدادات الباقة",
        active_status: "حالة النشاط",
        active_status_desc: "اجعل هذه الباقة متاحة للمستخدمين",
        preview_plan_name: "اسم الباقة",
        preview_plan_desc_placeholder: "وصف الباقة",
        live_preview: "معاينة مباشرة",
        user_facing_view: "عرض المستخدم",
        preview_images: "صور",
        preview_no_subscriptions: "بدون اشتراكات شهرية",
        preview_notes_title: "ملاحظات المعاينة",
        preview_notes_line1: "هذه معاينة لما سيراه المستخدمون.",
        preview_notes_line2: "تتحدث التغييرات في الوقت الفعلي",
        modals: {
          confirm_title: "تأكيد الباقة",
          confirm_message: "هل أنت متأكد أنك تريد نشر هذه الباقة؟",
          confirm_button: "تأكيد الباقة",
          draft_title: "حفظ كمسودة",
          draft_message: "حفظ الباقة كمسودة؟",
          draft_button: "حفظ المسودة",
          cancel_title: "إلغاء الباقة",
          cancel_message:
            "هل أنت متأكد أنك تريد الإلغاء؟ سيتم فقدان التغييرات غير المحفوظة.",
          cancel_button: "إلغاء الباقة",
        },
      },
    },
  },

  en: {
    common_error_msg: {
      only_png_jpeg: "Only PNG, JPEG, and JPG files are allowed.",
      failed_to_approve_request: "Failed to approve request",
      failed_to_reject_request: "Failed to reject request",
      no_document_available: "No document available",
      failed_to_load_store: "Failed to load store data",
      failed_to_delete_store: "Failed to delete store",
      select_user_to_delete: "Please select a user to delete",
      delete_not_allowed: "Your role does not allow deleting in this section.",
      password_not_meet_requirements: "Password does not meet the requirements",
      wait_while_product_uploading:
        "Please wait while the product is being updated",
      select_merchant_to_delete: "Please select a merchant to delete",
      failed_to_fetch_uploaded_files: "Failed to fetch uploaded files",
      failed_to_delete_file: "Failed to delete file",
      select_store_to_delete_product:
        "Please select a store first to delete the product",
      rejected_request_deleted_successfully:
        "Rejected request deleted successfully",
      business_deleted_successfully: "Business deleted successfully",
      failed_to_delete_business: "Failed to delete business",
      select_store_first: "Select the Store first",
      failed_to_fetched_products_try_again:
        "Failed to fetch products. Try again",
      product_updated_successfully: "Product updated successfully",
      failed_to_fetch_approved_stores:
        "Failed to fetch approved stores. Work in progress",
      store_deleted_successfully: "Store deleted successfully",
      request_deleted_successfully: "Request deleted successfully",
      invalid_user_id: "Invalid user ID",
      user_deleted_successfully: "User deleted successfully",
      failed_to_delete_user: "Failed to delete user",
      failed_to_deletee_product: "Failed to delete product",
      please_upload_a_file: "Please upload a file",
      email_cannot_symbol: "Email cannot contain '+' symbol.",
      failed_to_fetch_comments: "Failed to fetch comments",
      failed_to_create_comments: "Failed to create comment",
      file_uploaded_being_processed:
        "Your File Uploaded successfully and Being Processed, Wait for few minutes",
      store_logo_invalid_image:
        "The logo file is not a valid image. Please upload a real PNG or JPEG file.",
      store_submit_failed: "Could not submit your request. Please try again.",
    },
    privacy_policy: {
      Privacy_policy: "Privacy Policy",
      title: "Privacy Policy and Confidentiality of Information",
      welcome:
        "The Zory platform team welcomes you and would like to inform you that, in our commitment to protecting users, Zory is dedicated to safeguarding the information of merchants, professionals, and consumers in accordance with the privacy and confidentiality policy implemented on the Zory platform.",
      introduction:
        'This document serves to inform you of the privacy and confidentiality practices adopted by Zory. The platform has developed this "Privacy Policy and Confidentiality of Information" to clearly define how data is handled and protected. We kindly ask you to review this policy carefully. By using the Zory platform, you acknowledge and agree that all your information is subject to the terms outlined in this policy.',
      definitions: {
        title: "Definitions",
        platform_label: "Zory Platform",
        platform:
          "This term refers to the platform owned by Zory, and includes all digital forms of Zory on the internet—whether as a mobile application or a website.",
        merchant_label: "Merchant",
        merchant:
          "This refers to any merchant who registers on the Zory platform to connect their e-commerce store with Zory, whether a natural or legal person. This includes all formats of the merchant's store, as long as their products are displayed within Zory's interior design visualizations to enable product recommendations via the Zory platform. This definition includes both the merchant's website and/or mobile app.",
        ecommerce_label: "E-Commerce Store",
        ecommerce:
          "This refers to the online store used by the merchant within the Zory platform, including both the website and mobile application.",
        consumer_label: "Consumer",
        consumer:
          "This refers to any end-user who purchases services such as room designs or uses the AI-powered product and merchant recommendation features provided through the Zory platform.",
        user_label: "User",
        user: "This term refers to any individual who uses the Zory platform, whether as a merchant or a consumer.",
      },
      information_collected: {
        title: "Information Collected and Retained by Zory",
        intro:
          "Zory collects and stores the following types of information in its electronic systems:",
        items: [
          "Personal information of consumers, such as name, email address, and mobile number.",
          "Store and legal entity information, including commercial registration number and a copy of the commercial license, or freelance permit number and its documentation, along with a bank account certificate (IBAN) and a link to the merchant's online store.",
          "Login credentials for the e-commerce store, including username, password, email address, security question and answer for password recovery, and the identities of staff members requiring store accounts.",
          "Cookies: Zory uses cookies to enhance the user experience and provide personalized services. If the user does not provide required information, Zory may attempt to obtain it through other available sources.",
          "Product information from merchants: Zory maintains ongoing access to store visits and the nature of products offered, as it provides merchants with product recommendation gateways integrated within their platforms.",
          "Store performance data: Zory may monitor store performance when needed to offer support, guidance, or advice to improve their business outcomes.",
          "Consumer data from merchant stores: To enhance store operations and service quality, Zory continuously tracks the number of customers visiting merchant stores and their engagement levels.",
        ],
      },
      information_sharing: {
        title: "Information Sharing",
        content: [
          "Zory is committed to safeguarding user privacy and only retains collected information to enhance platform performance, support merchant operations, and simplify the service experience.",
          "As a general rule, access to this information is limited strictly to certain authorized technical team members, and only after receiving formal permission from Zory's management. Such access is typically limited, time-bound, and subject to internal monitoring and compliance oversight.",
          "In pursuit of maintaining a secure environment for eCommerce activity, Zory reserves the right to take appropriate action if any suspicious or unlawful activity is detected by a user. In accordance with Zory's Terms of Use and Privacy Policy, Zory may share relevant user information with competent authorities to ensure legal compliance. This aligns with the laws and regulations of the Kingdom of Saudi Arabia, including but not limited to the E-Commerce Law, Personal Data Protection Law, and Anti-Cybercrime Law.",
          "Zory further notes that unauthorized or illegal activity by users may result in their data being shared with official or private entities such as banks or regulatory bodies.",
          "By using the platform, the user acknowledges and agrees that Zory may use the information they provide for marketing and promotional communications.",
        ],
      },
      data_confidentiality: {
        title: "Data Confidentiality and User Information Security",
        content: [
          "Zory is committed to maintaining the confidentiality of user information to the highest possible standard. However, due to the inherent risks of the internet environment, we emphasize the following:",
          "Zory strives to ensure that all user data is protected and not accessed by unauthorized individuals, in accordance with the platform's privacy policies.",
          "The platform uses high-quality, regularly updated electronic and technical security systems to protect user information and prevent unauthorized access.",
          "That said, due to the nature of the internet, complete security cannot be guaranteed. There is always a risk of security breaches, malware, or cyberattacks that may compromise data despite robust firewalls and protection systems.",
          "Therefore, we strongly encourage users to maintain full confidentiality of their personal information and avoid sharing any sensitive data that they consider highly private. This advice is part of Zory's responsibility to guide and protect its users.",
          "Zory is committed to protecting users' personal data in accordance with the highest industry standards. In the event of a data breach that results in unauthorized access or manipulation of personal data, the platform will notify the appropriate authorities immediately and inform affected users of the incident. Zory will also take all necessary measures to address and remediate the breach.",
        ],
      },
      information_usage: {
        title: "How We Use Your Information",
        content:
          "We use the information we collect for the following purposes:",
        items: [
          "To provide and maintain our services.",
          "To process transactions and send related information.",
          "To communicate with you, including sending updates and promotional offers.",
          "To improve our website and services.",
          "To ensure security and prevent fraud.",
        ],
      },
      cookies: {
        title: "Information We Collect Automatically Using Cookies",
        content: [
          "As you navigate and interact with our services, we may use automatic data collection technologies to gather certain information about your device, browsing behavior, and usage patterns, including:",
          "Details of your visits to our services, including the resources you access and use on the site.",
          "The information collected automatically is statistical in nature and helps us improve our services and deliver more personalized features to you by enabling us to:",
          "Estimate our audience size and usage patterns.",
          "Store information about your preferences, allowing us to customize our services based on your individual interests.",
          "Speed up your search experience.",
          "Administer contests, promotional offers, surveys, or other features of our website.",
          "Recognize you when you return to our services.",
        ],
      },
      user_rights: {
        title: "User Rights Regarding Personal Data",
        content:
          "Zory is committed to protecting user privacy and providing clear mechanisms for exercising their rights related to personal data. These rights include:",
        items: [
          "Right of Access: Users have the right to access their personal data stored by Zory and to review, update, or modify it when necessary.",
          "Right to Obtain a Copy: Users may request a copy of their personal data that has been collected and processed by Zory.",
          "Right to Rectification: Users have the right to correct or update their personal information to ensure its accuracy and completeness.",
          "Right to Erasure: Users may request the deletion or destruction of their personal data if there is no longer a legitimate need for its processing.",
          "Right to Withdraw Consent: Users have the right to withdraw their consent for the processing of their personal data at any time.",
        ],
      },
      third_party_links: {
        title: "Third-Party Links",
        content: [
          "Our website may contain links to third-party websites, such as e-commerce platforms that display products featured in our product recommendations.",
          "Zory is not responsible for the privacy practices of these external websites, including any purchases you may make through them. We are also not responsible for any sales transactions that are completed through third-party websites.",
          'These provisions form part of our "Privacy Policy and Confidentiality of Information," which is designed to uphold the transparency and trust that Zory is committed to providing to all users.',
          "For more details about how your personal data is processed and how to exercise your rights, you may contact the Personal Data Protection Department at Zory Platform for Communications and Information Technology using the contact information provided below: support@zory.ai",
        ],
      },
    },
    chatbot: {
      ask_us_anything: "Ask us anything, or share your feedback.",
      connection_lost: "Try to reconnect. Connection Lost",
      connecting_to_support: "Connecting to support...",
      message_placeholder: "Message...",
    },
    navbar: {
      logout: "Logout",
      watch_tutorial: " Watch Tutorial",
      good_bye: "Good Bye",
    },

    common_table_comp: {
      actions: "Actions",
      image_url_copied_clipboard: "Image URL copied to clipboard",
      from_sales_request: "Sales request",
    },
    loginPage: {
      vendor_portal: "Vendor Portal",
      email: "Email",
      email_placeholder: "Enter Email",
      email_error_1: "Email is required",
      email_error_2: "Please enter a valid email",
      password_placeholder: "Password",
      forget_password: "Forget Password?",
      login: "Login",
      privacy_policy_content_1:
        "By continuing you are confirming that you have read and agree to our",
      privacy_policy_content_2: "Privacy Policy",
      agree_prefix: "I agree to",
      terms_of_service: "Terms of Service",
      and: "and",
      privacy_policy_link: "Privacy Policy",
      agree_error:
        "You must agree to the Terms of Service and Privacy Policy",
      no_merchant_access: "No active account found",
      invalid_credentials:
        "No active account found with the given credentials",
    },
    signup: {
      buttonText: "Sign Up",
      createAccount: "Create Your Account",
      enterDetails: "Please enter your details to get started",
      fullName: "Full Name",
      email: "Email",
      phone: "Phone No",
      phoneNumberPlaceholder: "Enter Your Phone No",
      phoneNumberMessage: "Phone number is required",
      storeName: "Store/Business Name",
      storeNamePlaceholder: "Enter Your Store Name",
      password: "Password",
      passwordPlaceholder: "Enter your password",
      passwordRequirements: {
        length: "Password should be from 6 to 20 characters long",
        complexity:
          "At least one uppercase, lowercase, special character, and numeric character is required",
      },
      phone_number_error_2: "Only numbers and '+' are allowed",
      next: "Next",
      submit: "Submit",
      alreadyHaveAccount: "Already have an account?",
      login: "Login",
      back: "Back",
      vendorPortal: "Vendor Portal",
      invalid_link: "This signup link is no longer valid.",
      industry: "Industry",
      industryPlaceholder: "Select Industry",
      industryRequired: "Industry is required",
      industrySpecify: "Please specify your industry",
      ecommercePlatform: "E-commerce Platform",
      ecommercePlatformPlaceholder: "Select Platform",
      ecommercePlatformRequired: "E-commerce platform is required",
      platformSpecify: "Please specify your platform",
      country: "Country",
      countryPlaceholder: "Enter your country",
      countryRequired: "Country is required",
      city: "City",
      cityPlaceholder: "Enter your city",
      cityRequired: "City is required",
      pleaseSpecify: "Please specify"
    },
    forget_passwordPage: {
      forget_password: "Forget Password?",
      forgort_password_description:
        "Enter your registered email address to receive password reset instructions.",
      success_msg: "The Link for password reset has been sent to your email",
      send_reset_inxtruction: "Send Reset Instructions",
    },
    reset_password: {
      reset_password_title: "Reset Password",
      reset_password_description:
        "Enter your new password to reset your password.",
      password: "Password",
      password_error: "Password is Required",

      confirm_password: "Confirm Password",
      validation_0: "Password should be from 8 to 20 character long",
      validation_1:
        "At least one upper case, lower case, special character and numeric character is required",
      validation_2: "Password must be at least 8 characters long",
      passwordMatch: "Passwords do not match!",
      confirm_password_error: "Password confirmation is required",
      requirement_not_match_msg: "Password does not meet the requirements",
      reset: "Reset",
    },
    platformOptions: {
      ZID: "ZID",
      SALLA: "SALLA",
      MAGENTO: "MAGENTO",
      SHOPIFY: "SHOPIFY",
      Other: "Other",
    },

    PostHog: {
      title: "PostHog Analytics",
      subtitle:
        "Product analytics pulled live from PostHog — visits, retention, traffic sources and page flow.",
      dau: "Daily Active Users (DAU)",
      dauSub: "Unique users viewing a page each day",
      wau: "Weekly Active Users (WAU)",
      wauSub: "Unique users viewing a page each week",
      events: "Top Events",
      eventsSub: "Most frequent events in the period",
      referrers: "Referring Domains",
      referrersSub: "Where your pageviews come from",
      topPages: "Top Pages",
      topPagesSub: "Most viewed pages in the period",
      countries: "Top Countries",
      countriesSub: "Where your visitors are located",
      browsers: "Browsers",
      browsersSub: "Browsers used by your visitors",
      devices: "Device Types",
      devicesSub: "Desktop vs mobile vs tablet",
      deviceDesktop: "Desktop",
      deviceMobile: "Mobile",
      deviceTablet: "Tablet",
      funnel: "Pages per Visitor",
      funnelSub: "How many pages users view in a session",
      kpiVisitors: "Unique Visitors",
      kpiPageviews: "Pageviews",
      kpiEvents: "Total Events",
      kpiSessions: "Sessions",
      kpiAvgSession: "Avg. Session",
      kpiBounce: "Bounce Rate",
      kpiPagesPerSession: "Pages / Session",
      kpiMobile: "% Mobile",
      convTitle: "Conversion Rates",
      convSignin: "Sign-in Rate",
      convSigninSub: "Sign-ins vs Visitors",
      convSub: "Subscription Rate",
      convSubSub: "Subscribers vs Sign-ins",
      convReturn: "Return Rate",
      convReturnSub: "Return customers vs Sign-ins",
      funnelByBrowser: "Pageview funnel, by browser",
      funnelByBrowserSub:
        "How many users completed 1 → 2 → 3 pageviews, broken down by browser.",
      funnelStep1: "First page view",
      funnelStep2: "Second page view",
      funnelStep3: "Third page view",
      funnelPersons: "persons",
      funnelCompleted: "completed step",
      funnelDropped: "dropped off",
      funnelAvgTime: "Avg time",
      newReturning: "New vs Returning",
      newReturningSub: "New and returning active users each day",
      newUsers: "New",
      returningUsers: "Returning",
      os: "Operating Systems",
      osSub: "Operating systems used by your visitors",
      entryPages: "Landing Pages",
      entryPagesSub: "Where visitor sessions begin",
      activity: "Activity",
      activitySub: "Explore events or see real-time activity from your app",
      actEvent: "Event",
      actPerson: "Person",
      actUrl: "URL / Screen",
      actLibrary: "Library",
      actTime: "Time",
      actEntry: "Entry Page",
      actPages: "Pages",
      actDuration: "Duration",
      tabEvents: "Events",
      tabSessions: "Sessions",
      tabLive: "Live",
      lastHour: "Last hour",
      viewMore: "View more",
      showingLatest: "Showing latest {n} records",
      last7: "Last 7 days",
      last14: "Last 14 days",
      last30: "Last 30 days",
      last90: "Last 90 days",
      custom: "Custom range",
    },
    chatbotCheckerPage: {
      page_title: "Chatbot Checker",
      page_subtitle:
        "Monitor how the AI assistant is performing by reviewing real conversations.",
      refresh: "Refresh",
      stat_total_conversations: "Total conversations",
      stat_total_messages: "Total messages",
      stat_positive_rate: "Positive quality rate",
      stat_flagged: "Flagged responses",
      search_placeholder: "Search by chat ID, name, email or message",
      col_chat_id: "Chat ID",
      filter_all: "All ratings",
      rating_good: "Good",
      rating_bad: "Bad",
      rating_unrated: "Unrated",
      col_user: "User",
      col_first_message: "First message",
      col_messages: "Messages",
      col_quality: "Quality",
      col_started: "Started",
      col_actions: "Actions",
      anonymous: "Anonymous visitor",
      sender_bot: "Assistant",
      sender_user: "User",
      rate_quality: "Rate this conversation's quality:",
      quality_saved: "Rating saved",
      quality_save_failed: "Could not save rating",
      delete_confirm_title: "Delete this conversation?",
      delete_confirm_body: "This permanently removes the session and all its messages. This action cannot be undone.",
      delete_confirm_ok: "Delete",
      delete_confirm_cancel: "Cancel",
      delete_success: "Conversation deleted",
      delete_failed: "Could not delete conversation",
      error_overview: "Could not load overview stats",
      error_conversations: "Could not load conversations",
      error_detail: "Could not load conversation detail",
    },
    Sidebar: {
      Dashboard: "Dashboard",
      PostHog: "PostHog",
      "Zory Analytics": "Zory Analytics",
      Merchants: "Merchants",
      Stores: "Stores",
      Products: "Products",
      "Merchant Users": "Merchant Users",
      Users: "AI Users",
      Campaigns: "Campaigns",
      Discounts: "Discounts",
      "Plan and Pricing": "Plans & Pricing",
      "Plan Usage": "Plan Usage",
      Referrals: "Referrals",
      Announcements: "Announcements",
      Library: "Library",
      Settings: "Settings",
      Categories: "Categories",
      Contacts: "Contacts",
      "Sales Requests": "Sales Requests",
      "Policies & Privacy": "Policies & Privacy",
      "Chatbot Checker": "Chatbot Checker",
      "Admin roles": "Admin Roles",
      "Organization team": "Organization team",
      "Organization generations": "Team generations",
    },
    sitePoliciesPage: {
      title: "Policies & Privacy",
      subtitle: "Edit the Privacy Policy and the Terms and Conditions in English and Arabic. Changes go live on the website as soon as you save.",
      privacy_policy: "Privacy Policy",
      terms_and_conditions: "Terms and Conditions",
      terms_and_conditions_subtitle: ["Terms & Conditions – Platform Users"],
      status_live: "Live",
      status_partial: "Partially filled",
      status_empty: "Not set up",
      tab_en: "English",
      tab_ar: "العربية",
      lang_empty: "Empty",
      content_label: "Content",
      content_placeholder_en: "Start writing the page content…",
      content_placeholder_ar: "ابدأ بكتابة محتوى الصفحة…",
      lang_missing_en: "No English content yet. The website keeps showing its built-in text in this language until you add some.",
      lang_missing_ar: "No Arabic content yet. The website keeps showing its built-in text in this language until you add some.",
      save: "Save changes",
      discard: "Discard",
      saving: "Saving...",
      save_success: "Page saved",
      save_error: "Could not save the page",
      no_changes: "No changes to save",
      error_fetching: "Could not load the pages",
      last_updated: "Last updated",
      never_saved: "Never saved",
      unsaved_changes: "Unsaved changes",
      read_only: "You have view-only access to this page.",
      editor_visual: "Write",
      editor_preview: "Preview",
      editor_html: "HTML",
      words: "words",
      preview_empty: "Nothing to preview yet.",
      retry: "Retry",
    },
    schedulingTab: {
      meetings_tab: "Meetings",
      availability_tab: "Availability",
      meetings_title: "Meetings",
      meetings_subtitle: "Times shown in the organizer time zone.",
      meetings_empty: "No meetings yet",
      schedule_meeting: "Schedule meeting",
      booking_paused_hint: "Booking is paused or the calendar is not connected.",
      scope_upcoming: "Upcoming",
      scope_past: "Past",
      scope_all: "All",
      status_all: "All statuses",
      status_confirmed: "Confirmed",
      status_pending: "Booking in progress",
      status_needs_review: "Needs review",
      status_cancellation_pending: "Cancellation pending",
      status_cancelled: "Cancelled",
      status_failed: "Failed",
      status_completed: "Completed",
      table_attendee: "Attendee",
      table_email: "Email",
      table_when: "Date & time",
      table_timezone: "Time zone",
      table_status: "Status",
      table_source: "Source",
      table_actions: "Actions",
      source_website: "Website",
      source_admin: "Admin",
      view: "View",
      cancel: "Cancel",
      check_status: "Check status",
      checking: "Checking...",
      meet_issue: "Meeting link issue",
      meet_pending: "Link being prepared",
      meet_failed: "No link — share joining details with the attendee",
      date_start: "From",
      date_end: "To",
      detail_title: "Meeting details",
      detail_attendee: "Attendee",
      detail_email: "Email",
      detail_message: "Message",
      detail_attendee_timezone: "Attendee time zone",
      detail_organizer_time: "Organizer time",
      detail_source: "Source",
      detail_booked_at: "Booked at",
      detail_status: "Status",
      detail_meet: "Joining link",
      detail_calendar: "Calendar",
      open_in_calendar: "Open in Google Calendar",
      cancel_meeting: "Cancel meeting",
      cancel_confirm_title: "Cancel this meeting?",
      cancel_confirm_body: "Google Calendar will notify the attendee.",
      cancel_slot_note: "The time stays unpublished afterwards. You can republish it later if you want it bookable again.",
      keep_meeting: "Keep meeting",
      cancelling: "Cancelling...",
      cancel_success: "Meeting cancelled",
      book_title: "Schedule a meeting",
      book_subtitle: "30 minutes · Google Meet",
      book_success: "Meeting scheduled",
      choose_date: "Date",
      choose_time: "Time",
      attendee_name: "Attendee name",
      attendee_email: "Attendee email",
      attendee_message: "Message",
      confirm_meeting: "Confirm meeting",
      confirming: "Confirming...",
      no_slots: "No published times are free.",
      admin_booking_note: "Only published, currently free times can be chosen. Calendar conflicts cannot be overridden here.",
      booking_pending_title: "We are still confirming this booking",
      booking_pending_body: "Do not create another booking yet.",
      setup_title: "Booking setup",
      setup_subtitle: "One Zory calendar organizes every meeting booked from the website or from here.",
      bookings_enabled: "Bookings enabled",
      bookings_paused: "Bookings paused",
      connect: "Connect Google Calendar",
      reconnect: "Reconnect",
      connection_ok: "Connection healthy",
      connection_reconnect: "Reconnect required",
      not_connected: "Not connected",
      no_organizer: "No organizer account",
      calendar: "Calendar",
      not_connected_title: "No calendar is connected",
      not_connected_body: "Set the organizer time zone and connect a Google account that may create events and Google Meet conferences. Times cannot be published until both are done.",
      reconnect_title: "Google Calendar access was lost",
      reconnect_body: "Reconnect to accept new bookings. Existing meetings and their Google events are unchanged — nothing has been cancelled.",
      reconnect_note: "Reconnecting must use the same account — it never silently switches calendars.",
      contact_email: "Contact email shown on Contact Us",
      contact_email_hint: "Shown to visitors. The invitation is sent by the connected organizer account.",
      organizer_timezone: "Organizer time zone",
      select_timezone: "Select a time zone",
      timezone_hint: "Changing this affects entry and display only. Existing slots and meetings keep their instants.",
      duration: "Meeting duration",
      duration_hint: "Fixed in this release.",
      minutes: "minutes",
      horizon: "Booking horizon",
      days: "days",
      unsaved: "Unsaved changes",
      discard: "Discard",
      discard_title: "Discard your changes?",
      discard_ok: "Discard",
      keep_editing: "Keep editing",
      save_changes: "Save changes",
      saving: "Saving...",
      settings_saved: "Settings saved",
      slots_title: "Published times",
      slots_subtitle: "Busy status is read from the calendar each time this list loads; it is not stored.",
      slots_calendar_unavailable: "Busy status cannot be checked right now, so availability is not offered to visitors.",
      slots_empty: "No times published yet.",
      refresh: "Refresh",
      add_slot: "Add slot",
      add_slot_title: "Add a bookable time",
      slot_date: "Date",
      slot_time: "Time",
      slot_start: "Start time",
      slot_ends: "Ends",
      slot_ends_hint: "Computed from the fixed duration.",
      slot_timezone: "Time zone",
      slot_status: "Status",
      slot_entry_note: "Entered in the organizer time zone",
      save_before_publishing: "Save your settings before publishing times — new times use the saved organizer time zone.",
      publish_slot: "Publish slot",
      publishing: "Publishing...",
      slot_published: "Time published",
      unpublish: "Unpublish",
      republish: "Republish",
      slot_available: "Available",
      slot_busy: "Busy on calendar",
      slot_booked: "Booked",
      slot_in_progress: "Booking in progress",
      slot_unpublished: "Unpublished",
      slot_past: "Past",
      slot_unknown: "Status unavailable",
      connected_success: "Google Calendar connected",
      error_generic: "That could not be completed. Please try again.",
      error_validation: "Check the highlighted fields.",
      error_invalid_timezone: "That time zone is not supported.",
      error_slot_unavailable: "That time is no longer available.",
      error_slot_expired: "That time has passed.",
      error_slot_changed: "That time has changed. Review it and try again.",
      error_slot_overlap: "That time overlaps a published time.",
      error_slot_busy: "The calendar is busy during that time.",
      error_slot_in_use: "That time has a booking and cannot be changed.",
      error_settings_changed: "These settings changed elsewhere. Review them and try again.",
      error_request_conflict: "This booking request was already sent with different details.",
      error_booking_pending: "We are still confirming this booking.",
      error_booking_failed: "We could not schedule the meeting.",
      error_booking_cancelled: "That booking was cancelled.",
      error_calendar_unavailable: "The calendar is unavailable right now.",
      error_calendar_reconnect: "The calendar connection needs attention.",
      error_calendar_mismatch: "That is a different Google account or calendar.",
      error_cancellation_pending: "The cancellation is still being confirmed.",
      error_cancellation_failed: "The cancellation did not finish.",
      error_rate_limited: "Too many attempts. Please wait and try again.",
      error_not_configured: "Finish the calendar setup first.",
      error_slot_not_found: "We could not find that time.",
      error_oauth_scope: "Those Google permissions are not enough for scheduling. Start again.",
      error_booking_unavailable: "Online booking is unavailable in this browser.",
      error_scheduling_disabled: "Online booking is not available right now.",
      error_load_meetings: "Could not load meetings.",
      error_load_slots: "Could not load times.",
      error_save_settings: "Could not save the settings.",
      error_publish_slot: "Could not publish that time.",
      error_connect: "Could not connect Google Calendar.",
      error_load_settings: "Could not load the settings.",
      refresh_connection: "Refresh connection status",
      refreshing: "Refreshing…",
      connection_refreshed: "Connection status updated",
      setup_tab_blocked: "Allow pop-ups for this site, then choose Connect Google Calendar again.",
      setup_tab_note: "Setup opens in a new tab. Finish there, close it, and refresh connection status here.",
      error_name_required: "Enter the attendee's name",
      error_email_required: "Enter an email address",
      error_email_invalid: "Enter a valid email address",
      error_slot_required: "Choose a time",
      error_date_required: "Choose a date",
      error_time_required: "Choose a start time",
    },
    salesRequestsPage: {
      title: "Sales Requests",
      search_placeholder: "Search by name, business, email or phone",
      date_start: "From",
      date_end: "To",
      export: "Export",
      exporting: "Exporting...",
      export_success: "Export downloaded",
      export_error: "Error exporting sales requests",
      empty: "No sales requests yet",
      error_fetching: "Error fetching sales requests",
      table: {
        name: "Name",
        business_name: "Business",
        email: "Email",
        phone_number: "Phone",
        furniture_type: "Furniture Type",
        submitted_at: "Submitted",
        actions: "Actions",
      },
      view: "View",
      detail_title: "Sales request details",
      detail: {
        name: "Name",
        business_name: "Business name",
        email: "Email",
        phone_number: "Phone number",
        furniture_type: "Furniture type",
        business_type: "Business type",
        message: "Message",
        submitted_at: "Submitted at",
        updated_at: "Last updated",
      },
      close: "Close",
      delete: "Delete",
      delete_confirm_title: "Delete this request?",
      delete_confirm_body:
        "This permanently removes the sales request and all its details. This action cannot be undone.",
      delete_confirm_ok: "Delete",
      delete_confirm_cancel: "Cancel",
      delete_success: "Request deleted",
      delete_failed: "Error deleting sales request",
      move_to_merchant: "Move to merchant requests",
      move_confirm_title: "Move to merchant requests?",
      move_confirm_body:
        "This request moves to the Merchants pending list, where you can accept or reject it.",
      move_confirm_ok: "Move",
      move_confirm_cancel: "Cancel",
      move_success: "Moved to merchant requests",
      move_failed: "Error moving sales request",
      move_duplicate_email:
        "Already have a request with same email, please use different one.",
    },
    allUsersPage: {
      btn_create_user: "Create",
      modal_title: "Create dashboard user",
      modal_subtitle: "Create a new user and assign a plan.",
      name_english: "Name (English)",
      name_english_placeholder: "Enter full name in English",
      name_arabic: "Name (Arabic)",
      name_arabic_placeholder: "Enter full name in Arabic",
      email: "Email",
      email_placeholder: "Enter email address",
      password: "Password",
      password_placeholder: "Enter a password",
      plan: "Plan",
      plan_placeholder: "Select a plan",
      expiry: "Access expires",
      expiry_placeholder: "Select date",
      cancel: "Cancel",
      submit: "Create user",
      validation_name_required: "Name is required",
      validation_email_required: "Email is required",
      validation_email_invalid: "Please enter a valid email address",
      validation_password_required: "Password is required",
      validation_plan_required: "plan is required.",
      validation_expiry_future: "Account access expire date must be in the future.",
      error_email_exists: "A dashboard user with this email already exists.",
      success_created: "User created successfully",
      error_create_failed: "Could not create user",
      error_plans_load: "Could not load plans",
      update_modal_title: "Update Plan",
      tab_assign_plan: "Assign Plan",
      tab_assign_images: "Assign Images",
      current_plan: "Current Plan",
      assign_images_disabled_hint: "No active subscription. Assign plan first.",
      remaining_images: "Remaining Images",
      images: "Images",
      images_placeholder: "e.g. 120",
      images_hint: "Enter the number of images to assign",
      furniture_finder: "Furniture Finder",
      furniture_finder_placeholder: "e.g. 30",
      furniture_finder_hint: "Enter Furniture Finder credits to assign",
      update_submit: "Update",
      update_success: "Plan updated successfully",
      update_error: "Could not update plan",
      update_validation_required: "Please update at least one field",
      error_user_detail_load: "Could not load user details",
    },
    createRolesPage: {
      title: "Admin Roles",
      subtitle: "Define and manage user roles and permissions here.",
      tab_roles: "Roles",
      tab_users: "Users",
      btn_create_role: "Create Role",
      modal_title_create_role: "Create new role",
      modal_title_edit_role: "Edit role",
      role_name_label: "Role name",
      role_name_placeholder: "Enter role name",
      role_description_label: "Description",
      role_description_placeholder: "Optional — stored with the role (e.g. mixed access)",
      partial_access: "Read only",
      edit_only_access: "Editor",
      full_access: "Full access",
      cancel: "Cancel",
      submit_create: "Create role",
      submit_update_role: "Update role",
      validation_role_name: "Please enter a role name",
      validation_permissions_required:
        "Select at least one module (read only, editor, or full access).",
      error_role_create_failed: "Could not create role. Please try again.",
      error_role_update_failed: "Could not update role. Please try again.",
      error_modules_load_failed: "Could not load modules. Close this dialog and try again.",
      error_roles_load_failed: "Could not load roles. Please try again.",
      warning_modules_empty: "The server returned no permission modules.",
      modal_modules_empty_hint:
        "Check your connection or server configuration. You can close this dialog and try again later.",
      col_role_name: "Role name",
      col_permissions: "Permissions",
      col_created: "Created",
      access_partial: "Read only",
      access_edit: "Editor",
      access_full: "Full",
      access_none: "None",
      empty_no_roles: 'No roles yet. Click "Create Role" to add one.',
      success_role_created: "Role created successfully",
      success_role_updated: "Role updated successfully",
      col_actions: "Actions",
      edit_role: "Edit role",
      edit_user: "Edit user",
      btn_create_user: "Create User",
      modal_title_create_user: "Create new user",
      modal_title_edit_user: "Edit user",
      modal_subtitle_create_user:
        "Enter their email and assign a role to grant the right level of access.",
      modal_subtitle_edit_user:
        "Change their assigned role and save to update their access.",
      user_email_label: "Email",
      user_email_placeholder: "Enter email address",
      user_role_label: "Role",
      user_role_placeholder: "Select a role",
      submit_create_user: "Create user",
      submit_update_user: "Update user",
      validation_email_required: "Please enter an email address",
      validation_email_invalid: "Please enter a valid email address",
      validation_role_required: "Please select a role",
      validation_no_roles_yet: "Create a role in the Roles tab first",
      success_user_created: "User added successfully",
      success_user_updated: "User updated successfully",
      error_user_create_failed: "Could not add user. Please try again.",
      error_user_update_failed: "Could not update user. Please try again.",
      error_users_load_failed: "Could not load users. Please try again.",
      col_user_email: "Email",
      col_user_role: "Role",
      col_user_status: "Status",
      user_status_active: "Active",
      user_status_pending: "Pending",
      empty_no_users: 'No users yet. Click "Create User" to add one.',
      revoke_user: "Revoke",
      cancel_pending_invite: "Cancel",
      cancel_pending_invite_aria: "Cancel pending invitation",
      cancel_invite_confirm_title: "Cancel this invitation?",
      cancel_invite_confirm_desc:
        "This action cannot be undone. Are you sure?",
      cancel_invite_ok: "Cancel invitation",
      success_invite_cancelled: "Invitation cancelled",
      error_invite_cancel_failed: "Could not cancel the invitation. Please try again.",
      revoke_user_confirm_title: "Revoke this user’s access?",
      revoke_user_confirm_desc:
        "This action cannot be undone. Are you sure?",
      revoke_user_ok: "Revoke",
      success_user_revoked: "Access revoked",
      error_user_revoke_failed: "Could not revoke access. Please try again.",
      api_role_labels: {
        VIEWER: "VIEWER",
        OWNER: "OWNER",
      },
    },
    referralsPage: {
      page_title: "Referrals",
      tab_dashboard: "Dashboard",
      tab_configuration: "Configuration",
      tab_rewards: "Rewards",
      tab_users: "Users",
      tab_activity_logs: "Activity Logs",
      dashboard_overview: "Dashboard Overview",
      export: "Export",
      exporting: "Exporting…",
      filter_last_90_days: "Last 90 days",
      filter_last_30_days: "Last 30 days",
      filter_last_15_days: "Last 15 days",
      filter_last_7_days: "Last 7 days",
      filter_custom_range: "Custom Range",
      date_start: "Start date",
      date_end: "End date",
      overview_total_referrals: "Total Referrals",
      overview_people_from_referrals: "People from Referrals",
      overview_total_rewards_earned: "Total Rewards Earned",
      overview_points_redeemed: "Reward redeemed",
      overview_pending_approvals: "Pending Approvals",
      overview_pending_subtitle: "{days}-day hold period",
      overview_rewards_earned: "Rewards Earned",
      top_referrals: "Top Referrals",
      country_placeholder: "Country",
      country_option_all: "Country",
      view_all: "View All",
      col_rank: "RANK",
      col_referrer: "REFERRER",
      col_email: "EMAIL",
      col_referrals: "REFERRALS",
      col_conversions: "CONVERSIONS",
      col_rewards_earned: "REWARDS EARNED",
      col_country: "COUNTRY",
      recent_activity: "Recent Activity",
      activity_filter_all: "All Activities",
      activity_filter_signup: "Signup",
      activity_filter_subscription: "Subscription",
      activity_filter_pending_approval: "Pending Approval",
      activity_filter_redeem_points: "Redeem Points",
      activity_empty: "No activity yet.",
      config_title: "Referrals Configuration",
      save_changes: "Save Changes",
      saving: "Saving...",
      program_status: "Program Status",
      program_status_hint: "Enable or disable the referral program",
      rewards_earning_rules: "Rewards & Earning Rules",
      col_plan: "PLAN",
      col_price_sar: "PRICE (SAR)",
      col_monthly_reward: "MONTHLY REWARD",
      col_annual_reward: "ANNUALLY REWARD",
      config_no_plans: "No plans configured.",
      referral_limits_controls: "Referral Limits & Controls",
      max_referrals_per_month: "Max Referrals Per Month",
      max_referrals_hint:
        "Limit to prevent abuse (can be adjusted for campaigns)",
      payment_hold_days: "Payment Hold Period (days)",
      payment_hold_hint:
        "Rewards credited after payment are non-refundable for this period",
      referred_user_discount: "Referred User Discount",
      referred_user_discount_hint:
        "Offer instant discount to new users who join via referral",
      discount_amount_sar: "Discount Amount (SAR)",
      discount_first_purchase_hint:
        "Instant discount on first purchase for referred users",
      custom_codes_title: "Custom Referral Codes (Influencers)",
      referral_code: "Referral Code",
      influencer_name: "Email",
      add_custom_code: "Add Custom Code",
      placeholder_enter_code: "Enter code",
      placeholder_select_influencer: "Enter email address",
      col_code: "CODE",
      col_influencer: "EMAIL",
      col_status: "STATUS",
      no_custom_codes: "No custom referral codes yet.",
      rewards_management: "Rewards Management",
      activity_logs_title: "Activity Logs",
      users_title: "Users",
      search_rewards: "Search rewards",
      read_only_hint: "View only — this action is not available.",
      revoke_disabled_credit_hint:
        "This reward is already credited and cannot be revoked here.",
      reward_credited_no_mutations_hint:
        "This reward is already credited — no further actions here.",
      search_users: "Search by name, email, or referral code...",
      search_logs: "Search logs...",
      col_user: "USER",
      col_amount: "AMOUNT",
      col_earned_date: "EARNED DATE",
      col_actions: "ACTIONS",
      col_event: "ACTIVITY",
      col_details: "DETAILS",
      col_timestamp: "TIMESTAMP",
      reward_details: "Reward Details",
      reward_id: "Reward ID",
      user_name: "User Name",
      user_email: "User Email",
      referrer_name: "Referrer Name",
      referrer_email: "Referrer Email",
      reward_value: "Reward Value",
      status: "Status",
      approve_reward: "Approve Reward",
      revoke_reward: "Revoke Reward",
      approving: "Approving…",
      revoking: "Revoking…",
      filter_all_status: "All Status",
      status_credit: "Credit",
      status_expired: "Expired",
      status_hold: "Hold",
      status_pending: "Pending",
      status_redeemed: "Redeemed",
      status_under_review: "Under review",
      pagination_prev: "Previous",
      pagination_next: "Next",
      modal_signups: "Signups",
      modal_conversions: "Conversions",
      modal_reward_earned: "Reward Earned",
      modal_referral_code: "Referral Code",
      modal_referral_link: "Referral Link",
      copy: "Copy",
      copied: "Copied to clipboard",
      copy_failed: "Could not copy",
      col_referral_code: "REFERRAL CODE",
      signup_label: "SIGNUPS",
      conversions_label: "CONVERSIONS",
      rewards_label: "REWARDS",
      last_activity: "LAST ACTIVITY",
      filter_logs_success: "Success",
      filter_logs_failed: "Failed",
      status_active: "Active",
      status_inactive: "Inactive",
      modal_close: "Close",
      delete_user: "Delete",
      delete_cancel: "Cancel",
      confirm_delete_user_title: "Delete referral user?",
      confirm_delete_user_message:
        "Are you sure you want to remove {name} from the referral program? This action cannot be undone.",
      delete_user_success: "Referral user deleted successfully.",
      delete_user_failed: "Failed to delete referral user.",
    },
    filters: {
      filter: "Filter",
      select: "Select",
      all: "All",
      search: "Search",
      select_categories: "Select Categories",
    },
    status: {
      active: "Active",
      inactive: "Inactive",
      rejected: "Rejected",
      permanently_rejected: "Permanently Rejected",
      waiting: "Waiting",
      pending: "Pending",
      completed: "Completed",
      processing: "Processing",
      failed: "Failed",
      blocked: "Blocked",
    },
    modals: {
      confirm_delete_text: "Confirm Delete",
      description_1: "Are you sure you want to delete",
      description_2: " This action cannot be undone.",
    },
    upload_file_comp: {
      file_uploaded: "File(s) Uploaded",
      can_upload_more_files: "You can upload more files",
      file_added: "File Added",
      only: "Only",
      file_allowed: "files are allowed.",
      file: "File",
      click_to_upload: "Click to upload",
      or_drag_and_drop: "or drag and drop",
      file_size_error: "File must be smaller than ",
      file_add_success_msg: "File added successfully",
      remove_file: "Remove File",
      remove_all_files: "Remove All Files",
    },

    common_btn: {
      add_btn: "Add",
      cancel_btn: "Cancel",
      upload: "Upload",
      delete: "Delete",
      save: "Save",
      change: "Change",
      close: "Close",
      reject: "Reject",
      accept: "Accept",
      update: "Update",
      deleting: "Deleting",
      block: "Block",
      loading: "Loading...",
      unblock: "Unblock",
    },

    AnalyticsPages: {
      select_store_to_view_analytics:
        "Please select a store to view the analytics",
      stores: "Stores",
      Analytics: "Analytics",
      welcome: "Welcome",
      total_clicks: "Total Clicks",
      total_impressions: "Total Impressions",
      most_viewed: "Most Viewed",
      metrics: "Metrics",
      since_last_month: "Since Last Month",
      select_store: " Select Store",
      clicks: "Clicks",
      impressions: "Impressions",
      no_data_right: "No Data Right Now",
      dropdown_1: {
        last_7_days: "Last 7 Days",
        last_30_days: "Last 30 Days",
        last_90_days: "Last 90 Days",
      },
      chart: {
        last_7_days: "Last 7 Days",
        last_30_days: "Last 30 Days",
        currentMOnth: "Current Month",
        custom_range: "Custom Range",
      },
    },

    MerchantAnalytics: {
      filter: {
        all_stores: "All Stores",
        last_7_days: "Last 7 days",
        last_30_days: "Last 30 days",
        last_90_days: "Last 90 days",
        custom_range: "Custom Range",
        no_countries_found: "No countries found",
        no_merchants_found: "No merchants found",
        failed_to_load_countries: "Failed to load countries",
      },
      cards: {
        active_merchants: "Active Merchants",
        pending_merchants: "Pending Merchants",
        waiting_merchants: "Waiting Merchants",
        total_stores: "Total Stores",
        active_stores: "Active Stores",
        total_products: "Total Products",
        active_products: "Active Products",
        total_views: "Total Views",
        clicks: "Clicks",
        ctr: "CTR",
      },
      charts: {
        analytics_overview: "Analytics Overview",
        performance_metrics_over_time: "Performance metrics over time",
        total_clicks: "Total Clicks",
        total_impressions: "Total Impressions",
        subscription_plans: "Subscription Plans",
        distribution_by_plan_type: "Distribution by plan type",
        total: "Total",
        free: "Free",
        standard: "Standard",
        enterprise: "Enterprise",
        clicks: "Clicks",
        views: "Views",
      },
      growth: {
        tabs: {
          merchants: "Merchants",
          stores: "Stores",
          products: "Products",
        },
        merchant_growth_trend: "Merchant Growth Trend",
        merchants_by_country: "Merchants by Country",
        store_growth_trend: "Store Growth Trend",
        stores_by_country: "Stores by Country",
        distribution_by_category: "Distribution by Category",
        days_7: "7 days",
        days_30: "30 days",
        days_90: "90 days",
        labels: {
          active: "Active",
          pending: "Pending",
          waiting: "Waiting",
          total_stores: "Total Stores",
          active_stores: "Active Stores",
        },
      },
      tables: {
        top_merchants: "Top Merchants",
        top_stores: "Top Stores",
        top_20_products: "Top 20 Products",
        merchants: "Merchants",
        stores: "Stores",
        views: "Views",
        impressions: "Impressions",
        products: "Products",
        country: "Country",
        status: "Status",
        active: "Active",
        inactive: "Inactive",
        pending: "Pending",
        waiting: "Waiting",
        product: "Product",
        store: "Store",
        category: "Category",
        export: "Export",
        csv_file: "CSV File",
        count: "Count",
      },
      months: {
        jan: "Jan",
        feb: "Feb",
        mar: "Mar",
        apr: "Apr",
        may: "May",
        jun: "Jun",
        jul: "Jul",
        aug: "Aug",
        sep: "Sep",
        oct: "Oct",
        nov: "Nov",
        dec: "Dec",
      },
    },

    // Dashboard Super Admin
    DashboardSuperAdmin: {
      new_merchants: "New Merchants",
      active_merchants: "Active Merchants",
      inactive_merchants: "Inactive Merchants",
      existing_business: "Existing Businesses",
      new_business: "New Businesses",
      subscription_overview: "Subscriptions Overview",
      subscription_overview_description_1:
        "60% of Merchants has occupied the Free Subscription plan.",
      subscription_overview_description_2:
        "30% of Merchants has occupied the Standard Subscription plan.",
      subscription_overview_description_3:
        "10% of Merchants has occupied the Enterprise Subscription plan.",
    },

    // Merchants Super Admin
    MerchantsPage: {
      Merchants: "Merchants",
      approved: "Approved",
      pending: "Pending",
      rejected: "Rejected",
      no_merchant: "No Merchants Created Yet",
      no_blocked_merchant: "No Merchants Blocked Yet",

      dropdown_1: {
        vendor: "Vendor",
        business: "Business",
      },
      dropdown_2: {
        all: "All",
        active: "Active",
        inactive: "Inactive",
      },

      filter_all_countries: "All Countries",
      filter_all_industries: "All Industries",
      filter_has_store: "Stores",
      has_store_all: "All stores",
      has_store_with: "With store",
      has_store_without: "Without store",

      merchant_pending_tooltip:
        "A pending request means it is being processed and has not yet been approved or rejected.",
      request_approved_msg:
        "Request approved successfully.Wait for User Sign up",
      request_rejected_msg: "Request rejected successfully",
      waiting_msg:
        "This business is currently in a waiting state. Until user SignUp",
      permenatly_msg:
        "This business has been permanently rejected. Please contact the admin",

      tableCol: {
        Merchant_name: "MERCHANT NAME",
        Vendor_name: "VENDOR NAME",
        store_name: "STORE NAME",
        ecom_platform: "ECOM PLATFORM",
        industry: "INDUSTRY",
        country: "COUNTRY",
        joined_at: "JOIN AT",
        status: "STATUS",
        no_of_store: "NO. OF STORES",
        product_count: "NO. OF PRODUCTS",
      },

      merchant_request_modal: {
        vendor_full_name: "Vendor Full Name",
        email_address: "Email Address",
        phone_number: "Phone Number",
        merchant_name: "Merchant Name",
        store_names: "Store Names",
        industry: "Industry",
        country: "Country",
        city: "City",
        e_commerce_platform: "E-commerce Platform",
        business_url: "Business Url",
        description: "Description",
      },
    },

    // Store Page
    StorePage: {
      platformOptions: {
        ZID: "ZID",
        SALLA: "SALLA",
        MAGENTO: "MAGENTO",
        SHOPIFY: "SHOPIFY",
        Other: "Other",
      },

      Merchants: "Merchants",
      Store: "Store",
      approved: "Approved",
      pending: "Pending",
      rejected: "Rejected",
      add_store: "Add Store",
      select_merchant: "Select Merchant",
      select: "Select",

      dropdown_1: {
        name: "Name",
        type: "Type",
      },
      dropdown_2: {
        all: "All",
        active: "Active",
        inactive: "Inactive",
      },

      comments_modal: {
        comment: "Comment",
        store_resubmission_comments: "Store Resubmission comments",
        comment_added_successfully: "Comment added successfully",
        comment_placeholder: "Add your comment against the remarks...",
        no_comments: "No Comments",
      },

      reject_comment_modal: {
        title: "Add Rejection Comment",
        placeholder: "Enter rejection reason...",
      },

      product_view_modal: {
        title: "Store Products",
      },
      rejection_comment: "Please enter a rejection comment.",

      request_rejected_msg: "Request rejected successfully",
      approveRequestStore: "Request Approved",

      storeTableCol: {
        store_name: "STORE NAME",
        merchant_name: "MERCHANT NAME",
        store_type: "STORE TYPE",
        no_of_products: "NO. OF PRODUCTS",
        status: "STATUS",
      },
      storeActions: {
        view_add_comments: "View & Add Comments",
        resubmit: "Re-Submit",
        update: "Update",
        view_product: "View Products",
      },
      store_pending_tooltip:
        "A pending request means it is being processed and has not yet been approved or rejected.",
      store_rejected_tooltip:
        "The rejected request indicates that it did not meet the required criteria for approval.",

      no_store: {
        title: "No Stores Found",
        description_approved:
          "No approved stores found. Stores will appear here after approval.",
        description_pending: "No pending store requests found.",
        description_rejected: "No rejected store requests found.",
        main_description:
          "Start by creating your first store to manage your products.",
      },
      // Create Store/ Update Store
      createStore: {
        general_details: "General Details",
        phone_number: "Phone Number",
        view: "View",

        no_file_uploaded: "No file uploaded",

        vendor_name: "Vendor Name",
        CRN: "CRN",
        BRC: "BRC",

        // Store Name
        store_name: "Store Name (English)",
        store_arabic_name: "Store Name (Arabic)",
        store_name_placeholder: "Enter your registered Store Name",
        store_arabic_name_placeholder:
          "Enter your registered Store Arabic Name",
        store_name_error: "Store name is required",
        store_name_rule_1: "Store name is required",

        //        store_type: "Select Type",
        store_type: "Store Type",
        store_type_placeholder: "Select Store Type",
        store_type_error: "Please select an Store Type",

        // Preferred Name
        preferred_name: "Store Name (English)",
        preferred_name_error: "Preferred Store name is required",
        preferred_name_placeholder:
          "Enter a store name in your preferred format",
        preferred_name_preview: "Preferred name preview",
        preferred_display_name: "Preferred Display Name",
        preferred_display_name_placeholder:
          "This name will be used for ads and promotional content and will remain the same even when translations are applied.",
        preferred_name_tooltip:
          "This name you will enter here will be shown in recommendations.",
        company_name: "Company Name",

        // Store description
        store_description: "Store Description",
        store_description_placeholder: "Enter your Store Description",
        store_description_error: "Store description is required",

        // Store Logo
        store_logo: "Store Logo",
        store_logo_error: "Store logo is required",
        check_size: "PNG, JPEG, JPG (max. 364×204px) Maximum file size 1 MB",

        // business Details
        business_details: "Business Details",

        // Regsitration number
        registration_number: "Commercial Registration Number",
        registration_number_placeholder:
          "Enter your Commercial Registration Number",
        registration_number_error: "Commercial Registration Number is required",
        registration_number_tooltip:
          "Enter your official business registration number as per your country's regulations.",

        // Business registration certificate
        certificate: "Business Registration Certificate",
        certificate_error: "Business Registration Certificate is required",
        certificate_placeholder:
          "Upload your Business Registration Certificate",
        certificate_tooltip:
          "Enter your official business registration number as per your country's regulations.",

        // VAT number
        vat_certificate: "VAT Certificate",
        vat_certificate_placeholder: "Upload your VAT Certificate",
        vat_certificate_error: "VAT Number is required",
        vat_tooltip:
          "Enter your official business registration number as per your country's regulations.",

        // Tax IX/Vat number
        tax_number: "Tax ID/VAT Number",
        tax_number_placeholder: "Enter your Tax ID/VAT Number",
        tax_number_error: "Tax ID/VAT Number is required",
        tax_number_tooltip:
          "Enter your official business registration number as per your country's regulations.",

        // Business URL
        business_url: "Business URL",
        business_url_placeholder: "Enter your Business URL",
        business_url_error: "Business URL is required",
        business_url_tooltip:
          "Attach the link to your business website or online store.",

        // Maroof link
        maroof_link: "Maroof Link",
        maroof_link_placeholder: "Enter your Maroof Link",
        maroof_link_error: "Maroof Link is required",
        maroof_link_tooltip:
          "Attach the link to your Maroof verification page.",

        // Location
        location: "Location",
        location_placeholder: "Enter your Location",
        location_error_1: "Location is required",
        location_error_2: "Please enter a valid Location URL!",

        location_tooltip:
          "Enter the physical address or headquarters of your business.",

        // Country of sale
        country_of_sale: "Country of Sale",
        country_of_sale_placeholder: "Select your Country of Sale",
        country_of_sale_error: "Country of Sale is required",
        country_of_sale_tooltip:
          "Select the countries where your products are sold.",

        store_status: "Store Status",
        store_image: "Store Image",
        store_link: "Store Link",
        Create: "Create Store",
        Update: "Update Store",
        Resubmit: "Resubmit Store",
        submit_request: "Submit Request",
        resubmit_request: "Re-Submit Request",
      },
      resubmission_remarks: "Store resubmission remarks",
      store_creation_msg: "Store created successfully",
    },

    // Product Page
    productPage: {
      showing: "Showing",
      stores: "Stores",
      products: "Product",
      of: "of",
      update_product: "Update Product",
      add_products: "Add Product",
      add_manually: "Add Manually",
      bulk_upload: "Bulk Upload",
      select_store: "Select Store",
      store_select_error: "Please select a store",
      selection_store_text: "Select the store to view products",
      add_manual_validation:
        "Validation Failed: Complete all fields before adding another.",

      dropdown_1: {
        name: "Name",
        category: "Category",
      },
      dropdown_2: {
        all: "All",
        active: "Active",
        inactive: "Inactive",
      },

      no_product: {
        title: "No Products Found",
        selected_store_no_product:
          "It seems there are no products in your selected store. Add some to start selling.",
        no_product_in_any_store:
          "It seems there are no products in any store. Add some to start selling.",
      },
      productTableCol: {
        product_name: "PRODUCT NAME",
        category: "CATEGORY",
        price: "PRICE",
        image: "IMAGE URL",
        product_url: "PRODUCT URL",
        status: "STATUS",
        error: "ERROR",
      },

      previous: "Prev",
      next: "Next",

      add_manual_page: {
        add_manual_validation:
          "Validation Failed: Complete all fields before adding another.",

        details: "Details",
        product_name: "Product Name",
        product_placeholder: "Enter your registered Product Name",
        product_name_error: "Product name is required",

        product_unit: "Product unit",
        product_unit_placeholder: "Enter the unit of the product",
        product_unit_error: "Product unit is required",

        product_price: "Product Price",
        product_price_placeholder: "Enter the price of the product",
        product_price_error_1: "Product price is required",
        product_price_error_2: "Please enter a valid price",

        select_type: "Select Type",
        select_type_placeholder: "Select the type of the product category",
        select_type_error: "Please select a Product Category",

        image_url: "Image URL",
        image_url_placeholder: "Enter the URL of the product image",
        image_url_error_1: "URL is Required",
        image_url_error_2: "Please enter a valid URL!",

        product_url: "Product URL",
        product_url_placeholder: "Enter the URL of the product",
        product_url_error_1: "URL is Required",
        product_url_error_2: "Please enter a valid URL!",

        add_another_product: "Add Another Product",
        product_added_successfully: "Product added successfully",
      },

      bulk_upload_page: {
        required_file_validation: "Please Add a file",
        file_deleted_successfully: "File deleted successfully",
        viewLogs: {
          file_upload_logs: "File Upload Logs",
          upload_summary: "Upload Summary",
          failed_entries: "Failed Entries",
          successfully_added: "Successfully Added",
          total_product: "Total Products",
          no_error_logs: "No error logs available",
        },
        upload_file: "Upload File",
        no_template_text: "Don't have the template?",
        download_template: "Download Template",
        upload_size: "XLSX, (max. 5MB)",
        view_summary: "View Summary",
        table: {
          previous_upload: "Previously Uploaded File",
          Col: {
            file_name: "FILE NAME",
            date: "DATE",
            status: "STATUS",
            file_type: "FILE TYPE",
          },
        },
      },
    },

    organizationPage: {
      pageTitle: "Organization team",
      teamTitle: "Team members",
      noActiveOrganizationTitle: "No active organization found",
      noActiveOrganizationDescription:
        "There is no active organization subscription linked to this account. Purchase an organization plan on the dashboard or sign in with an organization owner account.",
      addMember: "Add member",
      emptyTitle: "No team members yet",
      emptyDescription:
        "Invite teammates by email and allocate images and features from your organization pool.",
      nav: { team: "Team", generations: "Generations" },
      stats: {
        plan: "Plan",
        totalPool: "Total images",
        unallocated: "Unallocated",
        activeMembers: "Active members",
        invited: "Invited",
        ends: "Subscription ends",
        furnitureFinderSection: "Furniture Finder",
        totalFurnitureFinder: "Furniture Finder pool",
        unallocatedFurnitureFinder: "FF unallocated",
      },
      statusLabels: {
        active: "Active",
        invited: "Invited",
        suspended: "Suspended",
      },
      table: {
        email: "Email",
        status: "Status",
        assigned: "Assigned",
        remaining: "Remaining",
        used: "Used",
        pending: "Pending",
        features: "Features",
        ffRemaining: "FF balance",
        ffPending: "FF pending",
      },
      actions: {
        allocate: "Allocate",
        reclaim: "Reclaim",
      },
      addMemberModal: {
        title: "Invite team member",
        subtitle: "They will receive an email invite to join the Zory dashboard.",
        email: "Email",
        emailRequired: "Email is required",
        emailInvalid: "Enter a valid email",
        emailPlaceholder: "member@example.com",
        images: "Images to allocate",
        imagesHint: "Available from pool: {max} images",
        imagesMin: "Cannot be negative",
        imagesMax: "Exceeds unallocated pool images",
        furnitureFinder: "Furniture Finder to allocate",
        furnitureFinderHint: "Available from pool: {max}",
        furnitureFinderMin: "Cannot be negative",
        furnitureFinderMax: "Exceeds unallocated Furniture Finder pool",
        features: "Allowed features",
        featuresFromPlan: "Select from your organization plan features only.",
        noPlanFeatures: "No features are enabled on your organization plan.",
        submit: "Send invite",
        sending: "Sending…",
        success: "Member added successfully",
      },
      allocateModal: {
        title: "Allocate images & features",
        subtitle: "Update allocation for",
        images: "Additional images",
        imagesHint: "Available from pool: {max}",
        furnitureFinder: "Additional Furniture Finder",
        furnitureFinderHint:
          "Available from pool: {max}. This is added to the member's current balance.",
        furnitureFinderCurrentBalance: "Current balance: {balance}",
        furnitureFinderPendingNote:
          "{pending} pending credits will be applied on save before any new allocation.",
        features: "Features",
        featuresFromPlan: "Select from your organization plan features only.",
        noPlanFeatures: "No features are enabled on your organization plan.",
        submit: "Save allocation",
        saving: "Saving…",
        success: "Member updated",
        nothingToUpdate: "Enter images, Furniture Finder, or features to update",
      },
      reclaimModal: {
        title: "Reclaim unused images",
        body: "Return unused images from {email} to the organization pool?",
        hint: "Up to {remaining} unused images will be returned (if any).",
        furnitureFinderHint:
          "Up to {remaining} unused Furniture Finder credits will be returned (if any).",
        confirm: "Reclaim",
        cancel: "Cancel",
        success: "Reclaimed {count} images to the pool",
        successWithFurnitureFinder:
          "Reclaimed {images} images and {furnitureFinder} Furniture Finder credits to the pool",
      },
      generationsPage: {
        pageTitle: "Generations",
        pageSubtitle:
          "Shows generations made on a team member's organization profile. Personal-profile generations are excluded.",
        filterMember: "Team member",
        filterFeature: "Feature",
        personal: "Personal",
        allMembers: "All members",
        allFeatures: "All features",
        emptyTitle: "No generations yet",
        emptyDescription:
          "AI outputs from active team members on their organization account will appear here. Personal generations and older untagged data are not included.",
        noImage: "No image",
        generationAlt: "Team generation",
        paginationTotal: "{from}-{to} of {total}",
        viewDetails: "View details",
      },
      generationModal: {
        input: "Input",
        output: "Output",
        outputImage: "Output image {n}",
        prompt: "Prompt",
        noImage: "No image",
        noInput: "No input image",
        inputAlt: "Input image",
        outputAlt: "Output image",
        completed: "Completed",
        generationFailed: "Generation failed",
      },
    },

    // USer page
    userPage: {
      user: "User",
      add_user: "Add User",
      select_merchant: " Select Merchant",
      merchants: "Merchants",

      dropdown_1: {
        name: "Name",
        role: "Role",
      },
      dropdown_2: {
        all: "All",
        active: "Active",
        inactive: "Inactive",
      },

      select_merchant_view_user: "Select the Merchant to view Users",
      no_user: {
        title: "No User Created Yet",
        description:
          "Start by creating users to manage your stores and products",
      },

      userTableCol: {
        user_name: "USER NAME",
        email: "EMAIL ADDRESS",
        phone_number: "PHONE NUMBER",
        status: "STATUS",
        role: "ROLE",
      },
      ad_user_modal: {
        add_user: "Add User",
        text: "Add more users to your platform",

        email: "Email",
        email_placeholder: "Enter Email",
        email_error_1: "Email is required",
        email_error_2: "Please enter a valid email",

        role: "Role",
        role_placeholder: "Select User Role",
        role_error: "User Role is required",

        update_user_role: "Update User Role",
        update_role: "Update Role",

        send_invites_btn: "Send Invites",
        send_invite_successfully: "User invite sent successfully",
        invite_send_successfully: "Invite Send Successfully",
        admin: "ADMIN",
        viewer: "VIEWER",
      },
    },

    settingPage: {
      settings: "Settings",
      profile_text: "Profile",
      menu_text: "Menu",
      setup_profile_text: "Setup your profile",
      my_details: "My Details",
      reset_password: "Reset Password",
      personal_information: "Personal Information",

      update_profile_modal: {
        update_profile: "Update your profile picture",
        resolution: "Upload image with a resolution of 128×128 px",
        remove_profile: "Remove profile picture?",
        remove_profile_description:
          "Your Profile picture will be deleted and this image will be used instead.",
        Processing: "Processing...",
      },
      remove: "Remove",

      full_name: "Full Name",
      full_name_placeholder: "Enter Full Name",
      full_name_error: "Full name is required",

      email: "Email",
      email_error_1: "Email is required",
      email_error_2: "Please enter a valid email",
      email_placeholder: "Enter your Email",

      phone_number: "Phone Number",
      phone_number_placeholder: "Enter your Phone Number",
      phone_number_error: "Phone Number is required",
      phone_number_error_2: "Only numbers and '+' are allowed",

      profile_update_successfully: "Profile updated successfully",

      reset_your_password: "Reset Your Password",

      password_requiremnts:
        "Create a strong password that is at least 8 characters long, including at least one lowercase letter,one uppercase letter, one number, and one special character. This ensures optimal security for your account.",

      current_password: "Current Password",
      current_password_placeholder: "Enter your Current Password",
      current_password_error: "Current Password is required",

      new_password: "New Password",
      new_password_placeholder: "Enter your New Password",
      new_password_error: "New Password is required",

      confirm_password: "Confirm Password",
      confirm_password_placeholder: "Enter your Confirm Password",
      confirm_password_error: "Confirm Password is required",

      passwordMatch: "Passwords do not match!",

      discard_btn: "Discard",
      change_password_btn: "Change Password",

      failed_upload_details: "Failed to update profile. Try again.",
    },

    // Campaigns page
    campaignsPage: {
      campaigns: "Campaigns",
      create_campaign: "Create Campaign",
      edit_campaign: "Edit Campaign",
      view_campaign: "View Campaign",
      view_campaign_details: "View Campaign Details",
      campaign_deleted_successfully: "Campaign deleted successfully",
      campaign_created_successfully: "Campaign created successfully",
      campaign_updated_successfully: "Campaign updated successfully",
      failed_to_fetch_campaigns: "Failed to fetch campaigns. Please try again.",
      failed_to_delete_campaign: "Failed to delete campaign. Please try again.",
      failed_to_create_campaign: "Failed to create campaign. Please try again.",
      failed_to_update_campaign: "Failed to update campaign. Please try again.",
      campaign_id_missing: "Campaign ID is missing",
      campaign_id_not_found: "Campaign ID not found. Cannot update campaign.",
      search_campaigns: "Search campaigns...",

      // Steps
      steps: {
        details: "Details",
        audience: "Audience",
        content: "Content",
        preview: "Preview",
        schedule: "Schedule",
      },

      // Details Step
      details: {
        title: "Title",
        title_placeholder: "New Products - January",
        description: "Description",
        description_placeholder: "Describe your campaign...",
        email_sender: "Sender's Email",
        email_sender_placeholder: "sender@example.com",
        email_sender_invalid: "Please enter a valid email address",
        campaign_type: "Campaign Type",
        campaign_type_placeholder: "Select campaign type",
        types: {
          promotional: "Promotional",
          seasonal: "Seasonal",
          welcome: "Welcome",
          updates: "Platform Updates",
        },
      },

      // Audience Step
      audience: {
        select_target_audience: "Select Target Audience",
        list: "List",
        types: "Types",
        search: "Search",
        type: "Type",
        country: "Country",
        selected: "selected",
        of: "of",
        available: "available",
        loading: "Loading...",
        users: "users",
        all_users: "All Users",
        returning_users: "Returning Users",
        active_users: "Active Users",
        inactive_users: "Inactive Users",
        paid_users: "Paid Users",
        unpaid_users: "Unpaid Users",
        newsletter_users: "Newsletter Users",
        custom_users: "Custom Users",
        target_audience: "Target Audience",
        previous: "Previous",
        next: "Next",
        failed_to_fetch_users: "Failed to fetch users. Please try again.",
        // Excel upload modal (Audience)
        upload_excel_sheet: "Upload Excel Sheet",
        upload_excel_description:
          "Upload an Excel file (.xls, .xlsx, .xlsm, .csv) containing your audience list. Maximum file size: 10MB",
        click_or_drag_file: "Click or drag file to this area to upload",
        supported_formats: "Support for .xls, .xlsx, .xlsm, .csv files",
        upload_file: "Upload File",
        download: "Download",
        please_select_excel_file: "Please select an Excel file to upload",
        invalid_file: "Invalid file. Please try again.",
        excel_uploaded_successfully: "Excel file uploaded successfully",
        failed_to_upload_excel: "Failed to upload Excel file",
        excel_download_started: "Download started",
        failed_to_download_excel: "Failed to download Excel file",
        table: {
          user: "User",
          country: "Country",
          status: "Status",
          last_activity: "Last Activity",
          plan: "Plan",
        },
        status: {
          active: "Active",
          inactive: "Inactive",
        },
      },

      // Content Step
      content: {
        subject_english: "Subject (English)",
        subject_english_placeholder: "Enter subject in English",
        description_english: "Description (English)",
        description_english_placeholder: "Describe your campaign...",
        subject_arabic: "Subject (Arabic)",
        subject_arabic_placeholder: "أدخل العنوان بالعربية",
        description_arabic: "Description (Arabic)",
        description_arabic_placeholder: "وصف حملتك باللغة العربية",
        template: "Email Template",
        template_default: "Standard",
        template_default_desc: "English and Arabic stacked one after the other",
        template_bilingual_split: "Side by Side",
        template_bilingual_split_desc: "Optional header image, English and Arabic side by side, optional footer image",
        header_image: "Header Image (Optional)",
        header_image_hint: "Recommended width 600px",
        footer_image: "Footer Image (Optional)",
        footer_image_hint: "Recommended width 600px",
        upload_image: "Upload Image",
        remove_image: "Remove",
        no_image: "No image",
        attach_media: "Attach Media",
        upload_your_image_here: "Upload your image here",
        image_formats: "JPG, PNG, HEIC up to 1MB",
        choose_file: "Choose file",
        remove: "Remove",
        uploading_image: "Uploading image...",
        image_uploaded_successfully: "Image uploaded successfully",
        failed_to_upload_image: "Failed to upload image",
        add_a_button: "Add a Button",
        button_label_english: "Button Label (English)",
        button_label_english_placeholder: "Enter button label",
        button_label_arabic: "Button Label (Arabic)",
        button_label_arabic_placeholder: "أدخل نص الزر بالعربية",
        button_link: "Button Link",
        button_link_placeholder: "https://example.com",
      },

      // Schedule Step
      schedule: {
        schedule_campaign: "Schedule Campaign",
        send_immediately: "Send Immediately",
        send_immediately_description:
          "Send your campaign to recipients right away",
        schedule_for_later: "Schedule for Later",
        schedule_for_later_description:
          "Choose a date and time to send your campaign automatically",
        save_for_later: "Save for Later",
        save_for_later_description:
          "Save your campaign to review or edit later",
        date: "Date",
        time: "Time",
        not_scheduled: "Not scheduled",
        please_select: "Please select",
        campaign_summary: "Campaign Summary",
        summary: {
          title: "Title:",
          audience: "Audience:",
          type: "Type:",
          schedule: "Schedule:",
          na: "N/A",
        },
      },

      // Preview Step
      preview: {
        default_greeting_english: "Hi",
        default_description_english:
          "Warm up your season with our brand-new Winter Edition collection! From stylish essentials to limited-edition favorites, these products are made to keep you cozy and inspired all winter long.",
        default_cta_english:
          "Don't miss out — explore what's new before it's gone!",
        default_greeting_arabic: "مرحبا",
      },

      // Modal buttons
      buttons: {
        cancel: "Cancel",
        back: "Back",
        next: "Next",
        create_campaign: "Create Campaign",
        update_campaign: "Update Campaign",
        confirm_campaign: "Confirm Campaign",
        edit: "Edit",
        delete: "Delete",
        view: "View",
        view_details: "View Details",
        close: "Close",
        save_for_later: "Save For Later",
        delete_campaign: "Delete Campaign",
      },

      // Confirmation Modal
      confirm: {
        title: "Confirm Campaign",
        send_immediately_message: "Campaign will be sent immediately",
        schedule_for_later_message: "Campaign will be scheduled for later",
        save_for_later_message: "Campaign will be saved for later",
      },

      // Save for Later Modal
      save_for_later_modal: {
        title: "Save or delete your campaign?",
        subtitle: "Manage your campaign progress",
      },

      // Table
      table: {
        campaign: "Campaign",
        description: "Description",
        type: "Type",
        status: "Status",
        audience: "Audience",
        scheduled_on: "Scheduled On",
        created_on: "Created On",
        actions: "Actions",
        by: "by",
      },

      // Filters
      filters: {
        all_status: "All Status",
        all_types: "All Types",
        status: {
          scheduled: "Scheduled",
          draft: "Draft",
          saved: "Saved",
          send_immediately: "Send Immediately",
          completed: "Completed",
          canceled: "Canceled",
          failed: "Failed",
        },
        types: {
          promotional: "Promotional",
          seasonal: "Seasonal",
          welcome: "Welcome",
          updates: "Updates",
        },
      },

      // View Modal
      view: {
        campaign: "Campaign",
        created_by: "Created by",
        type: "Type",
        status: "Status",
        audience: "Audience",
        created_on: "Created on",
        description: "Description",
      },

      status_logs: {
        title: "Campaign Status Logs",
        upload_summary: "Upload Summary",
        total_emails: "Total Emails:",
        successful_emails: "Successful Emails:",
        failed_emails: "Failed Emails:",
        opened_tracked: "Opened (tracked):",
        unopened: "Unopened:",
        send_status: "Send Status:",
        processed_batches: "Processed Batches:",
        recipients_who_opened: "Recipients who opened",
        download_opened: "Download list",
        email: "Email",
        open_count: "Open count",
        first_opened: "First opened",
        items: "items",
        failed_entries: "Failed Entries",
        error: "Error",
        no_error_logs: "No error logs available",
        no_data: "No data available",
        no_opened: "No recipients have opened yet",
      },

      failed_emails: {
        title: "Failed Emails",
        email: "Email",
        reason: "Reason",
        failed_at: "Failed at",
        items: "items",
        search_placeholder: "Search by email or reason",
        refresh: "Refresh",
        empty: "No failed emails",
        no_results: "No matching results",
        delete_selected: "Remove selected",
        delete_all: "Remove all",
        confirm_delete_title: "Remove selected failed emails?",
        confirm_delete_all_title: "Remove all failed emails?",
        confirm_delete_message: "{count} selected email address(es) will be removed from this campaign.",
        confirm_delete_all_message: "{count} email address(es) will be removed from this campaign.",
        confirm_delete_warning:
          "They will be removed from the recipients and skipped on any future send. This cannot be undone.",
        confirm_ok: "Yes, remove",
        deleted_success: "Removed successfully",
        delete_failed: "Failed to remove failed emails",
        fetch_failed: "Failed to fetch failed emails",
        excluded_title: "Excluded from this campaign",
      },

      // Stats
      stats: {
        total: "Total",
        scheduled: "Scheduled",
        completed: "Completed",
      },
    },

    discountsPage: {
      discounts: "Discounts",
      search_discounts: "Search by discount code",
      create_discount: "Create Discount",
      code_copied: "Code copied to clipboard",
      copy_code: "Copy Code",
      discount_id_missing: "Discount ID is missing",
      error_fetching_stats: "Error fetching discount statistics",
      error_fetching_discounts: "Error fetching discounts list",
      error_fetching_discount: "Error fetching discount details",
      error_fetching_users: "Error fetching discount users",
      error_fetching_plans: "Error fetching plans",
      discount_created_successfully: "Discount created successfully",
      discount_updated_successfully: "Discount updated successfully",
      discount_deleted_successfully: "Discount deleted successfully",
      error_creating_discount: "Error creating discount",
      error_deleting_discount: "Error deleting discount",
      read_only_action_blocked: "View only — you cannot perform this action.",
      export_success: "Export successful",
      export_error: "Failed to export discount users",
      error_code_exists:
        "Discount code already exists. Please use a different code.",
      error_code_invalid: "Invalid code",
      error_start_date_required: "Start date is required.",
      error_start_date_invalid: "Invalid start date",
      error_end_date_required: "End date is required.",
      error_end_date_invalid: "Invalid end date",
      stats: {
        active: "Active Discounts",
        expired: "Expired Discounts",
        total_redemptions: "Total Redemptions",
        revenue_impact: "Revenue Impact",
      },
      filters: {
        all_status: "All Status",
        all_plan_types: "All Plan Types",
        all_plans: "All Plans",
        status: {
          active: "Active",
          expired: "Expired",
          upcoming: "Upcoming",
        },
        plan_types: {
          starter: "Starter",
          basic: "Basic",
          pro: "Pro",
          business: "Business",
        },
        discount_types: {
          percentage: "Percentage",
          fixed: "Fixed",
        },
      },
      table: {
        discount_code: "Discount Code",
        type_value: "Type & Value",
        validity_period: "Validity Period",
        target_plans: "Target Plans",
        audience: "Audience",
        usage: "Usage",
        status: "Status",
        actions: "Actions",
      },
      buttons: {
        view: "View",
        edit: "Edit",
        delete: "Delete",
      },
      pagination: {
        previous: "Previous",
        next: "Next",
      },
      breadcrumbs: {
        discounts: "Discounts",
      },
      detail: {
        user: "User",
        date: "Date",
        plan: "Plan",
        country: "Country",
        original_amount: "Original Amount",
        paid_amount: "Paid Amount",
        discount_type: "Discount Type",
        audience: "Audience",
        validity_period: "Validity Period",
        remaining_usage: "Remaining Usage",
        plans: "Plans",
        discount_users: "Discount Users",
      },
      export: "Export",
      export_csv: "CSV File",
      modal: {
        basic_info: "Basic Info",
        audience: "Audience",
        create_discount_code: "Create Discount Code",
        edit_discount_code: "Edit Discount Code",
        discount_name_english: "Discount Name (English)",
        discount_name_arabic: "Discount Name (Arabic)",
        required_fields_note: "Fields marked with * are required",
        discount_code: "Discount Code",
        discount_type: "Discount Type",
        percentage_discount: "Percentage Discount",
        fixed_discount: "Fixed Discount",
        plan_extension: "Plan Extension",
        trial_extension: "Trial Extension",
        discount_percentage: "Discount Percentage",
        discount_amount: "Discount Amount",
        applicable_plans: "Applicable Plans",
        target_countries: "Target Countries",
        select_country: "Select Country",
        start_date_time: "Start Date/Time",
        end_date_time: "End Date/Time",
        max_uses_overall: "Max Uses Overall",
        notify_when_max_reached: "Notify When Max Uses Reached",
        enable_disable_notification: "Enable/Disable email notification",
        first_purchase_only: "First Purchase Only",
        redeem_more_than_once: "Redeem more than once",
        back: "Back",
        next: "Next",
        create: "Create",
        update: "Update",
        confirm_saving_discount: "Confirm Saving Discount",
        confirm_discount_message:
          "The discount will saved and be available for the users from the start date mentioned.",
        discard: "Discard",
        confirm: "Confirm",
        discard_discount: "Discard Discount?",
        discard_discount_message:
          "Are you sure you want to discard this discount? No changes will be saved.",
        cancel: "Cancel",
        confirm_delete_discount: "Confirm Delete Discount",
        confirm_delete_discount_message:
          "Are you sure you want to delete this discount? This action cannot be undone.",
        delete: "Delete",
        error_discount_code_invalid_chars:
          "Only letters (A-Z), numbers (0-9), underscore (_), and hyphen (-) are allowed",
        error_discount_code_min_length:
          "Discount code must be at least 3 characters",
        error_discount_code_max_length:
          "Discount code must not exceed 20 characters",
        error_discount_max_amount: "Discount amount cannot exceed 99,999 SAR",
        error_discount_exceeds_plan_price:
          "Discount amount must be less than plan price (SAR",
      },
      audience: {
        all_users: "All Users",
        returning_users: "Returning Users",
        active_users: "Active Users",
        inactive_users: "Inactive Users",
        paid_users: "Paid Users",
        unpaid_users: "Unpaid Users",
        newsletter_users: "Newsletter Users",
        contact_users: "Contact Users",
        contact_list: "Contact List",
        contact_groups: "Contact Groups",
        select_contact: "Select Contact List",
        contact: "Contact",
        failed_to_fetch_contact_users: "Failed to fetch contact users",
        failed_to_fetch_contact_groups: "Failed to fetch contact groups",
        total_contact_users: "Total Contact Users",
        select_target_audience: "Select Target Audience",
        list: "List",
        types: "Types",
        search: "Search",
        type: "Type",
        country: "Country",
        selected: "selected",
        of: "of",
        available: "available",
        previous: "Previous",
        next: "Next",
        users: "users",
        loading: "Loading...",
        failed_to_fetch_users: "Failed to fetch users",
        status: {
          active: "Active",
          inactive: "Inactive",
        },
        table: {
          user: "User",
          country: "Country",
          status: "Status",
          last_activity: "Last Activity",
          plan: "Plan",
          name: "Name",
          email: "Email",
          description: "Description",
        },
      },
    },

    announcementsPage: {
      title: "Announcements",
      search_placeholder: "Search announcements",
      create_button: "Create Announcement",
      english_label: "English Text",
      arabic_label: "Arabic Text",
      success_create: "Announcement created successfully",
      validation: {
        english_required: "English text is required",
        arabic_required: "Arabic text is required",
      },
      table: {
        english_text: "English Text",
        arabic_text: "Arabic Text",
        created_at: "Created At",
        actions: "Actions",
      },
      modal: {
        title: "Create Announcement",
        english_placeholder: "Enter the announcement in English",
        arabic_placeholder: "Enter the announcement in Arabic",
        cancel: "Cancel",
        submit: "Create",
      },
      delete: {
        confirm_title: "Delete announcement?",
        confirm_message: "Are you sure you want to delete this announcement?",
        confirm_ok: "Delete",
        confirm_cancel: "Cancel",
        success: "Announcement deleted",
        error: "Unable to delete announcement",
      },
    },

    librayPage: {
      library: "Library",
      upload_images: "Upload Images",
      image_deleted_successfully: "Image deleted successfully",
      api_returned_unsuccessful_response:
        " API returned an unsuccessful response",
      failed_to_delete_image: "Failed to delete image",
      read_only_cannot_delete:
        "View only — you cannot delete images from the library.",
      read_only_cannot_upload:
        "View only — you cannot add images to the library.",

      no_more_images_title: "No Images Found",
      no_more_images_description:
        "It seems there are no images matching your filters. Try adjusting your selection or upload new images.",

      room_types_title: "Room Type",
      decor_style_title: "Decor Style",
      theme_title: "Theme",
      decor_style: {
        all: "All",
        islamic: "Islamic",
        minimalist: "Minimalist",
        tropical: "Tropical",
        modern: "Modern",
        contemporary: "Contemporary",
        classy: "Classy",
        boho: "Boho",
        modern_classic: "Modern Classic",
        industrial: "Industrial",
        rustic_modern: "Rustic Modern",
        eclectic: "Eclectic",
        zen: "Zen",
        shabby_chic: "Shabby Chic",
        elegant: "Elegant",
      },
      room_types: {
        all: "All",
        library: "Library",
        gym: "Gym",
        restaurant: "Restaurants",
        kitchen: "Kitchen",
        bathroom: "Bathroom",
        dining: "Dining",
        bedroom: "Bedroom",
        entrance: "Entrance",
        garden: "Garden",
        living_room: "Living Room",
        kids_room: "Kids Room",
        gaming_room: "Gaming Room",
        office: "Office",
      },
      theme: {
        all: "All",
        dark: "Dark",
        light: "Light",
        moroccan: "Moroccan",
      },
    },
    contactsPage: {
      contacts: "Contacts",
      search_contacts: "Search by name",
      create_contact_list: "Create Contact Group",
      create_contact_group: "Create Contact Group",
      edit_contact_list: "Edit Contact List",
      add_contact: "Add Contact",
      edit_contact: "Edit Contact",
      contact_list_id_missing: "Contact list ID is missing",
      contact_list_created_successfully: "Contact list created successfully",
      contact_list_updated_successfully: "Contact list updated successfully",
      contact_list_deleted_successfully: "Contact list deleted successfully",
      contact_added_successfully: "Contact added successfully",
      contact_updated_successfully: "Contact updated successfully",
      contact_deleted_successfully: "Contact deleted successfully",
      error_fetching_contacts: "Error fetching contacts",
      error_fetching_contact_list: "Error fetching contact list details",
      error_creating_contact_list: "Error creating contact list",
      error_updating_contact_list: "Error updating contact list",
      error_deleting_contact_list: "Error deleting contact list",
      error_saving_contact: "Error saving contact",
      error_deleting_contact: "Error deleting contact",
      error_uploading_excel: "Error uploading Excel file",
      excel_file_not_found: "Excel file not found",
      excel_file_required: "Please upload an Excel file",
      excel_updated_successfully: "Excel file updated successfully",
      excel_deleted_successfully: "Excel file deleted successfully",
      excel_download_started: "Download started",
      failed_to_download_excel: "Failed to download Excel file",
      failed_to_update_excel: "Failed to update Excel file",
      failed_to_delete_excel: "Failed to delete Excel file",
      excel_file_management: "Excel File Management",
      update_excel_file: "Update Excel File",
      excel_file_name: "Excel File Name",
      excel_file_path: "Excel File Path",
      no_excel_file: "No Excel file",
      no_excel_file_uploaded: "No Excel file uploaded",
      existing_excel_file: "Existing Excel File",
      confirm_delete_excel: "Confirm Delete Excel File",
      confirm_delete_excel_message:
        "Are you sure you want to delete this Excel file? This action cannot be undone.",
      confirm_delete_contact: "Confirm Delete Contact",
      confirm_delete_contact_message:
        "Are you sure you want to delete this contact? This action cannot be undone.",
      breadcrumbs: {
        contacts: "Contacts",
      },
      table: {
        name: "Name",
        description: "Description",
        contacts_count: "Contacts Count",
        actions: "Actions",
      },
      detail: {
        name: "Name",
        email: "Email",
        actions: "Actions",
        contacts: "Contacts",
        total_contacts: "Total Contacts",
        excel_file: "Excel File",
      },
      form: {
        name: "Name",
        name_required: "Name is required",
        name_placeholder: "Enter contact group name",
        contact_name_placeholder: "Enter contact name",
        description: "Description",
        description_placeholder: "Enter description",
        email: "Email",
        email_required: "Email is required",
        email_invalid: "Invalid email format",
        email_placeholder: "Enter email",
        upload_excel: "Upload Excel File",
        excel_file_required: "Excel file is required",
        excel_file_type_error: "Only Excel files (.xls, .xlsx) are allowed",
        excel_file_size_error: "File size must be less than 10MB",
        excel_uploaded_successfully: "Excel file uploaded successfully",
        excel_uploaded: "Excel file uploaded",
        uploading: "Uploading...",
        click_to_upload: "Click to upload Excel file",
      },
      buttons: {
        view: "View",
        edit: "Edit",
        delete: "Delete",
        download: "Download",
        update: "Update",
        create: "Create",
      },
      modal: {
        cancel: "Cancel",
        add: "Add",
        create: "Create",
        update: "Update",
        delete: "Delete",
        confirm_delete_contact_list: "Confirm Delete Contact Group",
        confirm_delete_contact_list_message:
          "Are you sure you want to delete this contact group? This action cannot be undone.",
      },
      pagination: {
        previous: "Previous",
        next: "Next",
      },
    },

    planUsagePage: {
      title: "Plan Usage Statistics",
      subtitle: "Average usage per subscriber by plan type",
      export: "Export",
      total_subscribers: "Total Subscribers",
      across_all_plans: "Across all plans",
      avg_images: "Avg. Images Generated",
      avg_finder: "Avg. Finder Usage",
      per_subscriber: "Per subscriber",
      per_subscriber_lower: "per subscriber",
      overall_usage: "Overall Plan Usage",
      of_included: "Of included allowance",
      average_by_plan: "Average Usage by Plan",
      plan: "Plan",
      subscribers: "Subscribers",
      images: "Images",
      furniture_finder: "Furniture Finder",
      avg_images_generated: "Avg. Images Generated",
      images_included: "Images Included",
      usage_percent: "Usage %",
      avg_finder_usage: "Avg. Finder Usage",
      finder_included: "Finder Included",
      overall_plan_usage: "Overall Plan Usage %",
      overall_tooltip:
        "The average of the Images and Furniture Finder usage percentages. Both allowances count equally, whatever their size.",
      chart_images: "Average Images Generated per Subscriber",
      chart_finder: "Average Furniture Finder Usage per Subscriber",
      total_images_generated: "Total Images Generated",
      total_finder_usage: "Total Finder Usage",
      all_subscribers_lower: "all subscribers",
      chart_total_images: "Total Images Generated per Plan",
      chart_total_finder: "Total Furniture Finder Usage per Plan",
      amount_spent: "Amount Spent",
      amount_spent_tooltip:
        "Total paid for this plan in the period. Counts every payment, so a subscriber who renewed or upgraded contributes more than once.",
      chart_amount_spent: "Amount Spent per Plan",
      in_period: "in the selected period",
      plan_distribution: "Plan Distribution",
      subscriber_singular: "subscriber",
      subscribers_lower: "subscribers",
      low_sample_tooltip:
        "Averaged over only {count} subscriber(s) — this reflects individual behaviour, not the plan.",
      low_sample_note:
        "Greyed bars are averaged over fewer than {count} subscribers, so they reflect individual behaviour rather than the plan.",
      no_data: "No plan usage for this period.",
      error_fetching: "Could not load plan usage statistics.",
      error_export: "Could not export the CSV.",
      usage_statistics: "Usage Statistics",
      tab_plans: "Plan Usage",
      tab_tools: "Generation by Tool",
    },

    toolUsagePage: {
      title: "Subscriber Generation",
      subtitle: "How subscribers are using Zory's generative tools",
      export: "Export",
      total_generations: "Total Generations",
      total_generations_inline: "Total Generations",
      across_all_tools: "Across all tools",
      most_used_tool: "Most Used Tool",
      generations_lower: "generations",
      no_data_caption: "No generations yet",
      share_of_top_tool: "Share of Top Tool",
      of_all_generations: "Of all generations",
      active_subscribers: "Active Subscribers",
      per_subscriber_lower: "per subscriber",
      subscribers: "Subscribers",
      segment_all: "All",
      segment_paid: "Paid subscribers",
      segment_trial: "Free / trial users",
      plan: "Plan",
      all_plans: "All Plans",
      plan_implies_paid: "A plan filter covers that plan's paid subscribers.",
      generations_by_tool: "Generations by Tool",
      panel_subtitle:
        "Percentage shows each tool's share of total generations.",
      tool: "Tool",
      relative_use: "Relative Use",
      relative_tooltip:
        "Each bar is sized against the most-used tool, so the leader fills the track.",
      generations: "Generations",
      percent_of_total: "% of Total",
      share_of_total: "Share of Total Generations",
      share_tooltip: "The same percentage drawn against a full 100% track.",
      footnote:
        "Metrics count successful generations across the selected subscribers.",
      no_data: "No generations for this period.",
      error_fetching: "Could not load tool usage statistics.",
      error_export: "Could not export the CSV.",
    },

    plansPricingPage: {
      title: "Pricing & Plans",
      create_plan: "Create Plan",
      search_plans: "Search plans...",
      view_list: "List",
      view_grid: "Grid",
      off_label: "OFF",
      no_plans: "No plans match your filters.",
      read_only_action_blocked: "View only — you cannot perform this action.",
      error_fetching_plans: "Error fetching plans. Please try again.",
      error_duplicating_plan: "Error duplicating plan.",
      error_disabling_plan: "Error disabling plan.",
      error_enabling_plan: "Error enabling plan.",
      error_deleting_plan: "Error deleting plan.",
      error_saving_plan: "Error saving plan.",
      error_fetching_plan: "Error fetching plan.",
      delete_confirm_title: "Delete plan?",
      delete_confirm_message:
        "Are you sure you want to delete this plan? This cannot be undone.",
      delete_cancel: "Cancel",
      filters: {
        all_status: "All Status",
        all_types: "All Types",
        all_categories: "All Categories",
        status: {
          active: "Active",
          inactive: "Inactive",
          draft: "Draft",
        },
        types: {
          one_time: "One-Time",
          subscription: "Subscription",
        },
        categories: {
          standard: "Standard",
          organization: "Organization",
        },
      },
      table: {
        plan: "Plan",
        type: "Type",
        category: "Category",
        price: "Price",
        images: "Images",
        subscribers: "Subscribers",
        status: "Status",
        last_updated: "Last Updated",
        actions: "Actions",
      },
      actions: {
        edit: "Edit Plan",
        duplicate: "Duplicate",
        disable: "Disable",
        enable: "Enable",
        delete: "Delete",
      },
      pagination: {
        show_total: "{start}-{end} of {total}",
      },
      grid: {
        images_included_template: "{count} Images Included",
        most_popular: "Most Popular",
        optional_addon: "Optional Add-On",
        per_photo: "per photo",
        one_time_note: "Valid for one time, No renewal",
        yearly_promo_template: "Just SAR {amount} with yearly billing",
      },
      createPlan: {
        breadcrumb: "Create Plan",
        edit_breadcrumb: "Edit Plan",
        page_title: "Create New Plan",
        edit_page_title: "Edit Plan",
        page_subtitle:
          "Set up plan details, features, and preview before publishing.",
        cancel: "Cancel",
        save_draft: "Save Draft",
        confirm_plan: "Confirm Plan",
        update_plan: "Update Plan",
        billing_monthly: "/month",
        billing_yearly: "/year",
        plan_name_required: "Plan name is required.",
        price_required: "Price is required.",
        plan_name_arabic_required: "Arabic plan name is required.",
        description_required: "Short description is required.",
        description_arabic_required: "Arabic short description is required.",
        features_bilingual_required:
          "Each feature requires both an English and an Arabic description.",
        plan_updated: "Plan updated successfully.",
        draft_saved: "Draft saved successfully.",
        plan_confirmed: "Plan created successfully.",
        draft_status_mismatch:
          "Plan was saved, but status may not be Draft. Check the plans list.",
        basic_info: "Basic Information",
        plan_name: "Plan Name",
        plan_name_placeholder: "e.g., Professional Plan",
        plan_name_arabic: "Plan Name (Arabic)",
        plan_name_arabic_placeholder: "مثال: باقة احترافية",
        short_description: "Short Description",
        short_description_placeholder: "Brief description of this plan",
        short_description_arabic: "Short Description (Arabic)",
        short_description_arabic_placeholder: "وصف موجز لهذه الخطة",
        max_chars: "Maximum",
        characters: "characters",
        category: "Category",
        plan_type: "Plan type",
        type_subscription: "Subscription",
        type_one_time: "One-Time",
        billing_cycle: "Billing Cycle",
        billing_monthly_option: "Monthly",
        billing_yearly_option: "Yearly",
        price: "Price",
        images: "Images",
        furniture_finder: "Furniture Finder",
        features: "Features",
        tab_feature_access: "Feature Access",
        tab_furniture_tools: "Furniture Tools",
        tab_ai_image_tools: "AI Design Tools",
        tab_room_planner: "Room Planner",
        tab_advanced_spaces: "Advanced Spaces",
        tab_upcoming_features: "Upcoming Features",
        no_features: "No features in this category yet.",
        feature_description: "Feature description",
        feature_placeholder: "Enter feature description",
        feature_description_arabic: "Feature description (Arabic)",
        feature_placeholder_arabic: "Enter feature description in Arabic",
        add_feature: "Add Feature",
        allowed_features: "Allowed Features",
        allowed_features_desc: "Select which features are available on this plan.",
        no_allowed_features: "No features available.",
        per_generation_features: "Per generation",
        included_use_features: "Included use",
        images_per_generation: "Images per generation",
        plan_settings: "Plans Settings",
        active_status: "Active Status",
        active_status_desc: "Make this plan available to users",
        preview_plan_name: "Plan Name",
        preview_plan_desc_placeholder: "Plan description",
        live_preview: "Live Preview",
        user_facing_view: "User facing view",
        preview_images: "Images",
        preview_no_subscriptions: "No monthly subscriptions",
        preview_notes_title: "Preview Notes",
        preview_notes_line1: "This is a preview of what users will see.",
        preview_notes_line2: "Changes update in real-time",
        modals: {
          confirm_title: "Confirm Plan",
          confirm_message: "Are you sure you want to publish this plan?",
          confirm_button: "Confirm Plan",
          draft_title: "Save as draft",
          draft_message: "Save this plan as a draft?",
          draft_button: "Save Draft",
          cancel_title: "Cancel Plan",
          cancel_message:
            "Are you sure you want to cancel? Unsaved changes will be lost.",
          cancel_button: "Cancel Plan",
        },
      },
    },
  },
}
